function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import ClipPlayer from "./clip-player";
import { EditModeModal, SmartResizeModal } from "./edit-mode";
import { BULK_ACTIONS } from "./agent-run";
import { TrimModal, ClipsModal, VideoEditModal, VideoResizeModal } from "./video-edit";
import { TemplateSheet, videoRefFor } from "./templates";
import { ShippedList, isLive, targetName } from "./shipped";
import { CreateMediaSheet } from "./create-media";
import { SequencesList } from "./sequence-outputs";
import { DeleteSheet, TrashList } from "./trash";
import { authHeaders as shareAuthHeaders } from "../reports/common";
import { autopilotSvc } from "../campaigns/autopilot-common";
import { loadBrandKit } from "../../functions/brand-kit";
import { INPUT, CARD } from "../../components/form-styles";
import { getOnboardingStatus } from "../../functions/onboarding-status";
import { headers as bearerHeaders } from "../../endpoints/market-intelligence";
import endpoints from "../../endpoints";
import { withRouter } from "react-router";
import { Container, CssContainer } from "../../components/container";
import { PageHeader, Ribbon, Card, Empty } from "../../components/analytics-kit";
import { Loader } from "../../components/loaders";
import Error from "../../components/error";
import Auth from "../../functions/authenticate";
import ServiceFactory from "../../service";
import account from "../../data/account";
const getAccount = () => {
  try {
    return account.get();
  } catch (e) {
    return null;
  }
};
import { getBillingStatus } from "../../functions/billing-status";
import RangePicker from "../../components/range-picker";
import { RANGES, num, usd, isCustomRange, parseCustomRange, rangeLabelFor } from "../sales/territory-common";
import { getGlobalRange, subscribePeriod, unsubscribePeriod } from "../../functions/period-store";
import { rangeDates } from "../../components/tenant-modules";
import { FunnelStrip, TrendChart, Swimlanes, ChannelLegs, rankRows, defaultMetric } from "./analytics";
import { CONNECT_GROUPS, connectionStatus } from "../../components/provider-connections";
import { VoicePicker } from "./voices";
import { AssetPicker } from "./sequence-create";
import { BrandLibraryPane, damAvailable, damSaveFromContent } from "./brand-library";
import { isBroken, markBroken } from "./broken-images";
import { tagsApi, tagMatches, tagDot, plural, TagChip, TagPicker, BulkTagPanel, ManageTagsSheet, UNTAGGED, toast } from "./tags";
import MyWork from "./mywork";

/*
 * Content Hub — the container spine (CONTENT_HUB.md §4; mockup
 * content-hub.html). Marketing group, feature-gated `contentHub`.
 * P0 UX scope: Library + container detail (Content / Where it lives /
 * Performance) + the Recommendations queue. Brand-level Visibility stays
 * on the existing Keyword Intelligence AI surface for now.
 *
 * Endpoints (ContentController, probed live 2026-08-11):
 *   GET  /v1/content/containers/{range}?$top=          library rows + range funnel numbers
 *   GET  /v1/content/containers/detail/{id}            {container, blocks, variants, publications, links}
 *   GET  /v1/content/containers/detail/{id}/funnel/{range}
 *   POST /v1/content/containers/{id}/repurpose {channels:[…]}   queued, drafts land async
 *   GET  /v1/content/recommendations                   ranked queue
 *   POST /v1/content/recommendations/{id}/accept | /dismiss
 *
 * Container/variant ids exceed 2^53 — JSONbig opaques; String(id) only.
 * Money rule: salesValue/conversionValue are the tenant's OWN sales —
 * always visible (ad spend/cost never appears here).
 */

// §220 cosmetics: commerce recs carry CSV-mangled product titles
// ('"""81""" Flared Arm Skirted Sofa') until the feed-transform root fix
// lands — display-strip: collapse quote runs, drop a leading stray quote.
function cleanTitle(t) {
  let x = String(t || "").replace(/"{2,}/g, '"').trim();
  // A quoted name keeps both quotes; a lone leading quote (no closing one) is dropped.
  if (x.startsWith('"') && x.indexOf('"', 1) === -1) x = x.replace(/^"\s*/, "");else if (!x.startsWith('"') && /^[^"]+"\s/.test(x)) x = '"' + x;
  return x.replace(/only 0 characters of description/i, "no description").replace(/\((\d[\d,.]*) revenue, (\d+)d\)/i, (m, v, d) => `($${Number(String(v).replace(/,/g, "")).toLocaleString()} in the last ${d} days)`).replace(/top seller — no linked content/i, "top seller with no content about it");
}
function svc(api) {
  const Service = ServiceFactory.getType(api, "product"); // /v1 root
  return new Service();
}
async function safe(promise, fallback) {
  try {
    return (await promise) || fallback;
  } catch (e) {
    return fallback;
  }
}
// Assets › Select › "Edit them together": plain names for the bulk edits (agent-run.js BULK_ACTIONS keys).
const BULK_LABELS = {
  remove_background: "Remove the background",
  packshot: "Put on a white background",
  brand_background: "Put on your brand color",
  overlay_logo: "Add your logo",
  badge: "Add a sale badge"
};
// Video assets whose poster was already tried this session (Assets grid makes missing posters from the first frame).
const POSTER_TRIED = new Set();
/** First frame (~0.5 s) of a video as a JPEG blob. Needs CORS on the file host; rejects on any failure or after 20 s. */
function grabFirstFrame(url) {
  return new Promise((resolve, reject) => {
    const v = document.createElement("video");
    let done = false;
    const finish = (err, blob) => {
      if (done) return;
      done = true;
      clearTimeout(timer);
      try {
        v.removeAttribute("src");
        v.load();
      } catch (e) {/* ignore */}
      if (err) reject(err);else resolve(blob);
    };
    const timer = setTimeout(() => finish(new Error("timeout")), 20000);
    v.crossOrigin = "anonymous";
    v.preload = "metadata";
    v.muted = true;
    v.playsInline = true;
    v.onloadedmetadata = () => {
      try {
        v.currentTime = Math.min(0.5, (Number(v.duration) || 1) / 2);
      } catch (e) {
        finish(e);
      }
    };
    v.onseeked = () => {
      try {
        const w = v.videoWidth,
          h = v.videoHeight;
        if (!w || !h) {
          finish(new Error("no frame"));
          return;
        }
        const k = Math.min(1, 960 / w);
        const c = document.createElement("canvas");
        c.width = Math.round(w * k);
        c.height = Math.round(h * k);
        c.getContext("2d").drawImage(v, 0, 0, c.width, c.height);
        c.toBlob(b => b ? finish(null, b) : finish(new Error("no blob")), "image/jpeg", 0.82);
      } catch (e) {
        finish(e);
      } // a tainted canvas (no CORS) lands here
    };
    v.onerror = () => finish(new Error("video error"));
    v.src = url;
  });
}
const CLASS_LABELS = {
  site_hygiene: ["Site hygiene", "var(--plk-warning-text)", "var(--plk-warning-soft)"],
  content_gap: ["Content gap", "var(--plk-info-text)", "var(--plk-info-soft)"],
  commerce: ["Commerce", "var(--plk-success-text)", "var(--plk-success-soft)"],
  refresh: ["Refresh", "var(--plk-accent)", "var(--plk-accent-soft)"],
  coverage: ["Coverage", "var(--plk-info-text)", "var(--plk-info-soft)"]
};
const CLASS_ICON = {
  site_hygiene: "health_and_safety",
  content_gap: "extension",
  commerce: "storefront",
  refresh: "autorenew",
  coverage: "grid_view"
};
// Lifecycle stages a piece can be tagged for (content_link link_type='stage'); the stage-gap recommendations read these.
const ORIGIN_LABEL = {
  web_import: "Web page",
  campaign_import: "Campaign",
  import: "Import",
  autopilot: "Autopilot",
  web_page: "Web page",
  website: "Web page",
  social_import: "Social post",
  email: "Email",
  email_import: "Email",
  automation: "Email journey",
  ad: "Ad",
  ad_creative: "Ad",
  manual: "Piece",
  brief: "Draft",
  mailchimp: "Mailchimp email",
  constant_contact: "Constant Contact email"
};
/** Pictures kept inside imported ad text (JSON rows with ImageUrls): surfaced as the piece's media. */
function adImagesFrom(d) {
  const out = [];
  (d && d.blocks || []).forEach(b => {
    const t = String(b && b.body || "").trim();
    if (!(t.startsWith("{") || t.startsWith("["))) return;
    let j = null;
    try {
      j = JSON.parse(t);
    } catch (e) {
      return;
    }
    (Array.isArray(j) ? j : [j]).forEach(a => {
      (a && a.ImageUrls || []).forEach(u => {
        if (u && /^https?:\/\//i.test(u) && out.indexOf(u) === -1) out.push(u);
      });
    });
  });
  return out;
}
function fmtDay(d) {
  const t = new Date(d);
  return isNaN(t) || t.getFullYear() < 1971 ? "" : t.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: t.getFullYear() === new Date().getFullYear() ? undefined : "numeric"
  });
}
const STAGES = [["audience", "Audience"], ["lead", "Lead"], ["prospect", "Prospect"], ["customer", "Customer"]];
const STAGE_PLURAL = {
  audience: "your audience",
  lead: "leads",
  prospect: "prospects",
  customer: "customers"
};
// Plain names for the scanner rules behind site-hygiene recommendations (axe ids for ADA, crawler checks for SEO).
const RULE_NAMES = {
  "document-title": "pages without a page title",
  "color-contrast": "text with too little contrast",
  "image-alt": "images without alt text",
  "link-name": "links without readable text",
  "button-name": "buttons without a name",
  "label": "form fields without labels",
  "html-has-lang": "pages without a language set",
  "html-lang-valid": "pages with an invalid language",
  "heading-order": "headings out of order",
  "list": "lists built incorrectly",
  "listitem": "list items outside a list",
  "frame-title": "frames without a title",
  "aria-hidden-focus": "hidden elements that still take focus",
  "meta-viewport": "pages that block zooming",
  "duplicate-id": "duplicate element ids",
  "select-name": "dropdowns without labels",
  "input-image-alt": "image buttons without alt text",
  "no_title": "pages without a title",
  "duplicate_title": "pages with duplicate titles",
  "no_description": "pages without a meta description",
  "duplicate_description": "duplicate meta descriptions",
  "no_h1_tag": "pages without an H1 heading",
  "no_image_alt": "images without alt text",
  "is_broken": "broken pages",
  "is_4xx_code": "pages returning 4xx errors",
  "is_5xx_code": "pages returning 5xx errors",
  "broken_links": "broken outbound links",
  "broken_resources": "broken page resources",
  "no_canonical": "pages without a canonical link",
  "title_too_long": "titles that are too long"
};
// Recommendations tab (redesign 2026-10-09): impact thresholds on the rec score, plain groups, plain rule copy.
const REC_IMPACT_HIGH = 60; // score >= 60 → High
const REC_IMPACT_MEDIUM = 40; // 40-59 → Medium; below 40 → Low
function recImpact(score) {
  const n = Number(score) || 0;
  return n >= REC_IMPACT_HIGH ? ["high", "High"] : n >= REC_IMPACT_MEDIUM ? ["medium", "Medium"] : ["low", "Low"];
}
const REC_GROUPS = [["fix", "Fix on your site", "Quick fixes that help everyone who visits"], ["slipping", "Slipping", "Pieces that are getting fewer visits than before"], ["gaps", "Gaps to fill", "Things people buy or look for that you have no content about"], ["products", "Product pages to fill out", "Products people look at that have very little written about them"], ["spread", "Worth sharing more", "Doing well on one channel. Try it on more."]];
/** Which plain group a rec class belongs to; unknown classes keep their own name. */
function recGroup(r) {
  const c = String(r && r.class || "").toLowerCase();
  if (c === "site_hygiene" || /hygiene|access|ada|seo/.test(c)) return "fix";
  if (c === "refresh" || /decay|fad/.test(c)) return "slipping";
  if (c === "coverage" || c === "content_gap" || /gap|coverage/.test(c)) return "gaps";
  if (c === "commerce") return "products";
  if (c === "winner_amp") return "spread";
  return c || "other";
}
/** "lost a third of its visits": plain fractions near 25/33/50/67/75%, else the rounded percent. */
function recShare(pct) {
  const bands = [[25, "a quarter"], [100 / 3, "a third"], [50, "half"], [200 / 3, "two thirds"], [75, "three quarters"]];
  const b = bands.find(([v]) => Math.abs(pct - v) <= 2);
  return b ? b[1] : `${Math.round(pct)}%`;
}
// Scanner rule → [what the places have, why it matters]; rules not listed read from RULE_NAMES.
const REC_RULE_PLAIN = {
  "color-contrast": ["have text that is hard to read", "Text with too little contrast. Fixing it helps people with low vision and helps search."],
  "image-alt": ["have pictures with no description", "Images without alt text. Screen readers and search engines cannot tell what they show."],
  "input-image-alt": ["have picture buttons with no description", "Screen readers cannot say what these buttons do."],
  "link-name": ["have links with no readable text", "Screen readers cannot say where these links go."],
  "button-name": ["have buttons with no name", "Screen readers cannot say what these buttons do."],
  "label": ["have form fields with no label", "People using screen readers cannot tell what to type."],
  "select-name": ["have dropdowns with no label", "People using screen readers cannot tell what to choose."],
  "document-title": ["have no page title", "The title shows in browser tabs and in search results."],
  "no_title": ["have no page title", "The title shows in browser tabs and in search results."],
  "html-has-lang": ["do not say what language they are in", "Screen readers need it to pronounce words correctly."],
  "heading-order": ["have headings out of order", "A clear heading order helps screen readers and search."],
  "meta-viewport": ["stop people from zooming in", "People with low vision need to zoom to read."],
  "no_description": ["have no search summary", "Search engines show this short summary under your link."],
  "duplicate_title": ["share a title with another page", "Search engines struggle to tell these pages apart."],
  "duplicate_description": ["share a search summary with another page", "Search engines struggle to tell these pages apart."],
  "no_h1_tag": ["have no main heading", "A main heading tells visitors and search engines what the page is about."],
  "no_image_alt": ["have pictures with no description", "Search engines and screen readers cannot tell what they show."],
  "is_broken": ["are broken", "Visitors who land on them see an error."],
  "is_4xx_code": ["show a page-not-found error", "Visitors who land on them see an error."],
  "is_5xx_code": ["show a server error", "Visitors who land on them see an error."],
  "broken_links": ["link to pages that no longer work", "Broken links frustrate visitors and hurt search."],
  "title_too_long": ["have titles that get cut off in search", "Shorter titles show in full in search results."]
};
// Lifecycle stage → [who, in plain words; the why line].
const REC_STAGE_PLAIN = {
  audience: ["new audiences", "people who are just finding you"],
  lead: ["leads", "people who have shown interest"],
  prospect: ["prospects", "people getting close to buying"],
  customer: ["customers", "people who have already bought"]
};
/** What a recommendation is about, from its source_ref: hyg:<ada|seo>:<rule> or cov:stage_gap:<stage>. */
function recRef(r) {
  const ref = String(r && (r.sourceRef || r.source_ref) || "");
  const h = ref.match(/^hyg:([^:]+):(.+)$/i);
  if (h) {
    const m = String(r.title || "").match(/Fix\s+(\d+)\s+(\w+)\s+/i);
    return {
      type: "hygiene",
      kind: h[1].toLowerCase(),
      rule: h[2],
      count: m ? Number(m[1]) : null,
      severity: m ? m[2].toLowerCase() : ""
    };
  }
  const g = ref.match(/^cov:stage_gap:(.+)$/i);
  if (g) return {
    type: "stage",
    stage: g[1].toLowerCase()
  };
  return {
    type: ""
  };
}
function recTitle(r) {
  const x = recRef(r);
  if (x.type === "hygiene") {
    const name = RULE_NAMES[x.rule] || String(x.rule).replace(/[-_]/g, " ");
    return `${x.count != null ? x.count + " " : ""}${x.kind === "ada" ? "accessibility" : "SEO"} issue${x.count === 1 ? "" : "s"}: ${name}`;
  }
  if (x.type === "stage") return `No content speaks to ${STAGE_PLURAL[x.stage] || x.stage} yet`;
  return null;
}
const STATUS_COLORS = {
  active: "var(--plk-success-text)",
  draft: "var(--plk-text-muted)",
  archived: "var(--plk-text-subtle)",
  published: "var(--plk-success-text)",
  approved: "var(--plk-info-text)",
  retired: "var(--plk-text-subtle)"
};
// §5.5 coverage anti-join kinds → the tenant-neutral gap label.
const COVERAGE_LABELS = {
  product_gap: "Product",
  topic_gap: "Topic",
  stage_gap: "Lifecycle"
};
// Channel → friendly label. Ad channels are TYPE-based (ad_display etc.) per
// the campaign-type standard — show Display/Retarget/Social/YouTube/CTV/OTT,
// never the provider ("Ads Google").
const CHANNEL_LABELS = {
  ad_display: "Display",
  ad_retargeting: "Retarget",
  ad_retarget: "Retarget",
  ad_search: "Search",
  ad_youtube: "YouTube",
  ad_ctv: "CTV/OTT",
  ad_social: "Social",
  ad_social_video: "Social video",
  email: "Email",
  web: "Website",
  website: "Website",
  landing: "Landing page",
  blog: "Blog",
  product_copy: "Product copy",
  social_facebook: "Facebook",
  social_instagram: "Instagram",
  social_pinterest: "Pinterest",
  gbp_post: "Google Business"
};
function channelTypeLabel(ch, fallbackTarget) {
  const k = String(ch || "").toLowerCase();
  if (CHANNEL_LABELS[k]) return CHANNEL_LABELS[k];
  if (k.startsWith("ad_")) return k.slice(3).replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
  const t = String(fallbackTarget || "").toLowerCase();
  if (t.startsWith("ads_")) return "Ads";
  return String(fallbackTarget || ch || "—").replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
}
// §4.6 swimlane overlay palette — up to 3 campaign lanes overlaid on the
// portfolio trend line, distinct from the accent (the portfolio's own color).
const OVERLAY_PALETTE = ["#378add", "#1d9e75", "#8b5cf6"];
// Shared 34px control height so toolbar buttons line up with inputs/primary buttons.
const TOGGLE_34 = {
  height: "34px",
  marginTop: 0,
  boxSizing: "border-box",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center"
};
function originIcon(o) {
  const k = String(o || "").toLowerCase();
  if (/web/.test(k)) return "language";
  if (/campaign|ad/.test(k)) return "campaign";
  if (/autopilot|recommend/.test(k)) return "auto_awesome";
  if (/manual/.test(k)) return "edit_note";
  if (/email|mailchimp|klaviyo/.test(k)) return "mail_outline";
  if (/shopify|store/.test(k)) return "storefront";
  return "description";
}
function pieceIcon(c) {
  const k = String(c && (c.channel || c.kind || c.type) || "").toLowerCase();
  if (/email/.test(k)) return "mail_outline";
  if (/video|youtube|tv|ctv/.test(k)) return "movie";
  if (/social|instagram|facebook|pinterest|linkedin|tiktok/.test(k)) return "share";
  if (/blog|article|landing|page/.test(k)) return "article";
  if (/ad|campaign/.test(k)) return "campaign";
  if (/product/.test(k)) return "inventory_2";
  return "description";
}
/** The story's media bundle: every image / clip linked to any piece in the story (GET stories/{id}/assets). */
class StoryMedia extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      items: undefined
    });
  }
  componentDidMount() {
    this._alive = true;
    this.load();
  }
  componentDidUpdate(p) {
    if (p.storyId !== this.props.storyId) this.load();
  }
  componentWillUnmount() {
    this._alive = false;
  }
  async load() {
    try {
      const r = await svc(`/content/stories/${this.props.storyId}/assets?$top=12`).getAsync();
      if (this._alive) this.setState({
        items: r && r.items || []
      });
    } catch (e) {
      if (this._alive) this.setState({
        items: []
      });
    }
  }
  render() {
    const {
      items
    } = this.state;
    if (this.props.compact) {
      const m = (items || []).filter(a => a && (a.url || a.posterUrl));
      return /*#__PURE__*/React.createElement("div", {
        className: "hub-lib-thumbs",
        title: m.length ? `${m.length} media in this story` : "No media yet"
      }, m.length ? m.slice(0, 4).map(a => /*#__PURE__*/React.createElement("span", {
        key: String(a.id),
        className: "t" + (a.kind === "video" ? " video" : ""),
        onClick: e => {
          e.stopPropagation();
          if (this.props.onOpen) this.props.onOpen(a);
        }
      }, (a.kind === "video" ? a.posterUrl : a.url) ? /*#__PURE__*/React.createElement("img", {
        src: a.kind === "video" ? a.posterUrl : a.url,
        alt: "",
        loading: "lazy"
      }) : null, a.kind === "video" && /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "play_arrow"))) : /*#__PURE__*/React.createElement("span", {
        className: "t blank"
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "auto_stories")), m.length > 4 && /*#__PURE__*/React.createElement("span", {
        className: "t more"
      }, "+", m.length - 4));
    }
    if (!items || !items.length) return null;
    return /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: 6,
        flexWrap: "wrap",
        alignItems: "center",
        margin: "8px 0 0"
      },
      title: "Media bundled with this story: images and clips linked to its pieces"
    }, /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, "Media \xB7 ", items.length), items.slice(0, 10).map(a => a.kind === "video" ? /*#__PURE__*/React.createElement("div", {
      key: String(a.id),
      onClick: () => this.props.onOpen && this.props.onOpen(a),
      title: a.title || "clip",
      style: {
        width: 44,
        height: 44,
        borderRadius: 6,
        cursor: "pointer",
        background: a.posterUrl ? `center / cover url(${a.posterUrl})` : "#1f2329",
        color: "#fff",
        fontSize: 10,
        fontWeight: 700,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
    }, a.posterUrl ? "" : "▶") : /*#__PURE__*/React.createElement("img", {
      key: String(a.id),
      src: a.url,
      alt: a.altText || a.title || "",
      title: a.title || "",
      loading: "lazy",
      onClick: () => this.props.onOpen && this.props.onOpen(a),
      style: {
        width: 44,
        height: 44,
        objectFit: "cover",
        borderRadius: 6,
        cursor: "pointer"
      }
    })));
  }
}
/**
 * Story cover (Stories redesign 2026-10-08): ONE picture, the first image or video poster in the story's media
 * (GET stories/{id}/assets), else the first piece's own cover, else a soft tinted text cover with the title.
 */
class StoryCover extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      items: undefined
    });
  }
  componentDidMount() {
    this._alive = true;
    this.load();
  }
  componentDidUpdate(p) {
    if (p.storyId !== this.props.storyId) this.load();
  }
  componentWillUnmount() {
    this._alive = false;
  }
  async load() {
    try {
      const r = await svc(`/content/stories/${this.props.storyId}/assets?$top=12`).getAsync();
      if (this._alive) this.setState({
        items: r && r.items || []
      });
    } catch (e) {
      if (this._alive) this.setState({
        items: []
      });
    }
  }
  render() {
    const {
      members,
      title,
      tint
    } = this.props;
    if (this.state.items === undefined) return /*#__PURE__*/React.createElement("div", {
      className: "st-cover-wait"
    });
    const pic = a => a && (a.kind === "video" ? a.posterUrl : a.url) || "";
    const a = this.state.items.find(x => pic(x) && !cdnExpired(pic(x)));
    let url = a ? pic(a) : "";
    let kind = a && a.kind === "video" ? "video" : "image";
    if (!url) {
      const m = (members || []).find(c => c.coverUrl && !cdnExpired(c.coverUrl));
      if (m) {
        url = m.coverUrl;
        kind = m.coverKind;
      }
    }
    return /*#__PURE__*/React.createElement(LbCover, {
      url: url,
      kind: kind,
      title: title,
      tint: tint
    });
  }
}
// Builder stages → the four segments on a story card (Brief, Make, Publish, Results). Older states used plan/write/media.
const ST_SEGMENTS = ["Brief", "Make", "Publish", "Results"];
const ST_STAGE_IDX = {
  brief: 0,
  plan: 1,
  write: 1,
  media: 1,
  make: 1,
  ship: 2,
  publish: 2,
  measure: 3,
  results: 3
};
/**
 * Where a story stands, from what the list rows already carry: the primary piece's builder state (stage, plan,
 * stageDone), approved and publication counts, channels and the results columns.
 * Live = something is published and nothing is left to do (every planned piece is out, or every piece of a story that
 * was never opened in the Builder is published), or the Builder marked it shipped / moved it on to results.
 */
function storyFacts(s) {
  const members = s.members || [];
  const primary = members.find(c => String(c.id) === String(s.storyId)) || members[0];
  let bs = null;
  try {
    const raw = primary && (primary.builderState || primary.BuilderState);
    bs = raw ? JSON.parse(raw) : null;
  } catch (e) {
    bs = null;
  }
  const sum = k => members.reduce((a, c) => a + (Number(c[k]) || 0), 0);
  const plan = bs && Array.isArray(bs.plan) ? bs.plan : [];
  const planned = plan.filter(r => r && r.on && r.kind === "draft").length;
  const pieces = planned || members.length;
  const approved = sum("approvedCount");
  const pubs = sum("publicationCount");
  const stage = String(bs && bs.stage || "").toLowerCase();
  let idx = Object.prototype.hasOwnProperty.call(ST_STAGE_IDX, stage) ? ST_STAGE_IDX[stage] : !bs && pubs > 0 ? 2 : 0;
  if (idx === 0 && pubs > 0) idx = 2; // already published from outside the Builder: past the Brief
  const open = members.filter(c => String(c.status || "").toLowerCase() !== "archived");
  const allOut = pubs > 0 && (bs && bs.stage ? idx >= 2 && pubs >= pieces : (open.length ? open : members).every(c => Number(c.publicationCount) > 0));
  const live = !!(bs && bs.stageDone && bs.stageDone.ship) || idx === 3 || allOut;
  if (live) idx = 3;
  const channels = [];
  members.filter(c => Number(c.publicationCount) > 0).forEach(c => chNames(c).forEach(x => {
    if (!channels.includes(x)) channels.push(x);
  }));
  let line;
  const outCount = members.filter(c => Number(c.publicationCount) > 0).length || pieces;
  if (live) line = ["Live", channels.length ? `${plural(outCount, "piece")} on ${plural(channels.length, "channel")}` : pubs ? `${plural(pubs, "piece")} published` : `${plural(pieces, "piece")} sent out`];else if (idx === 0) line = ["Brief", "add what the writers should know"];else if (idx === 1) line = ["Make", planned ? `${num(Math.min(approved, planned))} of ${plural(planned, "piece")} ready` : "plan the pieces"];else line = pubs > 0 ? ["Publish", `${num(Math.min(pubs, pieces))} of ${plural(pieces, "piece")} published`] : ["Ready to publish", approved ? `${plural(Math.min(approved, pieces), "piece")} approved` : "approve the pieces you want to send"];
  const res = [];
  const add = (v, one, many, fmt) => {
    if (v > 0) res.push([(fmt || num)(v), v === 1 ? one : many]);
  };
  add(sum("impressions"), "view", "views");
  add(sum("sessions"), "visit", "visits");
  add(sum("conversions"), "conversion", "conversions");
  add(sum("salesValue"), "in sales", "in sales", usd);
  return {
    idx,
    live,
    pieces,
    line,
    results: res.slice(0, 3),
    empty: live ? "No results yet" : idx === 0 && !pubs ? "Not started" : "Not published yet"
  };
}
const REPURPOSE_CHANNELS = [["email", "Email"], ["landing", "Landing page"], ["blog", "Blog"], ["social_instagram", "Instagram"], ["social_facebook", "Facebook"], ["product_copy", "Product copy"]];
function chip(text, color, bg) {
  return /*#__PURE__*/React.createElement("span", {
    className: "plk-chip",
    style: {
      color,
      background: bg
    }
  }, text);
}
const STATUS_CLS = {
  active: "ok",
  published: "ok",
  approved: "info",
  archived: "muted",
  retired: "muted"
};
function statusChip(status) {
  const s = String(status || "").toLowerCase();
  return /*#__PURE__*/React.createElement("span", {
    className: "plk-chip solid " + (STATUS_CLS[s] || "")
  }, s || "—");
}

// ---- Library + piece page (DS mockup libflow 2026-10-08): plain channel names, a human kind line, one results line.
// Channel codes as they arrive on variants (repurpose names, imported platform names, ad types) and publication targets.
const CH_NAME = {
  facebook: "Facebook",
  social_facebook: "Facebook",
  meta: "Facebook",
  instagram: "Instagram",
  social_instagram: "Instagram",
  linkedin: "LinkedIn",
  social_linkedin: "LinkedIn",
  pinterest: "Pinterest",
  social_pinterest: "Pinterest",
  tiktok: "TikTok",
  social_tiktok: "TikTok",
  youtube: "YouTube",
  social_youtube: "YouTube",
  ad_youtube: "YouTube",
  email: "Email",
  email_draft: "Email",
  plunk_campaign: "Email",
  plunk_journey: "Email",
  mailchimp: "Email",
  constant_contact: "Email",
  web: "Website",
  website: "Website",
  webpage: "Website",
  web_page: "Website",
  page: "Website",
  landing: "Website",
  blog: "Website",
  wordpress: "Website",
  shopify_article: "Website",
  shopify_page: "Website",
  shopify_product: "Product page",
  shopify_media: "Product page",
  product_copy: "Product page",
  gbp: "Google",
  gbp_post: "Google",
  google_business: "Google",
  ad_search: "Search ad",
  ad_display: "Display ad",
  ad_social: "Social ad",
  ad_social_video: "Social ad",
  ad_retargeting: "Display ad",
  ad_retarget: "Display ad",
  ad_ctv: "TV ad",
  video: "Video",
  custom_api: "Your site",
  manual: "Elsewhere"
};
function chName(code) {
  const k = String(code || "").trim().toLowerCase();
  if (!k) return "";
  if (CH_NAME[k]) return CH_NAME[k];
  if (/^ads_|_ads$/.test(k)) return ""; // a provider target ("ads_google"): callers fall back to the variant's ad type
  if (k.startsWith("ad_")) return "Ad";
  if (k.startsWith("shopify_")) return "Website";
  return k.replace(/_/g, " ").replace(/\b\w/g, x => x.toUpperCase());
}
const chCodes = c => String(c && c.channels || "").split(",").map(x => x.trim()).filter(Boolean);
/** Distinct plain channel names for a piece, in first-seen order. */
function chNames(c) {
  const out = [];
  chCodes(c).forEach(k => {
    const n = chName(k);
    if (n && !out.includes(n)) out.push(n);
  });
  return out;
}
/** What a piece is, in plain words (Social post, Email, Web page, Blog article, Ad, Video, Product description). */
function pieceKind(c, channelsArg) {
  const codes = (channelsArg || chCodes(c)).map(x => String(x || "").toLowerCase());
  for (const k of codes) {
    if (/email|campaign|mailchimp|constant_contact|journey/.test(k)) return "Email";
    if (k === "blog" || k === "shopify_article") return "Blog article";
    if (/^ad_/.test(k)) return "Ad";
    if (k === "video" || /youtube|tiktok/.test(k)) return "Video";
    if (/facebook|instagram|linkedin|pinterest|gbp|google_business|^social/.test(k)) return "Social post";
    if (/landing|^web|website|shopify_page|wordpress/.test(k)) return "Web page";
    if (/product/.test(k)) return "Product description";
  }
  const o = String(c && c.origin || "").toLowerCase();
  if (/social/.test(o)) return "Social post";
  if (/web|crawl|site/.test(o)) return "Web page";
  if (/email|mailchimp|constant|automation/.test(o)) return "Email";
  if (/campaign|ad/.test(o)) return "Ad";
  return "Piece";
}
const isImported = c => /import|crawl|archaeolog/i.test(String(c && c.origin || ""));
/** The one results line on a card: the meaningful numbers only. Returns null when there is nothing yet. */
function resultsParts(c) {
  const n = k => Number(c && c[k]) || 0;
  const parts = [];
  if (n("impressions") > 0) parts.push([num(n("impressions")), "views"]);
  if (n("impressions") > 0 || n("clicks") > 0) parts.push([num(n("clicks")), n("clicks") === 1 ? "click" : "clicks"]);
  if (n("sessions") > 0) parts.push([num(n("sessions")), n("sessions") === 1 ? "visit" : "visits"]);
  if (n("conversions") > 0) parts.push([num(n("conversions")), n("conversions") === 1 ? "conversion" : "conversions"]);
  if (n("salesValue") > 0) parts.push([usd(n("salesValue")), "sales"]);
  return parts.length ? parts.slice(0, 4) : null;
}
/** Facebook and Instagram image links are signed and stop working after a while (the oe= param is the expiry, hex seconds). */
function cdnExpired(url) {
  const u = String(url || "");
  if (!/(fbcdn\.net|cdninstagram\.com|fbsbx\.com)/i.test(u)) return false;
  const m = u.match(/[?&]oe=([0-9a-f]{6,10})/i);
  if (!m) return false;
  const t = parseInt(m[1], 16) * 1000;
  return isFinite(t) && t < Date.now();
}
const LB_STATUS_LABEL = {
  draft: "Draft",
  archived: "Archived"
};
/** Live / draft / archived, for the Library status pills. */
function libStatus(c) {
  if (String(c && c.status || "").toLowerCase() === "archived") return "archived";
  return Number(c && c.publicationCount) > 0 ? "live" : "draft";
}
const STAGE_NAMES = {
  audience: "New audience",
  lead: "Leads",
  prospect: "Prospects",
  customer: "Customers"
};

/** Tries each picture in turn (an expired or broken link falls through to the next); renders `fallback` when none load. */
class PdMedia extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      i: 0,
      asVideo: false
    });
  }
  componentDidUpdate(p) {
    if ((p.items || []).map(x => x.url).join("|") !== (this.props.items || []).map(x => x.url).join("|")) this.setState({
      i: 0,
      asVideo: false
    });
  }
  render() {
    const items = this.props.items || [];
    const it = items[this.state.i];
    if (!it) return this.props.fallback || null;
    const next = () => this.setState({
      i: this.state.i + 1,
      asVideo: false
    });
    if (it.kind === "video") return /*#__PURE__*/React.createElement(ClipPlayer, {
      key: it.url,
      src: it.url,
      poster: it.poster,
      className: this.props.videoClass
    });
    // A stored link with no file type (an imported post's media) may be a video: one try as a video before moving on.
    if (this.state.asVideo) return /*#__PURE__*/React.createElement("video", {
      key: "v" + it.url,
      src: it.url,
      controls: true,
      playsInline: true,
      preload: "metadata",
      className: this.props.videoClass,
      onError: next
    });
    return /*#__PURE__*/React.createElement("img", {
      key: it.url,
      src: it.url,
      alt: it.alt || "",
      className: this.props.imgClass,
      onError: () => it.maybeVideo ? this.setState({
        asVideo: true
      }) : next()
    });
  }
}
/** Library card cover: the piece's picture, else a soft typographic cover with the title. */
class LbCover extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      failed: false
    });
  }
  componentDidUpdate(p) {
    if (p.url !== this.props.url && this.state.failed) this.setState({
      failed: false
    });
  }
  render() {
    const {
      url,
      kind,
      title,
      tint
    } = this.props;
    const ok = url && !this.state.failed && !cdnExpired(url);
    if (ok) return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
      src: url,
      alt: "",
      loading: "lazy",
      onError: () => this.setState({
        failed: true
      })
    }), kind === "video" && /*#__PURE__*/React.createElement("span", {
      className: "lb-play",
      "aria-label": "Video"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "play_arrow")));
    return /*#__PURE__*/React.createElement("div", {
      className: "lb-type t" + (tint || 0)
    }, /*#__PURE__*/React.createElement("span", null, title));
  }
}
class ContentHubComponent extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onRange", token => this.props.history.push(`/Content/${token}`));
    // §310: campaigns layer — confirmed campaigns + the clusterer's
    // suggestions + per-campaign funnel groups. NOTE the funnel param is
    // plain `groupBy=` (the $-prefixed form silently ignores it — probed).
    _defineProperty(this, "loadCampaigns", async () => {
      const range = this.range();
      const [camps, sugg, funnel] = await Promise.all([safe(svc("/content/campaigns").getAsync(), {
        items: []
      }), safe(svc("/content/campaigns/suggest").getAsync(), {
        items: []
      }), safe(svc(`/content/funnel/aggregate/${range}?groupBy=campaign`).getAsync(), null)]);
      if (!this._alive) return;
      this.setState({
        camp: {
          campaigns: camps.items || [],
          suggests: sugg.items || [],
          groups: funnel && funnel.groups || [],
          tier: funnel ? Number(funnel.tier) : 2
        }
      });
    });
    // §312 §4.1: one pass loads the overview — portfolio funnel, the
    // trend lane w/ event pins, campaign lanes, decay, and the ranked
    // "what's working" rows (campaign groups; story groups when no
    // campaigns are confirmed yet).
    _defineProperty(this, "loadOverview", async () => {
      const range = this.range();
      if (this.state.cal === undefined) this.loadCalendar(); // the Overview pipeline strip counts what is scheduled ahead
      const [funnel, trend, lanesTrend, decay, campGroups, coverage] = await Promise.all([safe(svc(`/content/funnel/aggregate/${range}?groupBy=portfolio`).getAsync(), null), safe(svc(`/content/trend/${range}?groupBy=portfolio`).getAsync(), null), safe(svc(`/content/trend/${range}?groupBy=campaign`).getAsync(), null), safe(svc("/content/decay?$top=6").getAsync(), {
        items: []
      }), safe(svc(`/content/funnel/aggregate/${range}?groupBy=campaign`).getAsync(), null), safe(svc("/content/coverage?$top=8").getAsync(), {
        items: []
      })]);
      if (!this._alive) return;
      const tier = funnel ? Number(funnel.tier) : 0;
      let working = campGroups && campGroups.groups || [];
      let workingKind = "campaign";
      if (!working.length) {
        const st = await safe(svc(`/content/funnel/aggregate/${range}?groupBy=story`).getAsync(), null);
        if (!this._alive) return;
        working = st && st.groups || [];
        workingKind = "story";
      }
      const ranked = rankRows(working, tier);
      this.setState({
        ov: {
          tier,
          portfolio: funnel && (funnel.groups || [])[0],
          trendLane: trend && (trend.lanes || [])[0],
          lanes: lanesTrend && lanesTrend.lanes || [],
          working: ranked.rows.slice(0, 6),
          workingMeta: {
            ...ranked,
            kind: workingKind
          },
          decay: decay.items || [],
          coverage: coverage && coverage.items || []
        },
        ovMetric: this.state.ovMetric || defaultMetric(tier)
      });
    });
    // §312 §4.2: campaign detail — aggregate funnel + channel legs + trend.
    // §4.6 overlay toggle: single-click a swimlane to add/remove it from the
    // trend overlays. Cap 3 — at cap, FIFO-drop the oldest so a click always
    // responds. Color is stable by position in the selection.
    _defineProperty(this, "toggleOverlay", key => this.setState(s => {
      const cur = s.ovOverlays || [];
      if (cur.includes(key)) return {
        ovOverlays: cur.filter(k => k !== key)
      };
      return {
        ovOverlays: cur.length >= 3 ? [...cur.slice(1), key] : [...cur, key]
      };
    }));
    _defineProperty(this, "overlayColor", key => OVERLAY_PALETTE[(this.state.ovOverlays || []).indexOf(key)] || "var(--plk-text-subtle)");
    _defineProperty(this, "openCampaign", async name => {
      this.setState({
        campDetail: "loading",
        tab: "campaigns"
      });
      const range = this.range();
      const enc = encodeURIComponent(name);
      const [funnel, legs, trend] = await Promise.all([safe(svc(`/content/funnel/aggregate/${range}?campaign=${enc}`).getAsync(), null), safe(svc(`/content/funnel/aggregate/${range}?groupBy=channel&campaign=${enc}`).getAsync(), null), safe(svc(`/content/trend/${range}?campaign=${enc}`).getAsync(), null)]);
      if (!this._alive) return;
      const tier = funnel ? Number(funnel.tier) : 0;
      this.setState({
        campDetail: {
          name,
          tier,
          group: funnel && (funnel.groups || [])[0],
          legs: legs && legs.groups || [],
          trendLane: trend && (trend.lanes || [])[0]
        },
        campMetric: this.state.campMetric || defaultMetric(tier)
      });
    });
    _defineProperty(this, "confirmSuggestion", async sg => {
      this.setState({
        campBusy: true
      });
      const t = document.querySelector("paper-toast");
      try {
        for (const id of sg.containerIds || []) {
          await svc(`/content/containers/${String(id)}/campaign`).postAsync({
            name: sg.name
          });
        }
        if (t) t.show(`"${sg.name}" confirmed: ${(sg.containerIds || []).length} pieces grouped.`);
      } catch (e) {
        if (t) t.show(e.message && e.message.length < 160 ? e.message : "Couldn't confirm that grouping.");
      }
      if (!this._alive) return;
      this.setState({
        campBusy: false,
        ov: undefined
      });
      this.loadCampaigns();
      this.loadOverview();
    });
    _defineProperty(this, "dismissSuggestion", name => {
      const d = new Set(this.state.campDismissed);
      d.add(name);
      this.setState({
        campDismissed: d
      });
    });
    // §4.1 decay → refresh: open the piece with the repurpose panel primed, so
    // "Refresh" is one click into grounded drafts for the decaying content.
    _defineProperty(this, "refreshDecay", d => this.openDetail({
      id: d.containerId
    }, {
      repurpose: true
    }));
    /** Open a picture or video from a piece in the full editor (2026-10-08: replaces the old Edit pop-ups). Media that is
     *  not in Assets yet is saved there first (deduped by content) and linked to the piece; Back in the editor returns here. */
    _defineProperty(this, "openInEditor", async (m, containerId) => {
      if (!m || !m.url && !m.id) return;
      const isVideo = m.kind === "video";
      let id = m.id ? String(m.id) : "";
      if (!id) {
        if (this.state.openingMedia) return;
        this.setState({
          openingMedia: m.url
        });
        try {
          const a = await svc("/content/assets").postAsync({
            kind: isVideo ? "video" : "image",
            url: m.url,
            title: m.title || undefined,
            source: "piece",
            posterUrl: m.poster || undefined
          });
          id = a && (a.id || a.Id) ? String(a.id || a.Id) : "";
          if (id && containerId) await safe(svc(`/content/assets/${id}/link`).postAsync({
            containerId: String(containerId),
            role: "source"
          }), null);
        } catch (e) {
          id = "";
        }
        if (this._alive) this.setState({
          openingMedia: null
        });
        if (!id) {
          toast("This picture could not be opened in the editor. Its link may have expired.");
          return;
        }
      }
      const back = containerId ? `?back=${encodeURIComponent(`/Content?piece=${containerId}`)}` : "";
      this.props.history.push(`/Content/${isVideo ? "clips" : "images"}/${id}${back}`);
    });
    /** Take a picture or video off the open piece (it stays in Assets), then reload the piece. */
    _defineProperty(this, "removePieceMedia", async m => {
      const d = this.state.detail;
      const cid = d && d.container && d.container.id;
      if (!cid || !m) return;
      this.setState({
        pdRemoveBusy: true
      });
      const q = [m.id ? `assetId=${encodeURIComponent(String(m.id))}` : "", m.url ? `url=${encodeURIComponent(m.url)}` : ""].filter(Boolean).join("&");
      const r = await safe(svc(`/content/containers/${encodeURIComponent(String(cid))}/media?${q}`).deleteAsync(), null);
      if (!this._alive) return;
      this.setState({
        pdRemoveBusy: false,
        pdRemove: null
      });
      if (r && Number(r.removed) > 0) {
        toast("Removed from this piece. It is still in Assets.");
        this.openDetail({
          id: String(cid)
        }, {
          keepTab: true
        });
      } else toast("This one could not be removed from here.");
    });
    /** Link the assets picked in "Add from Assets" to the open piece, then reload it. */
    _defineProperty(this, "addPicked", async () => {
      const d = this.state.detail;
      const ids = this.state.pdPick || [];
      const cid = d && d.container && d.container.id;
      if (!cid || !ids.length) return;
      this.setState({
        pdPickBusy: true
      });
      let ok = 0;
      for (const id of ids) {
        const r = await safe(svc(`/content/assets/${encodeURIComponent(String(id))}/link`).postAsync({
          containerId: String(cid),
          role: "source"
        }), null);
        if (r) ok++;
      }
      if (!this._alive) return;
      this.setState({
        pdPickBusy: false,
        pdPick: null
      });
      toast(ok === ids.length ? `${ok === 1 ? "Added" : `${ok} added`} to this piece.` : `${ok} of ${ids.length} added. Try the rest again.`);
      this.openDetail({
        id: String(cid)
      }, {
        keepTab: true
      });
    });
    _defineProperty(this, "openDetail", async (row, opts = {}) => {
      const id = String(row.id);
      // The open piece lives in the address (?piece=) so Back from an editor lands on it again.
      try {
        const u = new URL(window.location.href);
        if (u.searchParams.get("piece") !== id) {
          u.searchParams.set("piece", id);
          window.history.replaceState(window.history.state, "", u.pathname + u.search + u.hash);
        }
      } catch (e) {/* old browser */}
      const samePiece = this.state.pdFor === id; // a reload of the open piece keeps the chosen channel version
      this.setState({
        detailLoading: true,
        detail: null,
        detailTab: opts.keepTab ? this.state.detailTab || "content" : "content",
        repurposeOpen: !!opts.repurpose,
        createOpen: false,
        editVariant: null,
        publishMenu: null,
        videoOpen: false,
        pdFor: id,
        pdMenu: false,
        pdTopicEdit: false,
        ...(samePiece ? {} : {
          pdVariant: null,
          pdByChannel: false,
          pdManageLive: false,
          pdNotesOpen: false,
          addOpen: false
        })
      });
      // §305.2: detail first — when every publication predates the selected
      // window, the funnel is empty by construction, so fetch it for
      // all_time instead (labeled in the Performance tab). Explicitly
      // covering windows keep the page range.
      const detail = await safe(svc(`/content/containers/detail/${id}`).getAsync(), null);
      if (!this._alive) return;
      if (!detail) {
        this.setState({
          detailLoading: false
        });
        return;
      }
      let funnelRange = this.range();
      const start = this.windowStart();
      const pubDates = (detail.publications || []).map(p => p.publishedDate ? String(p.publishedDate).slice(0, 10) : null).filter(Boolean);
      if (start && pubDates.length && pubDates.every(d => d < start)) funnelRange = "all_time";
      const funnel = await safe(svc(`/content/containers/detail/${id}/funnel/${funnelRange}`).getAsync(), null);
      if (!this._alive) return;
      // §3.1 reverse surface: the email automations that use this container.
      const autos = await safe(svc(`/content/containers/detail/${id}/automations`).getAsync(), null);
      if (!this._alive) return;
      // AI visibility for this container's topic (mockup §2 tab 4).
      const vis = await safe(svc(`/content/containers/detail/${id}/visibility`).getAsync(), null);
      if (!this._alive) return;
      const full = {
        ...detail,
        funnel,
        funnelRange,
        automations: autos && autos.items || [],
        visibility: vis || null
      };
      this.setState({
        detail: full,
        detailLoading: false
      });
      // Imported social posts: their saved picture link expires; fetch the post's current one as a fallback.
      if (/social/i.test(String(detail.container && detail.container.origin || "")) || (detail.publications || []).some(p => /facebook|instagram/i.test(String(p && p.target || "")))) this.loadSocialMedia(full);
    });
    _defineProperty(this, "repurpose", async () => {
      const {
        detail,
        repurposeSel
      } = this.state;
      if (!detail || !repurposeSel.size) return;
      this.setState({
        repurposeBusy: true
      });
      const t = document.querySelector("paper-toast");
      try {
        await svc(`/content/containers/${String(detail.container.id)}/repurpose`).postAsync({
          channels: [...repurposeSel],
          ...this.mediaBody(this.mediaChoices(detail))
        });
        if (t) t.show("Repurpose queued: grounded drafts land as variants within a few minutes.");
        this.setState({
          repurposeOpen: false,
          repurposeSel: new Set(),
          repurposeBusy: false
        });
      } catch (e) {
        if (t) t.show(e.message || "Repurpose failed.");
        this.setState({
          repurposeBusy: false
        });
      }
    });
    // Pull content INTO the open container: paste/write a source block, or
    // import a website page's copy. Either feeds Repurpose. Reloads the detail.
    _defineProperty(this, "addBlock", async () => {
      const {
        detail,
        addBlockText
      } = this.state;
      if (!detail || !addBlockText.trim()) return;
      this.setState({
        addBusy: true
      });
      const t = document.querySelector("paper-toast");
      try {
        await svc(`/content/containers/${String(detail.container.id)}/blocks`).postAsync({
          kind: "copy",
          body: addBlockText.trim()
        });
        if (t) t.show("Block added. Repurpose can now fan it out to channels.");
        this.setState({
          addBlockText: "",
          addBusy: false,
          addOpen: false
        });
        this.openDetail({
          id: detail.container.id
        });
      } catch (e) {
        if (t) t.show(e.message || "Could not add the block.");
        this.setState({
          addBusy: false
        });
      }
    });
    _defineProperty(this, "importPage", async () => {
      const {
        detail,
        importUrl
      } = this.state;
      if (!detail || !importUrl.trim()) return;
      this.setState({
        addBusy: true
      });
      const t = document.querySelector("paper-toast");
      try {
        await svc("/content/import").postAsync({
          url: importUrl.trim(),
          containerId: String(detail.container.id)
        });
        if (t) t.show("Page imported: its copy is now in this container.");
        this.setState({
          importUrl: "",
          addBusy: false,
          addOpen: false
        });
        this.openDetail({
          id: detail.container.id
        });
      } catch (e) {
        if (t) t.show(e.message || "Could not import that page.");
        this.setState({
          addBusy: false
        });
      }
    });
    // Request a transcript for a video (CONTENT_HUB_NEXT §V.1). Records a
    // transcript_pending block; the worker fills it in. Reloads the detail.
    _defineProperty(this, "transcribe", async videoUrl => {
      const {
        detail
      } = this.state;
      if (!detail || !videoUrl) return;
      this.setState({
        transcribeBusy: true
      });
      const t = document.querySelector("paper-toast");
      try {
        const r = await svc(`/content/containers/${String(detail.container.id)}/transcribe`).postAsync({
          videoUrl
        });
        if (t) t.show(r && r.queued === false ? "Already requested: a transcript is on the way." : "Transcribing the video: the transcript lands in Text shortly.");
        this.setState({
          transcribeBusy: false
        });
        this.openDetail({
          id: detail.container.id
        });
      } catch (e) {
        if (t) t.show(e && e.message || "Could not request a transcript.");
        this.setState({
          transcribeBusy: false
        });
      }
    });
    // Add an asset by URL — an image (image_ref) or a document/link (link).
    // `field` is the state key holding the URL; `kind` the block kind; `label`
    // the toast noun. Documents come in as links (no upload/parse needed).
    // Source media edits (2026-10-02): the Assets editors open on a block's URL; the result is a new asset version and lands
    // on the piece as a new block next to the original.
    _defineProperty(this, "srcSaved", async (res, kind) => {
      const d = this.state.detail;
      if (!d) return;
      // Editors report one version, a list of versions (resize sets) or just a version number: take the last one with a URL.
      const list = Array.isArray(res) ? res : [res];
      const v = list.filter(x => x && typeof x === "object" && x.url).pop();
      if (!v) {
        await this.openDetail({
          id: d.container.id
        }, {
          keepTab: true
        });
        return;
      }
      try {
        await svc(`/content/containers/${String(d.container.id)}/blocks`).postAsync({
          kind: kind === "video" ? "asset_ref" : "image_ref",
          body: v.url,
          assetRef: v.url
        });
        toast(kind === "video" ? "Edited video added to this piece." : "Edited image added to this piece.");
        await this.openDetail({
          id: d.container.id
        }, {
          keepTab: true
        });
      } catch (e) {
        toast("The edit was saved in Assets but could not be added to this piece.");
      }
    });
    _defineProperty(this, "addAsset", async (field, kind, label) => {
      const {
        detail
      } = this.state;
      const url = (this.state[field] || "").trim();
      if (!detail || !url) return;
      this.setState({
        addBusy: true
      });
      const t = document.querySelector("paper-toast");
      try {
        await svc(`/content/containers/${String(detail.container.id)}/blocks`).postAsync({
          kind,
          body: url
        });
        if (kind === "image_ref") {
          // The image joins the library and the piece's media bundle, not just the block list.
          try {
            const a = await svc("/content/assets").postAsync({
              kind: "image",
              url,
              title: detail.container.title || "",
              source: "manual"
            });
            if (a && (a.id || a.Id)) await svc(`/content/assets/${String(a.id || a.Id)}/link`).postAsync({
              containerId: String(detail.container.id),
              role: "source"
            });
          } catch (e) {/* block still added */}
        }
        if (t) t.show(`${label} added.`);
        this.setState({
          [field]: "",
          addBusy: false,
          addOpen: false
        });
        this.openDetail({
          id: detail.container.id
        });
      } catch (e) {
        if (t) t.show(e.message || `Could not add the ${label.toLowerCase()}.`);
        this.setState({
          addBusy: false
        });
      }
    });
    // Set/change the container's TOPIC — what AI visibility is measured against.
    _defineProperty(this, "setTopic", async () => {
      const {
        detail,
        topicDraft
      } = this.state;
      const c = detail && detail.container;
      if (!c || !topicDraft.trim()) return;
      this.setState({
        topicBusy: true
      });
      const t = document.querySelector("paper-toast");
      try {
        await svc(`/content/containers/${String(c.id)}`).putAsync({
          title: c.title,
          summary: c.summary,
          topic: topicDraft.trim(),
          status: c.status
        });
        if (t) t.show(`Topic set to "${topicDraft.trim()}". AI visibility will populate on the next check.`);
        this.setState({
          topicDraft: "",
          topicBusy: false
        });
        this.openDetail({
          id: c.id
        });
      } catch (e) {
        if (t) t.show(e.message || "Could not set the topic.");
        this.setState({
          topicBusy: false
        });
      }
    });
    _defineProperty(this, "recAction", async (rec, action) => {
      this.setState({
        recBusy: {
          ...this.state.recBusy,
          [String(rec.id)]: true
        }
      });
      const t = document.querySelector("paper-toast");
      try {
        await svc(`/content/recommendations/${String(rec.id)}/${action}`).postAsync({});
        if (t) t.show(action === "accept" ? "Accepted: a draft brief lands in the Library." : "Dismissed.");
        this.load();
      } catch (e) {
        if (t) t.show(e.message || "Action failed.");
      }
      if (this._alive) this.setState({
        recBusy: {
          ...this.state.recBusy,
          [String(rec.id)]: false
        }
      });
    });
    /** Where each refresh card's piece lives (its first publication URL): same-named pieces read apart by address. */
    _defineProperty(this, "loadRecPlaces", async recs => {
      const ids = recs.map(r => (String(r && (r.sourceRef || r.source_ref) || "").match(/^refresh:(\d+)$/) || [])[1]).filter(Boolean).slice(0, 12);
      if (!ids.length) return;
      const pairs = await Promise.all(ids.map(async id => {
        const d = await safe(svc(`/content/containers/detail/${id}`).getAsync(), null);
        const pub = d && (d.publications || []).find(p => p && p.url);
        return [id, pub ? String(pub.url).replace(/^https?:\/\/(www\.)?/, "").replace(/\/$/, "") : ""];
      }));
      if (this._alive) this.setState({
        recPlaces: Object.fromEntries(pairs)
      });
      // The visit counts behind each Slipping row (same /decay feed the weekly pass reads: trailing 28 days vs the 28 before).
      const dec = await safe(svc("/content/decay?$top=20").getAsync(), {
        items: []
      });
      if (this._alive) this.setState({
        recDecay: Object.fromEntries((dec && dec.items || []).map(d => [String(d.containerId), d]))
      });
    });
    // Lifecycle stage tags on a piece (content_link link_type='stage'): toggled from the piece header or the stage picker.
    _defineProperty(this, "setStage", async (containerId, stage, on) => {
      const id = String(containerId);
      if (on) await svc(`/content/containers/${id}/links`).postAsync({
        linkType: "stage",
        refId: stage
      });else await svc(`/content/containers/${id}/links?linkType=stage&refId=${encodeURIComponent(stage)}`).deleteAsync();
    });
    _defineProperty(this, "toggleDetailStage", async stage => {
      const d = this.state.detail;
      if (!d || !d.container) return;
      const links = d.links || [];
      const on = links.some(l => String(l.linkType || l.link_type || "").toLowerCase() === "stage" && String(l.refId || l.ref_id || "").toLowerCase() === stage);
      const t = document.querySelector("paper-toast");
      try {
        await this.setStage(d.container.id, stage, !on);
        const next = on ? links.filter(l => !(String(l.linkType || l.link_type || "").toLowerCase() === "stage" && String(l.refId || l.ref_id || "").toLowerCase() === stage)) : [...links, {
          linkType: "stage",
          refId: stage
        }];
        if (this._alive) this.setState({
          detail: {
            ...d,
            links: next
          }
        });
      } catch (e) {
        if (t) t.show(e && e.message || "Could not change the stage.");
      }
    });
    _defineProperty(this, "saveStagePick", async () => {
      const sp = this.state.stagePick;
      if (!sp) return;
      const ids = Object.keys(sp.picked).filter(k => sp.picked[k]);
      if (!ids.length) {
        this.setState({
          stagePick: null
        });
        return;
      }
      this.setState({
        stagePick: {
          ...sp,
          busy: true
        }
      });
      const t = document.querySelector("paper-toast");
      let ok = 0;
      for (const id of ids) {
        try {
          await this.setStage(id, sp.stage, true);
          ok++;
        } catch (e) {/* counted below */}
      }
      // The gap is closed now: mark the card done so it leaves the queue (accepted cards are never resurrected).
      if (ok > 0 && sp.recId) {
        try {
          await svc(`/content/recommendations/${sp.recId}/accept`).postAsync({});
        } catch (e) {/* the card stays; tags are saved */}
      }
      if (t) t.show(`${ok} piece${ok === 1 ? "" : "s"} tagged for ${STAGE_PLURAL[sp.stage] || sp.stage}.${ok < ids.length ? ` ${ids.length - ok} could not be tagged.` : ""}`);
      if (this._alive) this.setState({
        stagePick: null
      });
      this.load();
    });
    // §312 draft-from-rec: spawn the draft container that answers a rec
    // (linked via draft_container_id) and open it. Idempotent server-side —
    // a rec that already has a draft just returns it (we open it either way).
    _defineProperty(this, "recDraft", async rec => {
      if (rec.draftContainerId) {
        this.openDetail({
          id: rec.draftContainerId
        });
        return;
      }
      this.setState({
        recBusy: {
          ...this.state.recBusy,
          [String(rec.id)]: true
        }
      });
      const t = document.querySelector("paper-toast");
      try {
        const detail = await svc(`/content/recommendations/${String(rec.id)}/draft`).postAsync({});
        if (t) t.show("Draft created: opening it.");
        if (this._alive && detail && detail.container) {
          this.setState({
            detail: {
              ...detail,
              funnelRange: this.range()
            },
            detailLoading: false
          });
        }
        this.load();
      } catch (e) {
        if (t) t.show(e.message || "Couldn't create the draft.");
      }
      if (this._alive) this.setState({
        recBusy: {
          ...this.state.recBusy,
          [String(rec.id)]: false
        }
      });
    });
    // §220 item 3: manual container create (origin=manual) — minimal
    // title/topic/summary form; Repurpose grows it from there.
    _defineProperty(this, "createContainer", async () => {
      const title = (this.state.createTitle || "").trim();
      if (!title) return;
      this.setState({
        createBusy: true
      });
      const t = document.querySelector("paper-toast");
      try {
        const created = await svc("/content/containers").postAsync({
          title,
          topic: (this.state.createTopic || "").trim() || undefined,
          summary: (this.state.createSummary || "").trim() || undefined,
          origin: "manual"
        });
        if (!this._alive) return;
        const newId = created && (created.id || created.Id || created.container && (created.container.id || created.container.Id));
        if (t) t.show("Piece created: add copy and images, then repurpose or make media.");
        // Open the new piece right away (it used to vanish behind the Overview tab).
        this.setState({
          createBusy: false,
          createOpen: false,
          createTitle: "",
          createTopic: "",
          createSummary: "",
          tab: "library"
        });
        this.load();
        if (newId) this.openDetail({
          id: String(newId),
          title
        });
      } catch (e) {
        if (t) t.show(e.message && e.message.length < 160 ? e.message : "Create failed.");
        this.setState({
          createBusy: false
        });
      }
    });
    // ---------------------------------------------------------------- variant actions (2026-09-27)
    _defineProperty(this, "reloadDetail", async () => {
      if (this.state.detail) await this.openDetail({
        id: this.state.detail.container.id
      });
    });
    // Imported web page: read it again (2026-10-16). New text and new pictures come in; what the writers made stays.
    _defineProperty(this, "refreshFromWebsite", async () => {
      const d = this.state.detail;
      if (!d || !d.container) return;
      const id = String(d.container.id);
      this.setState({
        libraryBusy: true
      });
      try {
        const r = await svc(`/content/containers/${id}/refresh-page`).postAsync({});
        const pics = Number(r && r.newImages) || 0;
        toast(`Read again from ${r && r.host || "the website"}: ${Number(r && r.chars || 0).toLocaleString()} characters${pics ? `, ${pics} new picture${pics === 1 ? "" : "s"}` : ", no new pictures"}.`);
        await this.reloadDetail();
      } catch (e) {
        toast(e && e.message || "The page could not be read again.");
      } finally {
        this.setState({
          libraryBusy: false
        });
      }
    });
    _defineProperty(this, "startEdit", v => this.setState({
      editVariant: String(v.id),
      editTitle: v.title || "",
      editBody: v.body || ""
    }));
    _defineProperty(this, "saveEdit", async () => {
      const id = this.state.editVariant;
      if (!id) return;
      const t = document.querySelector("paper-toast");
      try {
        await svc(`/content/variants/${id}`).putAsync({
          title: this.state.editTitle,
          body: this.state.editBody
        });
        if (t) t.show("Saved.");
      } catch (e) {
        if (t) t.show(e && e.message || "Could not save.");
      }
      this.setState({
        editVariant: null
      });
      this.reloadDetail();
    });
    _defineProperty(this, "setVariantStatus", async (v, status) => {
      const t = document.querySelector("paper-toast");
      try {
        await svc(`/content/variants/${String(v.id)}/status`).postAsync({
          status
        });
        if (t) t.show(status === "approved" ? "Approved: pick where it goes under Publish." : `Marked ${status}.`);
      } catch (e) {
        if (t) t.show(e && e.message || "That didn't go through.");
      }
      this.reloadDetail();
    });
    _defineProperty(this, "copyVariant", v => {
      const text = (v.title ? v.title + "\n\n" : "") + (v.body || "");
      try {
        navigator.clipboard.writeText(text);
        const t = document.querySelector("paper-toast");
        if (t) t.show("Copied.");
      } catch (e) {/* no clipboard */}
    });
    _defineProperty(this, "publishTargets", (v, detailArg) => {
      const detail = detailArg || this.state.detail;
      // Imported social pieces carry the bare platform as their channel (instagram, facebook, pinterest, linkedin);
      // the publish rules below speak the repurpose channel names, so alias them (2026-09-29).
      const ALIAS = {
        instagram: "social_instagram",
        facebook: "social_facebook",
        pinterest: "social_pinterest",
        linkedin: "social_linkedin",
        gbp: "gbp_post",
        google_business: "gbp_post"
      };
      const raw = String(v.channel || "").toLowerCase();
      const ch = ALIAS[raw] || raw;
      const conns = this.state.connectors || [];
      const has = p => conns.some(c => String(c.provider || "").toLowerCase() === p && String(c.status || "").toLowerCase() === "connected");
      const shopify = !!this.state.shopify;
      const hasProduct = (detail && detail.links || []).some(l => String(l.linkType || l.link_type || "").toLowerCase() === "product");
      const list = [];
      if (ch === "product_copy" && shopify) list.push({
        key: "shopify_product",
        label: hasProduct ? "Shopify · product description" : "Shopify · product description (no product linked)",
        disabled: !hasProduct
      });
      if (ch === "video" && shopify) list.push({
        key: "shopify_media",
        label: hasProduct ? "Shopify · product page video" : "Shopify · product page video (no product linked)",
        disabled: !hasProduct
      });
      if (ch === "blog" && shopify) list.push({
        key: "shopify_article",
        label: "Shopify · blog post"
      });
      if ((ch === "landing" || ch === "web") && shopify) list.push({
        key: "shopify_page",
        label: "Shopify · page"
      });
      if ((ch === "blog" || ch === "landing" || ch === "web") && has("wordpress")) list.push({
        key: "wordpress",
        label: "WordPress · draft post"
      });
      if (ch === "email") list.push({
        key: "email_draft",
        label: "Plunk · email automation draft"
      });
      const soc = p => (this.state.social || []).some(a => String(a.platform || "").toLowerCase() === p && String(a.status || "").toLowerCase() === "connected");
      if (ch === "social_facebook" || ch === "video") list.push({
        key: "facebook",
        label: soc("facebook") ? ch === "video" ? "Facebook · video post" : "Facebook · post" : "Facebook · connect under Manage Data › Connect",
        disabled: !soc("facebook")
      });
      if (ch === "social_instagram" || ch === "video") list.push({
        key: "instagram",
        label: soc("instagram") ? ch === "video" ? "Instagram · reel" : "Instagram · post" : "Instagram · connect under Manage Data › Connect",
        disabled: !soc("instagram")
      });
      if (ch === "gbp_post") list.push({
        key: "gbp",
        label: soc("google_business") ? "Google Business Profile · post" : "Google Business Profile · connect under Manage Data › Connect",
        disabled: !soc("google_business")
      });
      if ((ch === "social_pinterest" || ch === "social_instagram" || ch === "blog") && soc("pinterest")) list.push({
        key: "pinterest",
        label: "Pinterest · pin"
      });
      if ((ch === "social_linkedin" || ch === "social_facebook" || ch === "blog") && soc("linkedin")) list.push({
        key: "linkedin",
        label: "LinkedIn · company post"
      });
      if (ch === "video" && soc("youtube")) list.push({
        key: "youtube",
        label: "YouTube · upload"
      });
      if (ch === "video" && soc("tiktok")) list.push({
        key: "tiktok",
        label: "TikTok · post"
      });
      if (has("custom_api")) list.push({
        key: "custom_api",
        label: "Custom API · your endpoint"
      });
      if (!list.length) list.push({
        key: "none",
        label: shopify ? "No target fits this channel yet" : "Connect a target under Manage Data › Connect",
        disabled: true
      });
      return list;
    });
    _defineProperty(this, "publishTo", async (v, target, detailArg, opts) => {
      const t = document.querySelector("paper-toast");
      const detail = detailArg || this.state.detail;
      const quiet = !!(opts && opts.quiet);
      const busyKey = `${v.id}|publish`;
      if (target === "shopify_product" && !quiet && !(this.state.shopifyConfirm && this.state.shopifyConfirm.confirmed)) {
        this.setState({
          publishMenu: null,
          shopifyConfirm: {
            variant: v,
            target
          }
        });
        return;
      }
      this.setState({
        publishMenu: null,
        shopifyConfirm: null,
        variantBusy: {
          ...this.state.variantBusy,
          [busyKey]: true
        }
      });
      try {
        const republish = !!(opts && opts.republish);
        if (target === "shopify_product" || target === "shopify_article" || target === "shopify_page") {
          await this.publishShopify(v, target, detail, quiet, opts && opts.externalId);
        } else if (target === "shopify_media") {
          await this.publishShopifyMedia(v, detail, quiet);
        } else if (target === "custom_api") {
          const videoUrl = v.channel === "video" ? this.videoUrlFor(v, detail) : undefined;
          await svc(`/content/variants/${String(v.id)}/publish/custom`).postAsync({
            kind: v.channel,
            videoUrl
          });
          if (t && !quiet) t.show("Sent to your endpoint: the reply lands under Where it lives in a moment.");
        } else if (target === "wordpress") {
          await svc(`/content/variants/${String(v.id)}/publish/cms`).postAsync({
            provider: "wordpress",
            republish
          });
          if (t && !quiet) t.show(republish ? "Queued to WordPress: the same post gets the current copy." : "Queued to WordPress as a draft.");
        } else if (target === "email_draft") {
          await svc(`/content/containers/${String(v.containerId)}/publish/email`).postAsync({});
          if (t && !quiet) t.show("Email automation draft created: find it under Email › Automations.");
        } else if (["facebook", "instagram", "gbp", "pinterest", "linkedin", "youtube", "tiktok"].includes(target)) {
          const NAMES = {
            gbp: "Google Business Profile",
            facebook: "Facebook",
            instagram: "Instagram",
            pinterest: "Pinterest",
            linkedin: "LinkedIn",
            youtube: "YouTube",
            tiktok: "TikTok"
          };
          const videoUrl = v.channel === "video" ? this.videoUrlFor(v, detail) : undefined;
          const imageUrl = videoUrl ? this.posterFor(videoUrl, detail) || undefined : this.heroImage(detail, v); // the video's thumbnail = the Reel cover
          if ((target === "instagram" || target === "pinterest") && !imageUrl && !videoUrl) {
            if (quiet) throw new Error(`${NAMES[target]} needs an image`);
            if (t) t.show(`${NAMES[target]} needs an image: add one under Blocks first.`);
            return;
          }
          if ((target === "youtube" || target === "tiktok") && !videoUrl) {
            if (quiet) throw new Error(`${NAMES[target]} needs a rendered video`);
            if (t) t.show(`${NAMES[target]} needs a rendered video. Make a video first.`);
            return;
          }
          const link = detail && detail.container && detail.container.url ? detail.container.url : undefined;
          await svc(`/content/variants/${String(v.id)}/publish/social`).postAsync({
            platform: target,
            imageUrl,
            videoUrl,
            altText: this.altFor(imageUrl),
            link,
            republish
          });
          if (t && !quiet) t.show(`Queued to ${NAMES[target]}.`);
        }
      } catch (e) {
        if (quiet) throw e;
        if (t) t.show(e && e.message && e.message.length < 200 ? e.message : "Publish failed.");
      } finally {
        if (this._alive) this.setState({
          variantBusy: {
            ...this.state.variantBusy,
            [busyKey]: false
          }
        });
        if (!quiet) setTimeout(() => this._alive && this.reloadDetail(), 1500);
      }
    });
    // Media bundle for a piece (2026-09-29): linked assets (with ids) plus image blocks that were never registered.
    _defineProperty(this, "mediaChoices", detailArg => {
      const d = detailArg || this.state.detail;
      if (!d) return [];
      const out = [];
      const seen = new Set();
      (d.assets || []).forEach(a => {
        if (a && a.url && !seen.has(a.url) && (a.kind === "image" || a.kind === "video")) {
          seen.add(a.url);
          out.push({
            url: a.url,
            id: String(a.id),
            kind: a.kind,
            title: a.title || "",
            poster: a.posterUrl || null,
            role: a.role || "",
            variantId: a.variantId ? String(a.variantId) : null
          });
        }
      });
      (d.blocks || []).forEach(b => {
        const u = b && (b.assetRef || b.body);
        if (u && /image/i.test(b.kind || "") && /^https?:\/\//i.test(u) && !seen.has(u)) {
          seen.add(u);
          out.push({
            url: u,
            id: null,
            kind: "image",
            title: "",
            poster: null,
            role: "block",
            variantId: null
          });
        }
      });
      return out;
    });
    _defineProperty(this, "mediaSelected", choices => {
      const sel = this.state.repurposeMedia;
      return sel ? choices.filter(c => sel.has(c.url)) : choices.filter(c => c.kind === "image").slice(0, 6);
    });
    _defineProperty(this, "mediaBody", choices => {
      const picked = this.mediaSelected(choices);
      return {
        assetIds: picked.filter(c => c.id).map(c => c.id),
        imageUrls: picked.filter(c => !c.id).map(c => c.url)
      };
    });
    // The image that rides with a variant when it publishes: its own hero asset, else the piece's first asset, else the first image block.
    _defineProperty(this, "heroImage", (detailArg, variant) => {
      const d = detailArg || this.state.detail;
      const assets = d && d.assets || [];
      const own = variant && assets.find(a => a.kind === "image" && a.variantId && String(a.variantId) === String(variant.id));
      if (own) return own.url;
      const any = assets.find(a => a.kind === "image" && (a.role === "hero" || a.role === "source" || a.role === "generated" || a.role === "media"));
      return any ? any.url : this.firstImage(d);
    });
    _defineProperty(this, "firstImage", detailArg => {
      const d = detailArg || this.state.detail;
      // An imported post's picture link can expire (Facebook / Instagram sign them): prefer one that still works.
      const imgs = (d && d.blocks || []).filter(x => /image/i.test(x.kind || "") || /\.(jpe?g|png|gif|webp)(\?|$)/i.test(x.assetRef || x.body || ""));
      const b = imgs.find(x => !cdnExpired(x.assetRef || x.body)) || imgs[0];
      return b ? b.assetRef || b.body : undefined;
    });
    _defineProperty(this, "videoUrlFor", (v, detailArg) => {
      const d = detailArg || this.state.detail;
      const b = videoRefFor(d && d.blocks && d.blocks, v.id);
      return b ? b.assetRef : undefined;
    });
    // Poster frame for a clip URL from the piece's assets (motion-engine renders carry one).
    _defineProperty(this, "posterFor", (url, detailArg) => {
      if (!url) return undefined;
      const d = detailArg || this.state.detail;
      const pools = [d && d.assets || [], this.state.assets || [], this.state.assetsPick || []];
      for (const pool of pools) {
        const a = pool.find(x => x && x.url === url);
        if (a && a.posterUrl) return a.posterUrl;
      }
      return undefined;
    });
    // Alt text for an image URL from the asset lists already loaded (R4); the server falls back to the asset library.
    _defineProperty(this, "altFor", url => {
      if (!url) return undefined;
      const pools = [this.state.assets || [], this.state.assetsPick || []];
      for (const pool of pools) {
        const a = pool.find(x => x.url === url);
        if (a && a.altText) return a.altText;
      }
      return undefined;
    });
    // Shopify writes go straight to ShopifyService (the store-token holder) with the user's JWT; the result is recorded here.
    _defineProperty(this, "publishShopify", async (v, target, detailArg, quiet, externalId) => {
      const t = document.querySelector("paper-toast");
      const d = detailArg || this.state.detail;
      const shop = this.state.shopify && this.state.shopify.shop || "";
      const link = (d.links || []).find(l => String(l.linkType || l.link_type || "").toLowerCase() === "product");
      const kind = target === "shopify_product" ? "product" : target === "shopify_article" ? "article" : "page";
      const html = /<[a-z][\s\S]*>/i.test(v.body || "") ? v.body : (v.body || "").split(/\n{2,}/).map(p => `<p>${p.replace(/\n/g, "<br/>")}</p>`).join("");
      const base = String(endpoints.product.root || "").replace(/\/v1\/?$/, "");
      const h = await bearerHeaders();
      h["content-type"] = "application/json";
      const r = await fetch(`${base}/shopify/content/publish`, {
        method: "POST",
        headers: h,
        body: JSON.stringify({
          shop,
          kind,
          productId: link ? link.refId || link.ref_id : undefined,
          title: v.title,
          html,
          publish: kind !== "product" ? true : undefined,
          externalId: externalId || undefined
        })
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.error || `Shopify publish failed (${r.status})`);
      await svc(`/content/variants/${String(v.id)}/published`).postAsync({
        target,
        externalId: j.externalId,
        url: j.url,
        previousHtml: j.previousHtml
      });
      if (t && !quiet) t.show(kind === "product" ? "Product description updated in Shopify." : kind === "article" ? "Blog post published to Shopify." : "Page published to Shopify.");
    });
    // R7: a rendered video becomes product-page media (Shopify hosts the file). Alt text = the variant title.
    _defineProperty(this, "publishShopifyMedia", async (v, detailArg, quiet) => {
      const t = document.querySelector("paper-toast");
      const d = detailArg || this.state.detail;
      const shop = this.state.shopify && this.state.shopify.shop || "";
      const link = (d.links || []).find(l => String(l.linkType || l.link_type || "").toLowerCase() === "product");
      const mediaUrl = this.videoUrlFor(v, d);
      if (!link) throw new Error("Link a product to this piece first.");
      if (!mediaUrl) throw new Error("This variant has no rendered video yet.");
      const base = String(endpoints.product.root || "").replace(/\/v1\/?$/, "");
      const h = await bearerHeaders();
      h["content-type"] = "application/json";
      const r = await fetch(`${base}/shopify/content/publish`, {
        method: "POST",
        headers: h,
        body: JSON.stringify({
          shop,
          kind: "media",
          productId: link.refId || link.ref_id,
          mediaUrl,
          mediaType: "video",
          alt: v.title || d.container && d.container.title || ""
        })
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.error || `Shopify media upload failed (${r.status})`);
      await svc(`/content/variants/${String(v.id)}/published`).postAsync({
        target: "shopify_media",
        externalId: j.externalId,
        url: j.url
      });
      if (t && !quiet) t.show("Video added to the product page in Shopify: it appears once Shopify finishes processing it.");
    });
    // R7 (images): any image block → product media on the linked Shopify product, alt text from the asset library.
    _defineProperty(this, "addImageToShopify", async url => {
      const t = document.querySelector("paper-toast");
      const d = this.state.detail;
      const shop = this.state.shopify && this.state.shopify.shop || "";
      const link = (d.links || []).find(l => String(l.linkType || l.link_type || "").toLowerCase() === "product");
      if (!link) {
        if (t) t.show("Link a product to this piece first.");
        return;
      }
      try {
        let alt = this.altFor(url);
        if (!alt) {
          try {
            const r = await svc(`/content/assets?q=${encodeURIComponent(url)}&$top=1`).getAsync();
            const a = r && r.items && r.items[0];
            alt = a && a.altText;
          } catch (e) {/* none */}
        }
        const base = String(endpoints.product.root || "").replace(/\/v1\/?$/, "");
        const h = await bearerHeaders();
        h["content-type"] = "application/json";
        const r = await fetch(`${base}/shopify/content/publish`, {
          method: "POST",
          headers: h,
          body: JSON.stringify({
            shop,
            kind: "media",
            productId: link.refId || link.ref_id,
            mediaUrl: url,
            mediaType: "image",
            alt: alt || d.container && d.container.title || ""
          })
        });
        const j = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(j.error || `Shopify media upload failed (${r.status})`);
        if (t) t.show("Image added to the product's media in Shopify.");
      } catch (e) {
        if (t) t.show(e && e.message || "Could not add the image to Shopify.");
      }
    });
    // R4: alt text on an asset — typed by the merchant, or written by content_alt_text_agent (an agent run, cost logged).
    _defineProperty(this, "saveAlt", async (a, text) => {
      const t = document.querySelector("paper-toast");
      try {
        await svc(`/content/assets/${String(a.id)}/alt`).postAsync({
          altText: text
        });
        this.setState({
          assets: (this.state.assets || []).map(x => String(x.id) === String(a.id) ? {
            ...x,
            altText: text
          } : x),
          altDraft: {
            ...this.state.altDraft,
            [String(a.id)]: undefined
          }
        });
      } catch (e) {
        if (t) t.show("Could not save the description.");
      }
    });
    // Fill every missing alt text in one go (2026-10-02): the server writes up to 20 per call; loop until none remain.
    _defineProperty(this, "fillAlt", async () => {
      if (this.state.altFillBusy) return;
      this.setState({
        altFillBusy: true
      });
      let written = 0,
        failed = 0,
        remaining = null;
      try {
        for (let i = 0; i < 10; i++) {
          const r = await svc("/content/assets/alt-text/fill?max=20").postAsync({});
          written += Number(r && r.written) || 0;
          failed += Number(r && r.failed) || 0;
          remaining = Number(r && r.remaining) || 0;
          if (this._alive) this.setState({
            altFillNote: `${written} written${remaining ? ` · ${remaining} to go` : ""}`
          });
          if (!remaining || !(Number(r && r.written) || 0)) break;
        }
        toast(written ? `Descriptions written for ${written} picture${written === 1 ? "" : "s"}${failed ? ` (${failed} could not be described)` : ""}.` : failed ? "The pictures could not be described." : "Every picture already has a description.");
        await this.loadAssets();
      } catch (e) {
        toast(e && e.message || "Could not write the descriptions.");
      } finally {
        if (this._alive) this.setState({
          altFillBusy: false,
          altFillNote: ""
        });
      }
    });
    _defineProperty(this, "writeAlt", async a => {
      const t = document.querySelector("paper-toast");
      this.setState({
        altBusy: {
          ...this.state.altBusy,
          [String(a.id)]: true
        }
      });
      try {
        const r = await this.runAgent("content_alt_text_agent", `Write alt text for this image${a.title ? ` (${a.title})` : ""}.`, {
          imageUrl: a.url,
          title: a.title || ""
        });
        const id = r && (r.runId || r.id || r.agentRunId || r.Id);
        const done = await this.waitAgent(id, 4000, 30);
        let alt = done.ok && (done.ctx && done.ctx.altText || done.res && done.res.altText);
        if (!alt && done.ok) {
          const raw = done.run && (done.run.runResult || done.run.RunResult) || "";
          const m = /"altText"\s*:\s*"([^"]+)"/.exec(raw);
          alt = m ? m[1] : "";
        }
        if (alt) await this.saveAlt(a, String(alt).trim());else if (t) t.show(done.timeout ? "Still writing: try again in a moment." : "The agent could not describe this image.");
      } catch (e) {
        this.creditsToast(e, "Could not start the alt-text agent.");
      } finally {
        if (this._alive) this.setState({
          altBusy: {
            ...this.state.altBusy,
            [String(a.id)]: false
          }
        });
      }
    });
    // R6: Story → Publish everywhere. Builds a plan (every approved variant of every piece → the first target that fits)
    // from each member's detail, lets the merchant adjust targets, then publishes in order.
    _defineProperty(this, "openStoryPublish", async story => {
      this.setState({
        storyPublish: story.storyId,
        storyPublishPlan: undefined
      });
      const rows = [];
      for (const m of story.members) {
        let d = null;
        try {
          d = await svc(`/content/containers/detail/${String(m.id)}`).getAsync();
        } catch (e) {
          d = null;
        }
        if (!d) continue;
        for (const v of d.variants || []) {
          if (String(v.status || "").toLowerCase() !== "approved") continue;
          const targets = this.publishTargets(v, d).filter(x => !x.disabled && x.key !== "none");
          if (!targets.length) continue;
          rows.push({
            key: `${m.id}|${v.id}`,
            piece: m.title || d.container.title || "Untitled",
            variant: v,
            detail: d,
            targets,
            target: targets[0].key,
            on: true
          });
        }
      }
      if (this._alive) this.setState({
        storyPublishPlan: rows
      });
    });
    _defineProperty(this, "runStoryPublish", async () => {
      const t = document.querySelector("paper-toast");
      const rows = (this.state.storyPublishPlan || []).filter(r => r.on);
      if (!rows.length) return;
      this.setState({
        storyPublishBusy: true
      });
      let ok = 0;
      const failed = [];
      for (const r of rows) {
        try {
          await this.publishTo(r.variant, r.target, r.detail, {
            quiet: true
          });
          ok++;
        } catch (e) {
          failed.push(`${r.piece}: ${e && e.message || "failed"}`);
        }
      }
      this.setState({
        storyPublishBusy: false,
        storyPublish: null,
        storyPublishPlan: undefined
      });
      if (t) t.show(failed.length ? `${ok} published · ${failed.length} failed: ${failed[0]}` : `${ok} piece${ok === 1 ? "" : "s"} published across the story.`);
      this.load();
    });
    _defineProperty(this, "undoShopify", async () => {
      const d = this.state.detail;
      const prev = (d.blocks || []).find(b => String(b.kind || "") === "previous_shopify_product");
      if (!prev) return;
      const t = document.querySelector("paper-toast");
      try {
        const base = String(endpoints.product.root || "").replace(/\/v1\/?$/, "");
        const h = await bearerHeaders();
        h["content-type"] = "application/json";
        const r = await fetch(`${base}/shopify/content/publish`, {
          method: "POST",
          headers: h,
          body: JSON.stringify({
            shop: this.state.shopify.shop,
            kind: "product",
            productId: prev.assetRef,
            html: prev.body || ""
          })
        });
        if (!r.ok) throw new Error("undo failed");
        if (t) t.show("Previous description restored in Shopify.");
      } catch (e) {
        if (t) t.show("Could not restore the previous description.");
      }
    });
    // ---------------------------------------------------------------- agent runs (media is billed like every other agent run)
    _defineProperty(this, "runAgent", async (agent, userMessage, parameters) => {
      const base = String(endpoints.product.root || "");
      const h = await bearerHeaders();
      h["content-type"] = "application/json";
      const r = await fetch(`${base}/agent/run`, {
        method: "POST",
        headers: h,
        body: JSON.stringify({
          agent,
          instruction: userMessage,
          parameters
        })
      });
      const text = await r.text();
      let j = {};
      try {
        j = JSON.parse(text);
      } catch (e) {/* not json */}
      if (r.status === 402) {
        const e = new Error(j && j.error || "Out of generation credits.");
        e.outOfCredits = true;
        throw e;
      }
      if (!r.ok) throw new Error(j && j.error || `Agent run failed (${r.status})`);
      return j;
    });
    // 402 from the agent API = the workspace's generation credits are spent: point at Billing & Usage (packs) instead of a dead end.
    _defineProperty(this, "creditsToast", (e, fallback) => {
      const t = document.querySelector("paper-toast");
      if (e && e.outOfCredits) {
        this.setState({
          outOfCredits: true
        });
        if (t) t.show("Out of generation credits: add a credit pack under Billing & Usage (account.plunk.io).");
        return;
      }
      if (t) t.show(e && e.message || fallback);
    });
    _defineProperty(this, "creditsNote", cost => {
      return null; // DS 2026-10-01: no credit amounts or balances anywhere in the UX
      const c = this.state.credits;
      if (c === null || typeof c === "undefined") return null;
      const low = c < cost;
      return /*#__PURE__*/React.createElement(React.Fragment, null, " ", /*#__PURE__*/React.createElement("span", {
        style: {
          color: low ? "var(--plk-danger-text)" : undefined,
          fontWeight: low ? 700 : 400
        }
      }, Math.floor(c), " credit", c === 1 ? "" : "s", " left", this.state.creditsLevel ? ` of ${this.state.creditsLevel}/mo` : ""), low && /*#__PURE__*/React.createElement(React.Fragment, null, " \xB7 ", /*#__PURE__*/React.createElement("a", {
        href: "https://account.plunk.io/?from=app",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Add credits \u2197")));
    });
    _defineProperty(this, "loadCredits", async () => {
      try {
        const s = await getBillingStatus(false);
        if (s && this._alive && typeof (s.creditBalance ?? s.balance) !== "undefined") this.setState({
          credits: Number(s.creditBalance ?? s.balance),
          creditsLevel: s.monthlyCredits != null ? Number(s.monthlyCredits) : null
        });
      } catch (e) {/* unknown */}
    });
    _defineProperty(this, "waitAgent", async (runId, everyMs, maxTries) => {
      const base = String(endpoints.product.root || "");
      for (let i = 0; i < maxTries && this._alive; i++) {
        await new Promise(res => setTimeout(res, everyMs));
        try {
          const h = await bearerHeaders();
          const r = await fetch(`${base}/agent/run/${encodeURIComponent(runId)}`, {
            headers: h
          });
          const run = await r.json();
          const status = String(run.status || run.Status || "").toLowerCase();
          if (status === "completed" || status === "complete" || status === "succeeded" || status === "success") {
            let ctx = {};
            try {
              ctx = JSON.parse(run.contextOutput || run.ContextOutput || "{}");
            } catch (e) {/* ignore */}
            let res = {};
            try {
              res = JSON.parse(run.runResult || run.RunResult || "{}");
            } catch (e) {/* ignore */}
            return {
              ok: true,
              ctx,
              res,
              run
            };
          }
          if (status === "failed" || status === "error" || status === "cancelled") return {
            ok: false,
            run
          };
        } catch (e) {/* retry */}
      }
      return {
        ok: false,
        timeout: true
      };
    });
    // Story-level media (2026-09-27): every member's blocks feed the prompt and the image picker; the result is
    // attached to the story's primary piece (the story id IS the primary container id).
    _defineProperty(this, "openStoryMedia", async (s, kind) => {
      const t = document.querySelector("paper-toast");
      const blocks = [];
      const variants = [];
      for (const m of s.members) {
        try {
          const d = await svc(`/content/containers/detail/${String(m.id)}`).getAsync();
          (d && d.blocks || []).forEach(b => blocks.push(b));
          (d && d.variants || []).forEach(v => variants.push(v));
        } catch (e) {/* skip */}
      }
      if (!blocks.length && !variants.length && t) t.show("The story's pieces have no content yet: add copy or images to a piece first.");
      const ctx = {
        containerId: String(s.storyId),
        title: s.title || "Story",
        blocks,
        variants,
        story: true,
        storyId: s.storyId
      };
      this.setState({
        storyMedia: ctx,
        storyRepurpose: null,
        storyPublish: null
      });
      if (kind === "image") await this.openImageGen(ctx);else await this.openVideo(ctx);
    });
    // ---------------------------------------------------------------- image generation (image_generator_agent · 6 credits, credit_price "image")
    _defineProperty(this, "openImageGen", async ctxArg => {
      const ctx = ctxArg && ctxArg.blocks ? ctxArg : this.state.detail ? {
        containerId: String(this.state.detail.container.id),
        title: this.state.detail.container.title || "",
        blocks: this.state.detail.blocks || [],
        story: false
      } : null;
      if (!ctx) return;
      const text = this.ctxText(ctx, " ");
      const prompt = `Lifestyle photo for "${ctx.title}". ${text.slice(0, 500)}`.trim();
      let assets = this.state.assetsPick;
      if (!assets.length) {
        try {
          const r = await svc("/content/assets?kind=image&$top=60").getAsync();
          assets = r && r.items || [];
        } catch (e) {/* none */}
      }
      this.setState({
        imageOpen: true,
        videoOpen: false,
        imagePrompt: prompt,
        assetsPick: assets,
        imageRef: this.firstImage({
          blocks: ctx.blocks
        }) || "",
        storyMedia: ctx.story ? ctx : null
      });
      this.loadCredits();
    });
    _defineProperty(this, "makeImage", async () => {
      const ctx = this.mediaCtx();
      const t = document.querySelector("paper-toast");
      if (!ctx) return;
      this.setState({
        imageBusy: true
      });
      try {
        const first = this.firstImage({
          blocks: ctx.blocks
        });
        const refs = this.state.imageRef ? [this.state.imageRef] : first ? [first] : [];
        if (!refs.length) {
          this.setState({
            imageBusy: false
          });
          if (t) t.show("Pick a reference image first: the image agent grounds the result in it.");
          return;
        }
        const r = await this.runAgent("image_generator_agent", this.state.imagePrompt, {
          imageUrls: refs,
          aspectRatio: this.state.imageAspect,
          count: "1",
          resolution: "2k"
        });
        const id = r && (r.runId || r.id || r.agentRunId || r.Id);
        this.setState({
          imageBusy: false,
          imageOpen: false,
          imageJob: {
            id,
            containerId: ctx.containerId
          }
        });
        if (t) t.show(`Image agent running (6 credits): it lands in ${ctx.story ? "the story's primary piece" : "Blocks"} and Assets in under a minute.`);
        const done = await this.waitAgent(id, 6000, 40);
        const urls = done.ok && (done.ctx && done.ctx.urls || done.res && done.res.urls) || [];
        if (urls.length) await this.attachImage(urls[0], ctx.containerId, ctx.title);else {
          this.setState({
            imageJob: null
          });
          if (t) t.show(done.timeout ? "Still rendering: check Blocks in a minute." : "The image agent could not produce an image.");
        }
      } catch (e) {
        this.setState({
          imageBusy: false
        });
        this.creditsToast(e, "Could not start the image.");
      }
    });
    _defineProperty(this, "attachImage", async (url, containerId, title) => {
      try {
        const a = await svc("/content/assets").postAsync({
          kind: "image",
          url,
          title: `Generated · ${title || this.state.detail && this.state.detail.container.title || ""}`,
          source: "plunk_image",
          altText: (this.state.imagePrompt || "").slice(0, 125)
        });
        if (a && (a.id || a.Id)) await svc(`/content/assets/${String(a.id || a.Id)}/link`).postAsync({
          containerId,
          role: "generated"
        });
        await svc(`/content/containers/${containerId}/blocks`).postAsync({
          kind: "image_ref",
          body: url,
          assetRef: url
        });
      } catch (e) {/* visible on next reload */}
      const t = document.querySelector("paper-toast");
      if (t) t.show("Image ready: it's in Assets and on the piece.");
      this.setState({
        imageJob: null,
        storyMedia: null
      });
      if (this.state.detail) this.reloadDetail();else this.load();
    });
    // ---------------------------------------------------------------- video (existing media pipeline)
    _defineProperty(this, "openVideo", async ctxArg => {
      const ctx = ctxArg && ctxArg.blocks ? ctxArg : this.state.detail ? {
        containerId: String(this.state.detail.container.id),
        title: this.state.detail.container.title || "",
        blocks: this.state.detail.blocks || [],
        story: false
      } : null;
      if (!ctx) return;
      const text = this.ctxText(ctx, "\n\n");
      const prompt = `${ctx.title}\n\n${text}`.slice(0, 4000);
      let assets = [];
      try {
        const r = await svc("/content/assets?kind=image&$top=60").getAsync();
        assets = r && r.items || [];
      } catch (e) {/* none */}
      // Video clips (Veo renders, uploads) can be scenes too: the motion engine scales them to cover.
      try {
        const v = await svc("/content/assets?kind=video&$top=20").getAsync();
        assets = assets.concat((v && v.items || []).map(a => ({
          ...a,
          kind: "video"
        })));
      } catch (e) {/* none */}
      // The pieces' own images lead the picker, then the asset library.
      const own = (ctx.blocks || []).filter(b => /image/i.test(b.kind || "")).map(b => ({
        id: "b" + b.id,
        url: b.assetRef || b.body,
        title: ctx.title
      })).filter(a => a.url && !assets.some(x => x.url === a.url));
      assets = own.concat(assets);
      // R2: the last storyboard for this piece comes back for editing instead of starting over.
      let storyboard = null;
      const sb = (ctx.blocks || []).filter(b => String(b.kind || "") === "storyboard").sort((a, b) => (Number(b.version) || 0) - (Number(a.version) || 0))[0]; // newest version (list is kind, version DESC)
      if (sb) {
        try {
          const j = JSON.parse(sb.body || "{}");
          storyboard = Array.isArray(j.scenes) ? j.scenes : Array.isArray(j) ? j : null;
        } catch (e) {
          storyboard = null;
        }
      }
      this.setState({
        videoOpen: true,
        imageOpen: false,
        videoPrompt: prompt,
        assetsPick: assets,
        videoImages: [],
        storyboard,
        storyMedia: ctx.story ? ctx : null,
        videoTitle: ctx.title || ""
      });
      this.loadCredits();
      this.resumeVideoJob(ctx.containerId);
    });
    // A render can outlive the page (minutes): the run id is kept per piece so reopening the panel resumes the wait and
    // still attaches the result instead of orphaning it.
    _defineProperty(this, "resumeVideoJob", async containerId => {
      let id = null;
      try {
        id = localStorage.getItem("plunk-video-job:" + containerId);
      } catch (e) {/* private mode */}
      if (!id || this.state.videoJob) return;
      this.setState({
        videoJob: {
          id,
          containerId
        }
      });
      const done = await this.waitAgent(id, 15000, 80);
      if (!this._alive) return;
      const url = done.ok && (done.ctx && done.ctx.videoUrl || done.res && done.res.videoUrl);
      if (url) await this.attachVideo(url, containerId, null, done);else if (!done.timeout) {
        try {
          localStorage.removeItem("plunk-video-job:" + containerId);
        } catch (e) {/* ignore */}
        this.setState({
          videoJob: null
        });
      }
    });
    _defineProperty(this, "writeStoryboard", async () => {
      const t = document.querySelector("paper-toast");
      const ctx = this.mediaCtx();
      const first = ctx ? this.firstImage({
        blocks: ctx.blocks
      }) : null;
      const images = this.state.videoImages.length ? this.state.videoImages : first ? [first] : [];
      if (!images.length) {
        if (t) t.show("Pick at least one image for the scenes.");
        return;
      }
      this.setState({
        storyboardBusy: true
      });
      try {
        const r = await this.runAgent("content_storyboard_agent", this.state.videoPrompt, {
          imageUrls: images,
          aspectRatio: this.state.videoAspect
        });
        const id = r && (r.runId || r.id || r.agentRunId || r.Id);
        const done = await this.waitAgent(id, 4000, 45);
        let scenes = done.ok && (done.ctx && done.ctx.scenes || done.res && done.res.scenes);
        if (!scenes && done.ok) {
          const raw = done.run && (done.run.runResult || done.run.RunResult) || "";
          try {
            const j = JSON.parse(raw.replace(/^```(json)?|```$/g, "").trim());
            scenes = j.scenes || j;
          } catch (e) {
            scenes = null;
          }
        }
        if (typeof scenes === "string") {
          try {
            scenes = JSON.parse(scenes);
          } catch (e) {
            scenes = null;
          }
        }
        if (Array.isArray(scenes) && scenes.length) this.setState({
          storyboard: scenes.map(sc => ({
            imageUrl: sc.imageUrl || sc.image || images[0],
            narration: sc.narration || sc.script || ""
          }))
        });else if (t) t.show(done.timeout ? "Still writing: try again in a moment." : "The storyboard agent returned nothing usable.");
      } catch (e) {
        this.creditsToast(e, "Could not start the storyboard.");
      } finally {
        if (this._alive) this.setState({
          storyboardBusy: false
        });
      }
    });
    _defineProperty(this, "makeVideo", async () => {
      const ctx = this.mediaCtx();
      const t = document.querySelector("paper-toast");
      if (!ctx) return;
      this.setState({
        videoBusy: true
      });
      try {
        const first = this.firstImage({
          blocks: ctx.blocks
        });
        const images = this.state.videoImages.length ? this.state.videoImages : first ? [first] : [];
        if (!images.length) {
          this.setState({
            videoBusy: false
          });
          if (t) t.show("Pick at least one image for the scenes.");
          return;
        }
        const sb = (this.state.storyboard || []).filter(sc => sc.imageUrl && (sc.narration || "").trim());
        const recipe = this.state.videoRecipe || "promo";
        const acct = getAccount() || {};
        const params = {
          imageUrls: images,
          aspectRatio: this.state.videoAspect,
          voice: this.state.videoVoice || "Joanna",
          recipe,
          captions: this.state.videoCaptions ? "true" : "false",
          musicUrl: (this.state.videoMusic || "").trim() || undefined,
          titleText: recipe === "promo" ? (this.state.videoTitle || "").trim() || ctx.title || undefined : undefined,
          titleSub: recipe === "promo" ? (this.state.videoTitleSub || "").trim() || undefined : undefined,
          endText: recipe === "promo" || recipe === "product_tour" ? (this.state.videoEnd || "").trim() || undefined : undefined,
          endSub: recipe === "promo" || recipe === "product_tour" ? (this.state.videoEndSub || "").trim() || undefined : undefined,
          brandName: acct.account || acct.name || undefined
        };
        Object.keys(params).forEach(k => {
          if (params[k] === undefined) delete params[k];
        });
        if (sb.length) {
          params.scenes = JSON.stringify(sb.map(sc => ({
            imageUrl: sc.imageUrl,
            narration: sc.narration.trim(),
            overlayText: (sc.overlayText || "").trim() || undefined
          })));
          try {
            await svc(`/content/containers/${ctx.containerId}/blocks`).postAsync({
              kind: "storyboard",
              body: JSON.stringify({
                scenes: sb,
                aspectRatio: this.state.videoAspect,
                recipe
              })
            });
          } catch (e) {/* keeps rendering */}
        }
        const r = await this.runAgent("content_video_agent", this.state.videoPrompt, params);
        const id = r && (r.runId || r.id || r.agentRunId || r.Id);
        try {
          if (id) localStorage.setItem("plunk-video-job:" + ctx.containerId, String(id));
        } catch (e) {/* private mode */}
        this.setState({
          videoBusy: false,
          videoOpen: false,
          videoJob: {
            id,
            containerId: ctx.containerId
          }
        });
        if (t) t.show(`Video agent running (10 credits): rendering takes a few minutes; it lands ${ctx.story ? "on the story's primary piece" : "here"} as a video variant.`);
        const done = await this.waitAgent(id, 15000, 80);
        const url = done.ok && (done.ctx && done.ctx.videoUrl || done.res && done.res.videoUrl);
        if (url) await this.attachVideo(url, ctx.containerId, ctx.title, done);else if (done.timeout) {
          if (t) t.show("Still rendering: reopen this piece later and it attaches itself.");
        } else {
          this.setState({
            videoJob: null
          });
          try {
            localStorage.removeItem("plunk-video-job:" + ctx.containerId);
          } catch (e) {/* ignore */}
          if (t) t.show("The video agent could not render this piece.");
        }
      } catch (e) {
        this.setState({
          videoBusy: false
        });
        this.creditsToast(e, "Could not start the video.");
      }
    });
    _defineProperty(this, "attachVideo", async (url, containerId, title, done) => {
      const name = title || this.state.detail && this.state.detail.container.title || "Video";
      const meta = done && ((done.ctx && done.ctx.posterUrl ? done.ctx : null) || done.res) || {};
      try {
        localStorage.removeItem("plunk-video-job:" + containerId);
      } catch (e) {/* ignore */}
      try {
        const a = await svc("/content/assets").postAsync({
          kind: "video",
          url,
          title: `Video · ${name}`,
          source: "plunk_video",
          posterUrl: meta.posterUrl || undefined,
          durationSeconds: meta.durationSeconds || undefined
        });
        const variant = await svc(`/content/containers/${containerId}/variants`).postAsync({
          channel: "video",
          title: name,
          body: (this.state.videoPrompt || "").split("\n")[0],
          status: "draft"
        });
        const vid = variant && (variant.id || variant.Id);
        if (a && (a.id || a.Id) && vid) await svc(`/content/assets/${String(a.id || a.Id)}/link`).postAsync({
          containerId,
          variantId: String(vid),
          role: "video"
        });
        await svc(`/content/containers/${containerId}/blocks`).postAsync({
          kind: "video_ref",
          body: `variant:${vid}`,
          assetRef: url
        });
      } catch (e) {/* recorded next reload */}
      const t = document.querySelector("paper-toast");
      if (t) t.show("Video ready: it's a video variant on the piece and in Assets.");
      this.setState({
        videoJob: null,
        storyMedia: null
      });
      if (this.state.detail) this.reloadDetail();else this.load();
    });
    _defineProperty(this, "toggleLibrarySel", id => {
      const s = new Set(this.state.librarySel);
      const k = String(id);
      if (s.has(k)) s.delete(k);else s.add(k);
      this.setState({
        librarySel: s
      });
    });
    // §312 merge selected pieces into a story (the primary = the first selected;
    // its title names the story). /stories/merge is the curation rail the grouped
    // library sits on; a story = containers sharing story_id.
    _defineProperty(this, "groupSelected", async () => {
      const ids = [...this.state.librarySel]; // full-precision id strings (JSONbig)
      if (ids.length < 2) return;
      this.setState({
        libraryBusy: true
      });
      const t = document.querySelector("paper-toast");
      try {
        // Container ids exceed 2^53 — Number() would corrupt them. Build the
        // JSON body with the ids as unquoted number literals; postAsync sends
        // a string body verbatim (no re-stringify), preserving precision.
        const body = `{"containerIds":[${ids.join(",")}],"primaryId":${ids[0]}}`;
        await svc("/content/stories/merge").postAsync(body);
        if (t) t.show(`Merged ${ids.length} pieces into a story.`);
        this.setState({
          librarySelect: false,
          librarySel: new Set(),
          libraryBusy: false
        });
        this.load();
      } catch (e) {
        if (t) t.show(e.message || "Couldn't merge those pieces.");
        this.setState({
          libraryBusy: false
        });
      }
    });
    // Ungroup a story = split every member back out (SplitStory removes one
    // container from its story; do it for each to dissolve the group).
    _defineProperty(this, "ungroupStory", async members => {
      this.setState({
        libraryBusy: true
      });
      const t = document.querySelector("paper-toast");
      try {
        for (const c of members) await svc("/content/stories/split").postAsync(`{"containerId":${String(c.id)}}`);
        if (t) t.show("Story ungrouped.");
        this.setState({
          libraryBusy: false
        });
        this.load();
      } catch (e) {
        if (t) t.show(e.message || "Couldn't ungroup.");
        this.setState({
          libraryBusy: false
        });
      }
    });
    // Repurpose FROM a story — repurpose the primary; the backend grounds the
    // generation on EVERY story member's blocks (Service.Activity 1.0.116).
    _defineProperty(this, "repurposeStory", async primaryId => {
      const chans = [...this.state.storyRepurposeSel];
      if (!primaryId || !chans.length) return;
      this.setState({
        storyRepurposeBusy: true
      });
      const t = document.querySelector("paper-toast");
      try {
        // The story's media bundle rides with every draft (hero = newest image asset in the story).
        let assetIds = [];
        try {
          const r = await svc(`/content/stories/${String(primaryId)}/assets?kind=image&$top=6`).getAsync();
          assetIds = (r && r.items || []).map(a => String(a.id));
        } catch (e) {/* no bundle */}
        await svc(`/content/containers/${String(primaryId)}/repurpose`).postAsync({
          channels: chans,
          assetIds
        });
        if (t) t.show("Repurposing the story: grounded drafts land as variants within a few minutes.");
        this.setState({
          storyRepurpose: null,
          storyRepurposeSel: new Set(),
          storyRepurposeBusy: false
        });
      } catch (e) {
        if (t) t.show(e && e.message || "Repurpose failed.");
        this.setState({
          storyRepurposeBusy: false
        });
      }
    });
    // Reusable text-filter box (Library / Stories / Assets).
    _defineProperty(this, "searchBox", (placeholder, style) => /*#__PURE__*/React.createElement("input", {
      className: "cust-search wa-search",
      type: "search",
      value: this.state.search,
      placeholder: placeholder || "Search…",
      onChange: e => this.setState({
        search: e.target.value
      }),
      style: style || undefined
    }));
    // ---- Asset library / DAM (CONTENT_HUB_NEXT §1) ----
    _defineProperty(this, "loadAssets", async () => {
      if (this.state.assetKind === "trash" || this.state.assetKind === "sequences") {
        if (this._alive) this.setState({
          assets: []
        });
        return;
      }
      // Every kind in one load (the server caps a page at 200, newest first); the type pills, Show and Sort filter it here.
      const d = await safe(svc("/content/assets?$top=200").getAsync(), {
        items: []
      });
      if (this._alive) this.setState({
        assets: d && d.items || []
      }, () => this.queuePosters());
      // Tier 3 (2026-10-01): describe + embed assets that are not indexed yet (a few per visit; cost recorded), then refresh.
      if (!this._assetIndexKicked) {
        this._assetIndexKicked = true;
        safe(svc("/content/assets/index?max=12").postAsync({}), null).then(r => {
          if (r && this._alive && (r.described || 0) + (r.embedded || 0) > 0 && !this.state.search) this.loadAssets();
        });
      }
    });
    // Upload (2026-10-01): presigned PUT straight to S3 (no size limit from the API), then register the public URL.
    _defineProperty(this, "uploadFiles", async files => {
      const list = Array.from(files || []).slice(0, 20);
      if (!list.length) return;
      const t = document.querySelector("paper-toast");
      this.setState({
        uploadBusy: true,
        uploadNote: ""
      });
      let okCount = 0;
      for (let i = 0; i < list.length; i++) {
        const f = list[i];
        try {
          this.setState({
            uploadNote: `Uploading ${i + 1} of ${list.length}: ${f.name}`
          });
          const pre = await svc("/content/assets/upload-url").postAsync({
            fileName: f.name,
            contentType: f.type || "application/octet-stream",
            bytes: f.size
          });
          if (!pre || !pre.uploadUrl) throw new Error(pre && pre.error || "Could not prepare the upload.");
          await new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open("PUT", pre.uploadUrl, true);
            xhr.setRequestHeader("content-type", pre.contentType || f.type || "application/octet-stream");
            xhr.upload.onprogress = e => {
              if (e.lengthComputable && this._alive) this.setState({
                uploadNote: `Uploading ${i + 1} of ${list.length}: ${f.name} · ${Math.round(e.loaded / e.total * 100)}%`
              });
            };
            xhr.onload = () => xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new Error(`Upload failed (${xhr.status})`));
            xhr.onerror = () => reject(new Error("Upload failed (network)"));
            xhr.send(f);
          });
          let durationSeconds = null;
          if (pre.kind === "video") {
            try {
              durationSeconds = await new Promise(res => {
                const v = document.createElement("video");
                v.preload = "metadata";
                v.onloadedmetadata = () => {
                  res(Math.round(v.duration || 0));
                  URL.revokeObjectURL(v.src);
                };
                v.onerror = () => res(null);
                v.src = URL.createObjectURL(f);
              });
            } catch (e) {
              durationSeconds = null;
            }
          }
          await svc("/content/assets").postAsync({
            kind: pre.kind,
            url: pre.url,
            title: f.name.replace(/\.[a-z0-9]+$/i, ""),
            source: "upload",
            durationSeconds
          });
          okCount++;
        } catch (e) {
          if (t) t.show(`${f.name}: ${e && e.message || "upload failed"}`);
        }
      }
      if (this._alive) {
        this.setState({
          uploadBusy: false,
          uploadNote: ""
        });
        this._assetIndexKicked = false;
        this.loadAssets();
      }
      if (t && okCount) t.show(`${okCount} file${okCount === 1 ? "" : "s"} added to the library.`);
    });
    // Brand library (Plunk DAM, 2026-10-27): save an asset to it; pick from it (brand-library.jsx).
    _defineProperty(this, "saveToBrandLibrary", async a => {
      const t = document.querySelector("paper-toast");
      this.setState({
        asMenu: null
      });
      try {
        const r = await damSaveFromContent(a.id);
        if (t) t.show(r && r.duplicate ? "Already in the brand library." : "Saved to the brand library.");
      } catch (e) {
        if (t) t.show(`Couldn't save it: ${e && e.data && e.data.error || e && e.message || "error"}`);
      }
    });
    // Bulk delete: each picked asset goes to Trash with its versions (references kept; use the single-asset sheet to replace).
    _defineProperty(this, "deletePicked", async () => {
      const picked = this.pickedAssets();
      if (!picked.length) return;
      this.setState({
        bulkBusy: true
      });
      let n = 0;
      for (const a of picked) {
        try {
          await svc(`/content/assets/${String(a.id)}?replaceWithLatest=false`).deleteAsync();
          n++;
        } catch (e) {/* keep going */}
      }
      const t = document.querySelector("paper-toast");
      if (t) t.show(`${n} file${n === 1 ? "" : "s"} moved to Trash. You can restore ${n === 1 ? "it" : "them"} within 30 days.`);
      this.setState({
        bulkBusy: false,
        bulkMode: false,
        bulkPicked: {}
      }, () => this.loadAssets());
    });
    // Conversational search: the words you would use to describe the asset ("our best seller on a white background").
    _defineProperty(this, "searchAssets", q => {
      clearTimeout(this._assetSearchTimer);
      if (!q || q.trim().length < 3) {
        this.setState({
          assetSearch: null,
          assetSearchBusy: false
        });
        return;
      }
      this.setState({
        assetSearchBusy: true
      });
      this._assetSearchTimer = setTimeout(async () => {
        const kind = this.state.asType || ""; // Show (edited, not used, …) filters the results client-side
        const d = await safe(svc(`/content/assets/search?q=${encodeURIComponent(q.trim())}${kind ? `&kind=${kind}` : ""}&$top=40`).getAsync(), null);
        if (this._alive && (this.state.search || "").trim() === q.trim()) this.setState({
          assetSearch: d && d.items ? d.items : [],
          assetSearchBusy: false
        });
      }, 450);
    });
    // Showcase (Tier 3): a public gallery page of the picked assets on share.plunk.io (a board: branded, expires, view count).
    _defineProperty(this, "createShowcase", async () => {
      const picked = this.pickedAssets().filter(a => a.kind === "image");
      if (!picked.length) return;
      this.setState({
        showcaseBusy: true,
        showcaseUrl: null
      });
      const t = document.querySelector("paper-toast");
      try {
        const res = await fetch("https://share.plunk.io/v1/board", {
          method: "POST",
          headers: {
            ...shareAuthHeaders(),
            "content-type": "application/json"
          },
          body: JSON.stringify({
            title: `Pictures · ${new Date().toLocaleDateString()}`,
            items: picked.map(a => ({
              renderUrl: a.latestUrl || a.url,
              title: a.title || ""
            })),
            expiresDays: 30,
            reviewEnabled: false
          })
        });
        const d = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(d.error || `Showcase failed (${res.status})`);
        this.setState({
          showcaseUrl: d.url,
          showcaseBusy: false
        });
        if (t) t.show("Link ready.");
      } catch (e) {
        if (t) t.show(e && e.message || "Could not make the link.");
        this.setState({
          showcaseBusy: false
        });
      }
    });
    _defineProperty(this, "addAsset2", async () => {
      const url = (this.state.newAssetUrl || "").trim();
      if (!url) return;
      this.setState({
        assetBusy: true
      });
      const t = document.querySelector("paper-toast");
      try {
        await svc("/content/assets").postAsync({
          url
        });
        if (t) t.show("Asset added to the library.");
        this.setState({
          newAssetUrl: "",
          assetBusy: false
        }, () => this.loadAssets());
      } catch (e) {
        if (t) t.show(e && e.message || "Could not add the asset.");
        this.setState({
          assetBusy: false
        });
      }
    });
    // Tier 2 (2026-10-01): a bulk edit is a proposal in the Autopilot content lane; approving it there runs
    // content_bulk_edit_agent over the set and stacks one version per asset.
    _defineProperty(this, "proposeBulk", async () => {
      const picked = this.pickedAssets().filter(a => a.kind === "image");
      if (!picked.length) return;
      const action = BULK_ACTIONS.find(x => x[0] === this.state.bulkAction) || BULK_ACTIONS[0];
      this.setState({
        bulkBusy: true
      });
      const t = document.querySelector("paper-toast");
      try {
        // Brand-kit values travel in the proposal so the run matches what Edit Mode would do for one image.
        const kit = (await loadBrandKit()) || {};
        const logoIsSvg = !!(kit.logoUrl && /\.svg(\?|$)/i.test(kit.logoUrl));
        const params = {};
        if (action[0] === "badge") {
          params.text = (this.bulkText || this.state.bulkText || "SALE").trim();
          if (kit.accent) params.bgHex = kit.accent;
          params.textHex = "#ffffff";
          params.position = "top_left";
        }
        if (action[0] === "overlay_logo") {
          if (!kit.logoUrl || logoIsSvg) {
            if (t) t.show(logoIsSvg ? "The brand kit logo is an SVG: upload a PNG logo under Settings → Brand kit first." : "Add a logo under Settings → Brand kit first.");
            this.setState({
              bulkBusy: false
            });
            return;
          }
          params.logoUrl = kit.logoUrl;
          params.position = "bottom_right";
          params.scale = "0.18";
        }
        if (action[0] === "brand_background") {
          if (!kit.accent) {
            if (t) t.show("Set an accent color under Settings → Brand kit first.");
            this.setState({
              bulkBusy: false
            });
            return;
          }
          params.mode = kit.accent;
        }
        if (action[0] === "packshot") params.mode = "white";
        const body = {
          kind: "bulk_image_edit",
          rule: "bulk_image_edit",
          title: `${BULK_LABELS[action[0]] || action[1]} on ${picked.length} picture${picked.length === 1 ? "" : "s"}`,
          rationale: `Proposed from Assets: ${action[1].toLowerCase()} applied to ${picked.length} selected image${picked.length === 1 ? "" : "s"}. Each result is saved as a new version under its original; nothing is published.`,
          payload: {
            action: action[0],
            params,
            assets: picked.map(a => ({
              assetId: String(a.id),
              url: a.latestUrl || a.url,
              title: a.title || ""
            }))
          },
          dedupeKey: `bulk:${action[0]}:${picked.map(a => String(a.id)).sort().join(",").slice(0, 100)}`
        };
        const r = await autopilotSvc("/recommendations").postAsync(body);
        if (t) t.show(r && r.id ? "Sent for approval: approve it in Autopilot, Content, and each picture gets a new version." : "Sent for approval.");
        this.setState({
          bulkMode: false,
          bulkPicked: {},
          bulkBusy: false
        });
      } catch (e) {
        if (t) t.show(e && e.message || "Could not send the edit for approval.");
        this.setState({
          bulkBusy: false
        });
      }
    });
    // ---- Assets tab (redesign 2026-10-09, DS mockups assetflow Main + Select). Scoped under .as-view (sass/v2/_assets.scss).
    // One load (all kinds, up to 200 newest roots); the type pills, Show and Sort work client-side over it.
    _defineProperty(this, "assetPool", () => {
      const m = new Map();
      [...(this.state.assets || []), ...(this.state.assetSearch || [])].forEach(a => {
        if (a && a.id != null) m.set(String(a.id), a);
      });
      return m;
    });
    _defineProperty(this, "pickedAssets", () => {
      const pool = this.assetPool();
      const p = this.state.bulkPicked || {};
      return Object.keys(p).filter(k => p[k]).map(k => pool.get(k)).filter(Boolean);
    });
    // Videos without a poster: grab the first frame in the browser, upload it, record it. At most 4 at once, once per
    // asset per session, silent; any failure (CORS, codec, timeout) leaves the placeholder tile.
    _defineProperty(this, "queuePosters", () => {
      if (!this._alive) return;
      this._posterActive = this._posterActive || 0;
      const todo = (this.state.assets || []).filter(a => a && a.kind === "video" && !a.posterUrl && a.url && !POSTER_TRIED.has(String(a.id)));
      while (this._posterActive < 4 && todo.length) {
        const a = todo.shift();
        POSTER_TRIED.add(String(a.id));
        this._posterActive++;
        this.makePoster(a).catch(() => {/* placeholder stays */}).then(() => {
          this._posterActive--;
          this.queuePosters();
        });
      }
    });
    _defineProperty(this, "makePoster", async a => {
      const blob = await grabFirstFrame(a.url);
      const pre = await svc("/content/assets/upload-url").postAsync({
        fileName: `poster-${String(a.id)}.jpg`,
        contentType: "image/jpeg",
        bytes: blob.size
      });
      if (!pre || !pre.uploadUrl || !pre.url) throw new Error("no upload url");
      const put = await fetch(pre.uploadUrl, {
        method: "PUT",
        headers: {
          "content-type": pre.contentType || "image/jpeg"
        },
        body: blob
      });
      if (!put.ok) throw new Error(`poster upload ${put.status}`);
      await svc(`/content/assets/${String(a.id)}/poster`).postAsync({
        posterUrl: pre.url
      });
      if (this._alive) this.setState(s => ({
        assets: (s.assets || []).map(x => String(x.id) === String(a.id) ? {
          ...x,
          posterUrl: pre.url
        } : x)
      }));
    });
    // Download one file after another. Cross-origin links ignore `download`, so fetch each as a blob and save it through an
    // object URL; when the file host refuses the fetch, open it in a tab instead.
    _defineProperty(this, "downloadAssets", async list => {
      const files = (list || []).filter(a => a && (a.latestUrl || a.url));
      if (!files.length) return;
      this.setState({
        asDlBusy: true,
        asMenu: null
      });
      for (const a of files) {
        const url = a.latestUrl || a.url;
        const ext = (/\.([a-z0-9]{2,5})(?:[?#]|$)/i.exec(url) || [])[1] || (a.kind === "video" ? "mp4" : a.kind === "doc" ? "pdf" : "jpg");
        const base = String(a.title || "").replace(/[\\/:*?"<>|]+/g, " ").trim().slice(0, 80) || (a.kind === "video" ? "video" : a.kind === "doc" ? "document" : "image");
        try {
          const r = await fetch(url, {
            mode: "cors"
          });
          if (!r.ok) throw new Error(String(r.status));
          const o = URL.createObjectURL(await r.blob());
          const el = document.createElement("a");
          el.href = o;
          el.download = `${base}.${ext}`;
          el.style.display = "none";
          document.body.appendChild(el);
          el.click();
          el.remove();
          setTimeout(() => URL.revokeObjectURL(o), 5000);
        } catch (e) {
          window.open(url, "_blank", "noopener");
        }
        await new Promise(res => setTimeout(res, 350));
      }
      if (this._alive) this.setState({
        asDlBusy: false
      });
    });
    _defineProperty(this, "copyAssetLink", a => {
      this.setState({
        asMenu: null
      });
      try {
        navigator.clipboard.writeText(a.latestUrl || a.url);
        toast("Link copied.");
      } catch (e) {
        toast("Could not copy the link.");
      }
    });
    _defineProperty(this, "showAsNote", (text, pieceId) => {
      clearTimeout(this._asNoteT);
      this.setState({
        asNote: {
          text,
          pieceId: pieceId || null
        }
      });
      this._asNoteT = setTimeout(() => {
        if (this._alive) this.setState({
          asNote: null
        });
      }, 10000);
    });
    // "Add to a piece": link each asset to the chosen piece as a source. Ids go as strings (they exceed 2^53).
    _defineProperty(this, "linkAssetsToPiece", async piece => {
      const ids = this.state.asAddPiece && this.state.asAddPiece.ids || [];
      if (!ids.length || this.state.asAddBusy) return;
      const cid = String(piece.id);
      this.setState({
        asAddBusy: true
      });
      let ok = 0;
      for (const id of ids) {
        try {
          await svc(`/content/assets/${id}/link`).postAsync({
            containerId: cid,
            role: "source"
          });
          ok++;
        } catch (e) {/* keep going */}
      }
      const title = cleanTitle(piece.title) || "the piece";
      if (!this._alive) return;
      this.setState({
        asAddBusy: false,
        asAddPiece: null,
        asPieceQ: ""
      });
      this.showAsNote(ok === ids.length ? `Added to ${title}.` : ok ? `${ok} of ${ids.length} added to ${title}.` : `Could not add to ${title}.`, ok ? cid : null);
      if (ok) this.loadAssets();
    });
    _defineProperty(this, "useInNewStory", () => {
      const ids = this.pickedAssets().filter(a => a.kind === "image" || a.kind === "video").map(a => String(a.id)).slice(0, 20);
      if (!ids.length) {
        toast("Pick pictures or videos to start a story with.");
        return;
      }
      this.props.history.push(`/Content/build/new?assets=${ids.join(",")}`);
    });
    // Descriptions for just the picked images that have none (one agent run each).
    _defineProperty(this, "describePicked", async () => {
      const list = this.pickedAssets().filter(a => a.kind === "image" && !a.altText);
      this.setState({
        asEditMenu: false
      });
      if (!list.length) {
        toast("Every picked image already has a description.");
        return;
      }
      toast(`Writing ${list.length} description${list.length === 1 ? "" : "s"}…`);
      for (const a of list) {
        await this.writeAlt(a);
        if (!this._alive) return;
      }
    });
    _defineProperty(this, "hideDescBanner", () => {
      try {
        sessionStorage.setItem("plk-as-desc-hidden", "1");
      } catch (e) {/* private window */}
      this.setState({
        asDescHidden: true
      });
    });
    _defineProperty(this, "descBannerHidden", () => {
      if (this.state.asDescHidden) return true;
      try {
        return sessionStorage.getItem("plk-as-desc-hidden") === "1";
      } catch (e) {
        return false;
      }
    });
    _defineProperty(this, "openAssetEditor", a => {
      const id = String(a.id);
      if (a.kind === "image") this.props.history.push(`/Content/images/${id}`);else if (a.kind === "video") this.props.history.push(`/Content/clips/${id}`);else if (a.url) window.open(a.url, "_blank", "noopener");
    });
    /** Rename an asset (saved on its original, so every version shows it). Empty or unchanged names do nothing. */
    _defineProperty(this, "renameAsset", async a => {
      const id = String(a.id);
      const name = String(this.state.asRenameDraft || "").trim();
      if (this.state.asRename !== id) return;
      this.setState({
        asRename: null
      });
      if (!name || name === (a.title || "")) return;
      const prev = a.title;
      const patch = t => this.setState({
        assets: (this.state.assets || []).map(x => String(x.id) === id ? {
          ...x,
          title: t
        } : x)
      });
      patch(name);
      try {
        await svc(`/content/assets/${id}/title`).postAsync({
          title: name
        });
        toast("Renamed.");
      } catch (e) {
        patch(prev);
        toast(e && e.message || "Could not rename it.");
      }
    });
    _defineProperty(this, "loadCalendar", async () => {
      const {
        gridStart,
        gridEnd
      } = this.calWindow();
      const iso = ContentHubComponent.isoDay;
      this.setState({
        calBusy: true
      });
      const today = new Date();
      const ahead = new Date(today);
      ahead.setDate(today.getDate() + 120);
      const [d, a] = await Promise.all([safe(svc(`/content/calendar?from=${iso(gridStart)}&to=${iso(gridEnd)}`).getAsync(), {
        items: []
      }),
      // Everything dated from today on (the API caps a window at 120 days): a piece with a date is not "ready to schedule".
      safe(svc(`/content/calendar?from=${iso(today)}&to=${iso(ahead)}`).getAsync(), null)]);
      if (this._alive) this.setState({
        cal: d && d.items || [],
        calAhead: a ? a.items || [] : null,
        calBusy: false
      });
    });
    /** ‹ › step: a month in Month view, a week in Week view. */
    _defineProperty(this, "shiftMonth", delta => {
      const w = this.calWindow();
      if (w.week) {
        const next = new Date(w.gridStart);
        next.setDate(next.getDate() + 7 * delta);
        this.setState({
          calWeek: next,
          cal: undefined,
          calMore: ""
        }, () => this.loadCalendar());
        return;
      }
      const next = new Date(w.m.getFullYear(), w.m.getMonth() + delta, 1);
      this.setState({
        calMonth: next,
        cal: undefined,
        calMore: ""
      }, () => this.loadCalendar());
    });
    _defineProperty(this, "calToday", () => this.setState({
      calMonth: null,
      calWeek: null,
      cal: undefined,
      calMore: ""
    }, () => this.loadCalendar()));
    _defineProperty(this, "setCalView", view => {
      const w = this.calWindow();
      if (view === (w.week ? "week" : "month")) return;
      if (view === "week") {
        // The week holding today when today is in the month on screen, else the month's first week.
        const t = new Date();
        const inMonth = t.getFullYear() === w.m.getFullYear() && t.getMonth() === w.m.getMonth();
        this.setState({
          calView: "week",
          calWeek: ContentHubComponent.weekStart(inMonth ? t : w.m),
          cal: undefined,
          calMore: ""
        }, () => this.loadCalendar());
      } else {
        this.setState({
          calView: "month",
          calMonth: new Date(w.gridStart.getFullYear(), w.gridStart.getMonth(), 1),
          cal: undefined,
          calMore: ""
        }, () => this.loadCalendar());
      }
    });
    // Scheduler: pick a container → its variants → a target channel + date. A piece id prefills the sheet
    // ("Pick a day" and drops from the Ready to schedule column).
    _defineProperty(this, "openScheduler", (isoDate, containerId) => {
      this.setState({
        schedOpen: true,
        schedDate: isoDate || "",
        schedContainerId: "",
        schedVariants: undefined,
        schedVariantId: "",
        schedTarget: "",
        schedNote: "",
        schedQuery: "",
        schedPickOpen: false,
        calMore: ""
      });
      if (containerId) this.pickSchedContainer(String(containerId));
    });
    _defineProperty(this, "pickSchedContainer", async id => {
      this.setState({
        schedContainerId: id,
        schedVariants: undefined,
        schedVariantId: ""
      });
      if (!id) return;
      const d = await safe(svc(`/content/containers/detail/${String(id)}`).getAsync(), {
        variants: []
      });
      const variants = d && d.variants || [];
      // Start on an approved version when there is one, and on its own channel when the channel list has it.
      const pick = variants.find(v => ["approved", "published", "live"].includes(String(v.status || "").toLowerCase())) || variants[0];
      const TARGET_OF = {
        web: "web",
        website: "web",
        blog: "blog",
        landing: "landing",
        email: "email",
        social_facebook: "social_facebook",
        social_instagram: "social_instagram",
        social_pinterest: "social_pinterest",
        gbp_post: "gbp_post",
        product_copy: "product_copy"
      };
      if (this._alive && String(this.state.schedContainerId) === String(id)) {
        this.setState(s => ({
          schedVariants: variants,
          schedVariantId: pick ? String(pick.id) : "",
          schedTarget: s.schedTarget || pick && TARGET_OF[String(pick.channel || "").toLowerCase()] || ""
        }));
      }
    });
    _defineProperty(this, "saveSchedule", async () => {
      const {
        schedVariantId,
        schedTarget,
        schedDate,
        schedNote,
        schedContainerId
      } = this.state;
      if (!schedVariantId || !schedTarget || !schedDate) return;
      this.setState({
        schedBusy: true
      });
      const t = document.querySelector("paper-toast");
      try {
        // Same rule as the Builder (2026-09-27): an approved piece releases on its date; drafts wait for a reviewer.
        const sv = (this.state.schedVariants || []).find(v => String(v.id) === String(schedVariantId));
        const approved = !!sv && ["approved", "published", "live"].includes(String(sv.status || "").toLowerCase());
        // Ids exceed 2^53: send them as raw number literals in a pre-built body (Number() rounds them; postAsync sends a string verbatim).
        const body = JSON.stringify({
          target: schedTarget,
          scheduledDate: schedDate,
          note: schedNote || null,
          approved
        }).replace(/^\{/, `{"variantId":${String(schedVariantId)},"containerId":${schedContainerId ? String(schedContainerId) : "null"},`);
        await svc("/content/schedule").postAsync(body);
        if (t) t.show(approved ? `Scheduled for ${schedDate}. It goes out that day.` : `Scheduled for ${schedDate}. Approve it on the calendar so it goes out.`);
        this.setState({
          schedOpen: false,
          schedBusy: false
        }, () => this.loadCalendar());
      } catch (e) {
        if (t) t.show(e && e.message || "Could not schedule.");
        this.setState({
          schedBusy: false
        });
      }
    });
    _defineProperty(this, "setScheduleStatus", async (id, status) => {
      const t = document.querySelector("paper-toast");
      try {
        await svc(`/content/schedule/${String(id)}`).postAsync({
          status
        });
        this.loadCalendar();
      } catch (e) {
        if (t) t.show(e && e.message || "Could not update.");
      }
    });
    _defineProperty(this, "rescheduleItem", async (id, isoDate) => {
      if (!isoDate) return;
      const t = document.querySelector("paper-toast");
      try {
        await svc(`/content/schedule/${String(id)}`).postAsync({
          scheduledDate: isoDate
        });
        if (t) t.show(`Moved to ${isoDate}.`);
        this.loadCalendar();
      } catch (e) {
        if (t) t.show(e && e.message || "Could not reschedule.");
      }
    });
    _defineProperty(this, "updateScheduleItem", async (id, patch) => {
      const t = document.querySelector("paper-toast");
      try {
        await svc(`/content/schedule/${String(id)}`).postAsync(patch);
        this.loadCalendar();
      } catch (e) {
        if (t) t.show(e && e.message || "Could not save.");
      }
    });
    _defineProperty(this, "deleteScheduleItem", async id => {
      const t = document.querySelector("paper-toast");
      try {
        await svc(`/content/schedule/${String(id)}/delete`).postAsync({});
        this.loadCalendar();
      } catch (e) {
        if (t) t.show(e && e.message || "Could not remove.");
      }
    });
    /** Archive or restore a set of containers (DS 2026-10-02): the API takes status draft|active|archived on PUT; archived pieces leave the Library, Stories and Measure. */
    _defineProperty(this, "setContainersStatus", async (members, status) => {
      const t = document.querySelector("paper-toast");
      const list = Array.isArray(members) ? members : [members];
      this.setState({
        libraryBusy: true
      });
      try {
        for (const c of list) await svc(`/content/containers/${String(c.id)}`).putAsync({
          title: c.title,
          summary: c.summary,
          topic: c.topic,
          status
        });
        if (t) t.show(status === "archived" ? `${list.length === 1 ? "Piece" : `${list.length} pieces`} archived.` : "Restored.");
        await this.load(); // the Library, Stories and the header counts all read the main list (loadLibrary never existed)
        if (this.state.detail && list.some(c => String(c.id) === String(this.state.detail.container.id))) await this.reloadDetail();
      } catch (e) {
        if (t) t.show(e && e.message || "Could not change the status.");
      } finally {
        if (this._alive) this.setState({
          libraryBusy: false
        });
      }
    });
    // Story Trash (2026-10-07): archived stories move to the Trash for 30 days, then the nightly job deletes them for good.
    _defineProperty(this, "trashStory", async (members, toTrash) => {
      const t = document.querySelector("paper-toast");
      this.setState({
        libraryBusy: true,
        storyTrashAsk: null
      });
      try {
        const body = `{"containerIds":[${members.map(m => String(m.id)).join(",")}]}`; // ids past 2^53 stay exact
        await svc(`/content/containers/${toTrash ? "trash" : "untrash"}`).postAsync(body);
        if (t) t.show(toTrash ? "Moved to the Trash. It is deleted for good after 30 days." : "Restored to Archived.");
        await this.load();
      } catch (e) {
        if (t) t.show(e && e.message || "Could not change it.");
      } finally {
        if (this._alive) this.setState({
          libraryBusy: false
        });
      }
    });
    // ---- Library tags (DS mockup content-library-tags-2026-10-08) ----
    _defineProperty(this, "loadTags", async () => {
      const r = await safe(tagsApi.list(), null);
      if (!r || !this._alive) return r;
      const map = r.assignments || null;
      if (map) this._tagMap = map;
      this.setState(s => {
        const next = {
          tags: (r.items || []).map(t => ({
            ...t,
            id: String(t.id)
          }))
        };
        if (map && s.data) next.data = {
          ...s.data,
          containers: s.data.containers.map(c => ({
            ...c,
            tags: (map[String(c.id)] || []).map(String)
          }))
        };
        return next;
      });
      return r;
    });
    _defineProperty(this, "createTag", async name => {
      const t = await tagsApi.create(name);
      if (t && t.id != null) {
        const tag = {
          ...t,
          id: String(t.id)
        };
        this.setState(s => ({
          tags: (s.tags || []).some(x => x.id === tag.id) ? s.tags : [...(s.tags || []), tag]
        }));
        return tag;
      }
      throw new Error("Could not create that tag.");
    });
    // Saved as picked (no Save button): optimistic, put back on failure.
    _defineProperty(this, "setPieceTags", async (c, tagIds) => {
      const before = (c.tags || []).slice();
      this.patchContainerTags([c.id], () => tagIds);
      try {
        await tagsApi.setPiece(c.id, tagIds);
        this.refreshTagCounts();
      } catch (e) {
        this.patchContainerTags([c.id], () => before);
        const t = document.querySelector("paper-toast");
        if (t) t.show(e && e.message || "Could not save the tags.");
      }
    });
    _defineProperty(this, "refreshTagCounts", () => {
      clearTimeout(this._tagCountTimer);
      this._tagCountTimer = setTimeout(async () => {
        const r = await safe(tagsApi.list(), null);
        if (r && this._alive) this.setState({
          tags: (r.items || []).map(t => ({
            ...t,
            id: String(t.id)
          }))
        });
      }, 600);
    });
    _defineProperty(this, "bulkTags", async (add, remove) => {
      const ids = [...this.state.librarySel];
      await tagsApi.bulk(ids, add, remove);
      this.patchContainerTags(ids, cur => [...cur.filter(x => !remove.includes(x)), ...add.filter(x => !cur.includes(x))]);
      const t = document.querySelector("paper-toast");
      if (t) t.show(`Tags updated on ${ids.length} piece${ids.length === 1 ? "" : "s"}.`);
      this.refreshTagCounts();
    });
    _defineProperty(this, "setGroupBy", g => {
      try {
        localStorage.setItem("plunk.contentLibrary.groupBy", g);
      } catch (e) {/* per-viewer convenience only */}
      this.setState({
        libGroupBy: g
      });
    });
    _defineProperty(this, "toggleTagFilter", id => {
      const cur = this.state.tagFilter || [];
      this.setState({
        tagFilter: cur.includes(id) ? cur.filter(x => x !== id) : [...cur, id]
      });
    });
    _defineProperty(this, "setLibView", v => {
      try {
        localStorage.setItem("plunk.contentLibrary.view", v);
      } catch (e) {/* per-viewer convenience only */}
      this.setState({
        libView: v
      });
    });
    // ----------------------------------------------------------------- detail (the piece page)
    /**
     * Imported social posts keep the picture link the network handed out on import day, and Facebook / Instagram links
     * expire (signed oe= param). The social sync refreshes social_post.media_url every run, so for imported social pieces
     * fetch the current link for each publication (matched on permalink) and offer it as a fallback picture.
     */
    _defineProperty(this, "loadSocialMedia", async detail => {
      const pubs = (detail.publications || []).filter(p => p && p.url && /facebook|instagram|meta|linkedin|pinterest|tiktok|youtube/i.test(String(p.target || "")));
      if (!pubs.length) return;
      const days = pubs.map(p => String(p.publishedDate || p.createdDate || "").slice(0, 10)).filter(x => /^\d{4}-\d{2}-\d{2}$/.test(x)).sort();
      if (!days.length) return;
      const shift = (iso, n) => {
        const t = new Date(iso + "T00:00:00Z");
        t.setUTCDate(t.getUTCDate() + n);
        return t.toISOString().slice(0, 10).replace(/-/g, "");
      };
      const tok = `custom_${shift(days[0], -2)}_${shift(days[days.length - 1], 2)}`;
      const r = await safe(svc(`/social/posts/${tok}?$top=100&$sort=recent`).getAsync(), null);
      const norm = u => String(u || "").replace(/^https?:\/\/(www\.|m\.)?/, "").replace(/\/+$/, "");
      const items = (r && r.items || []).filter(x => x && x.mediaUrl);
      const found = [];
      pubs.forEach(p => {
        const hit = items.find(x => norm(x.permalink) === norm(p.url));
        if (hit) found.push({
          url: hit.mediaUrl,
          kind: /video|reel/i.test(String(hit.type || "")) || /\.(mp4|mov|m4v)(\?|$)/i.test(hit.mediaUrl) ? "video" : "image",
          platform: String(hit.platform || ""),
          variantId: String(p.variantId),
          permalink: p.url
        });
      });
      const cur = this.state.detail;
      if (!this._alive || !found.length || !cur || String(cur.container.id) !== String(detail.container.id)) return;
      this.setState({
        detail: {
          ...cur,
          socialMedia: found
        }
      });
    });
    /** Publish for the chosen version: an approved or published one opens the target menu; a draft is approved first. */
    _defineProperty(this, "pdPublish", async v => {
      if (!v) return;
      const s = String(v.status || "").toLowerCase();
      if (s === "approved" || s === "published" || s === "live") {
        this.setState({
          publishMenu: this.state.publishMenu === String(v.id) ? null : String(v.id),
          pdMenu: false
        });
        return;
      }
      try {
        await svc(`/content/variants/${String(v.id)}/status`).postAsync({
          status: "approved"
        });
      } catch (e) {
        toast(e && e.message || "That didn't go through.");
        return;
      }
      toast("Approved. Pick where it goes.");
      await this.reloadDetail();
      if (this._alive) this.setState({
        publishMenu: String(v.id),
        pdVariant: String(v.id)
      });
    });
    // --------------------------------------------------------------- rec queue
    // Redesign 2026-10-09 (mockup calflow/Recs): plain groups (Fix on your site / Slipping / Gaps to fill / ...),
    // one row per suggestion with an impact chip, a plain title, a "why" line built only from numbers the
    // suggestion (or the decay feed it came from) carries, one outlined action and a quiet dismiss.
    /** Plain title + why for one suggestion. Every number comes from the rec text, its source_ref, or the decay row. */
    /** One recommendation row: shared by the Recommendations tab and the Overview's "What next" card. */
    _defineProperty(this, "renderRecRow", (r, opts) => {
      const recBusy = this.state.recBusy || {};
      const groupOf = x => recGroup(x);
      const places = this.state.recPlaces || {};
      const busy = recBusy[String(r.id)];
      const [ik, il] = recImpact(r.score);
      const copy = this.recCopy(r);
      const title = opts && opts.title || copy.title;
      const why = opts && opts.why || copy.why;
      const piece = copy.piece;
      const x = recRef(r);
      const g = groupOf(r);
      const place = piece ? places[String(piece.id)] : "";
      const draftLabel = r.draftContainerId ? "Open the draft" : g === "slipping" ? "Write a fresh version" : g === "spread" ? "Write a new version" : "Write about it";
      return /*#__PURE__*/React.createElement("div", {
        key: String(r.id),
        className: "rec-row"
      }, /*#__PURE__*/React.createElement("span", {
        className: "rec-impact " + ik,
        title: `Impact: ${il.toLowerCase()}`
      }, il), /*#__PURE__*/React.createElement("div", {
        className: "rec-b"
      }, /*#__PURE__*/React.createElement("b", {
        className: "rec-t"
      }, title), (why || piece) && /*#__PURE__*/React.createElement("span", {
        className: "rec-why"
      }, why, piece && /*#__PURE__*/React.createElement(React.Fragment, null, why ? " · " : "", /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "rec-place",
        title: "Open this piece",
        onClick: () => this.openDetail({
          id: String(piece.id)
        })
      }, place || "Open the piece")))), x.type === "hygiene" ? /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "rec-act",
        onClick: () => this.props.history.push(`/${x.kind === "ada" ? "Ada" : "Seo"}?rule=${encodeURIComponent(x.rule)}`)
      }, "See where") : x.type === "stage" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "rec-act",
        disabled: busy,
        onClick: () => this.setState({
          stagePick: {
            stage: x.stage,
            picked: {},
            recId: String(r.id)
          }
        })
      }, "Tag a piece"), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "rec-text",
        disabled: busy,
        onClick: () => this.recDraft(r)
      }, busy ? "Working…" : r.draftContainerId ? "Open the draft" : "Write one")) : /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "rec-act",
        disabled: busy,
        onClick: () => this.recDraft(r)
      }, busy ? "Working…" : draftLabel), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "rec-x",
        "aria-label": `Dismiss: ${title}`,
        title: "Dismiss",
        disabled: busy,
        onClick: () => this.recAction(r, "dismiss")
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons",
        "aria-hidden": "true"
      }, "close")));
    });
    this.state = {
      data: null,
      error: false,
      // ?tab=stories (New story's back button, 2026-10-08) opens on that tab; anything else starts on the overview
      tab: (() => {
        try {
          const t = new URLSearchParams(window.location.search).get("tab");
          return ["overview", "library", "stories", "assets", "calendar", "recommendations", "mywork"].includes(t) ? t : "overview";
        } catch (e) {
          return "overview";
        }
      })(),
      detail: null,
      // {container, blocks, variants, publications, links, funnel}
      detailTab: "content",
      // content | where | performance
      detailLoading: false,
      repurposeOpen: false,
      repurposeSel: new Set(),
      repurposeBusy: false,
      recBusy: {},
      recClassFilter: "",
      // §3 grouped library — group by campaign (the grouping the container
      // list carries); select-to-group assigns a campaign, ungroup removes it.
      librarySelect: false,
      librarySel: new Set(),
      libraryGroupName: "",
      libraryBusy: false,
      // Library tags (DS 2026-10-08): registry + filter (Any/All, Untagged) + Group by Story | Tag | Channel | None.
      tags: [],
      tagFilter: [],
      tagMode: "any",
      tagsMore: false,
      tagPickerFor: null,
      bulkTagsOpen: false,
      manageTagsOpen: false,
      libGroupOpen: new Set(),
      libGroupBy: (() => {
        try {
          const g = localStorage.getItem("plunk.contentLibrary.groupBy");
          return ["story", "tag", "channel", "none"].includes(g) ? g : "story";
        } catch (e) {
          return "story";
        }
      })(),
      // Library toolbar (DS mockup libflow 2026-10-08): status pills, channel select, grid | list.
      libStatus: "all",
      libChannel: "",
      libView: (() => {
        try {
          return localStorage.getItem("plunk.contentLibrary.view") === "list" ? "list" : "grid";
        } catch (e) {
          return "grid";
        }
      })(),
      // Piece page: chosen channel version, ··· menu, results by channel, manage placements, notes, topic edit.
      pdVariant: null,
      pdFor: null,
      pdMenu: false,
      pdByChannel: false,
      pdManageLive: false,
      pdNotesOpen: false,
      pdTopicEdit: false,
      // Stories tab: repurpose FROM a whole story (grounds on all its blocks).
      storyRepurpose: null,
      storyRepurposeSel: new Set(),
      storyRepurposeBusy: false,
      createOpen: false,
      createBusy: false,
      createTitle: "",
      createTopic: "",
      createSummary: "",
      // Add content INTO a container (paste a block or import a page) — so a
      // freshly-created empty container isn't a dead end before Repurpose.
      addOpen: false,
      addBlockText: "",
      importUrl: "",
      addImageUrl: "",
      addDocUrl: "",
      addBusy: false,
      topicDraft: "",
      topicBusy: false,
      transcribeBusy: false,
      editVariant: null,
      editTitle: "",
      editBody: "",
      variantBusy: {},
      publishMenu: null,
      shopifyConfirm: null,
      showArchived: false,
      shopify: null,
      videoOpen: false,
      videoPrompt: "",
      videoAspect: "16:9",
      videoVoice: "Joanna",
      videoMusic: "",
      videoRecipe: "promo",
      videoTitle: "",
      videoTitleSub: "",
      videoEnd: "",
      videoEndSub: "",
      videoCaptions: true,
      videoImages: [],
      videoBusy: false,
      videoJob: null,
      assetsPick: [],
      addTab: "paste",
      imageOpen: false,
      imagePrompt: "",
      imageAspect: "1:1",
      imageRef: "",
      imageBusy: false,
      imageJob: null,
      // R2 storyboard editor · R4 alt text · R6 story publish (2026-09-27)
      storyboard: null,
      storyboardBusy: false,
      altBusy: {},
      altDraft: {},
      storyPublish: null,
      storyPublishPlan: undefined,
      storyPublishBusy: false,
      credits: null,
      creditsLevel: null,
      outOfCredits: false,
      storyMedia: null,
      // §310 campaigns-in-the-hub v1: the campaign layer over hub
      // content (rails from the §312 backend note, probe-verified).
      camp: undefined,
      // { campaigns, suggests, groups, tier }
      campBusy: false,
      campDismissed: new Set(),
      showSuggests: false,
      // Asset library / DAM tab (CONTENT_HUB_NEXT §1)
      assets: undefined,
      assetKind: "",
      newAssetUrl: "",
      assetBusy: false,
      editAsset: null,
      resizeAsset: null,
      trimAsset: null,
      uploadBusy: false,
      uploadNote: "",
      clipsAsset: null,
      assetSearch: null,
      assetSearchBusy: false,
      showcaseUrl: null,
      showcaseBusy: false,
      bulkMode: false,
      bulkPicked: {},
      bulkAction: "remove_background",
      bulkText: "SALE",
      bulkBusy: false,
      // Forward content calendar tab (CONTENT_HUB_NEXT §4)
      cal: undefined,
      calMonth: null,
      calBusy: false,
      calView: "month",
      calWeek: null,
      calAhead: null,
      calChannel: "",
      calMore: "",
      calDrop: "",
      calReadyAll: false,
      schedOpen: false,
      schedContainerId: "",
      schedVariants: undefined,
      schedVariantId: "",
      schedTarget: "",
      schedDate: "",
      schedNote: "",
      schedBusy: false,
      search: "",
      // per-tab text filter (Library / Stories / Assets)
      // §312 §4.1/§4.2/§4.6 — overview + campaign detail
      ov: undefined,
      // { tier, portfolio, trendLane, lanes, working, workingMeta, decay }
      ovMetric: null,
      ovOverlays: [],
      // §4.6 selected swimlane keys overlaid on the trend chart (max 3)
      campDetail: null,
      // { name, group, legs, trendLane, tier } | "loading"
      campMetric: null,
      connectors: [],
      social: []
    };
    this._alive = true;
  }

  // §305: the library defaults to ALL TIME — imported history (months of
  // CC campaigns) read as dead content under a calendar-month default.
  // An explicit range token in the route always wins.
  range() {
    return this.props.params && this.props.params.range || getGlobalRange("all_time");
  }

  // Window start for the current range (YYYY-MM-DD); custom_ tokens parse
  // their own window.
  windowStart() {
    const r = this.range();
    if (isCustomRange(r)) {
      const w = parseCustomRange(r);
      return w ? w[0].toISOString().slice(0, 10) : null;
    }
    return rangeDates(r).startDate;
  }
  async componentDidMount() {
    getOnboardingStatus().then(ob => this._alive && this.setState({
      shopify: ob && ob.shopify ? {
        shop: ob.shop
      } : false
    })).catch(() => {});
    if (Auth.isAuthenticated() || (await Auth.attachOrSignIn())) {
      this.load();
      damAvailable().then(ok => {
        if (this._alive && ok) this.setState({
          hasBrandLibrary: true
        });
      });
      // My work tab on team workspaces (phase 4)
      svc("/content/team").getAsync().then(t => {
        if (this._alive) this.setState({
          teamOn: !!(t && (t.users || []).length > 1)
        });
      }).catch(() => {});
      const pid = (() => {
        try {
          return new URLSearchParams(window.location.search).get("piece");
        } catch (e) {
          return null;
        }
      })();
      if (pid && /^\d+$/.test(pid)) this.openDetail({
        id: pid
      });
    }
    this._periodTok = subscribePeriod(({
      range
    }) => {
      if (!this._alive || !range) return;
      // The header picker announces its saved range when the page opens: an unchanged range is not a change
      // (it used to move to /Content/<range>, remount the hub and drop you back on Overview, 2026-10-09).
      if (range === this.range()) return;
      const target = `/Content/${range}`;
      if (window.location.pathname === target) {
        this.setState({
          data: null,
          error: false,
          detail: null,
          camp: undefined,
          ov: undefined,
          campDetail: null
        }, () => this.load());
      } else {
        const t = this.state.tab;
        this.props.history.push(t && t !== "overview" ? `${target}?tab=${t}` : target);
      }
    });
  }
  componentWillUnmount() {
    this._alive = false;
    clearTimeout(this._tagCountTimer);
    unsubscribePeriod(this._periodTok);
  }
  componentDidUpdate(prev) {
    const prevRange = prev.params && prev.params.range || "";
    const curRange = this.props.params && this.props.params.range || "";
    if (prevRange !== curRange) {
      this.setState({
        data: null,
        error: false,
        detail: null,
        camp: undefined,
        ov: undefined,
        campDetail: null
      });
      this.load();
    }
  }

  // The library endpoint returns at most 100 rows per call: page through until a short page (cap 2,000), so a
  // workspace past 100 pieces sees all of them (the Library tab was stuck at 100, 2026-10-07).
  // Pages after the first are fetched 4 at a time (R&S: 9 one-by-one pages took ~12 s, 2026-10-11); onPage gets
  // the rows so far after each round.
  async loadAllContainers(range, status, onPage, first) {
    const PAGE = 100;
    const CAP = 2000;
    const PAR = 4;
    const get = skip => safe(svc(`/content/containers/${range}?$top=${PAGE}&$skip=${skip}${status ? `&status=${status}` : ""}`).getAsync(), null);
    const all = [];
    const d0 = first || (await get(0));
    const items0 = d0 && d0.items || [];
    all.push(...items0);
    if (items0.length < PAGE) return {
      items: all
    };
    // The first page carries the total: fetch every remaining page through a pool of 4 (no waiting on a round).
    const total = Number(d0 && d0.count);
    if (total > PAGE) {
      const skips = [];
      for (let k = PAGE; k < Math.min(total, CAP); k += PAGE) skips.push(k);
      const pages = new Array(skips.length);
      let next = 0;
      const worker = async () => {
        while (next < skips.length) {
          const i = next++;
          pages[i] = await get(skips[i]);
        }
      };
      await Promise.all(Array.from({
        length: Math.min(PAR, skips.length)
      }, worker));
      pages.forEach(d => all.push(...(d && d.items || [])));
      // Rows added since the count was taken: keep paging one by one from where the count ended.
      for (let skip = PAGE + skips.length * PAGE, last = pages[pages.length - 1] && pages[pages.length - 1].items || []; last.length === PAGE && skip < CAP; skip += PAGE) {
        const d = await get(skip);
        last = d && d.items || [];
        all.push(...last);
      }
      return {
        items: all
      };
    }
    for (let skip = PAGE; skip < CAP; skip += PAGE * PAR) {
      const skips = [];
      for (let k = skip; k < Math.min(skip + PAGE * PAR, CAP); k += PAGE) skips.push(k);
      const pages = await Promise.all(skips.map(get));
      let done = false;
      for (const d of pages) {
        const items = d && d.items || [];
        all.push(...items);
        if (items.length < PAGE) {
          done = true;
          break;
        }
      }
      if (done) break;
      if (onPage) onPage(all.slice());
    }
    return {
      items: all
    };
  }

  // Shows the first 100 pieces as soon as they arrive; the rest load behind (dataComplete false until then), and
  // the overview, recommendations, tags and trash load alongside instead of after every page (~15 s blank, 2026-10-11).
  async load() {
    const range = this.range();
    const tok = this._loadTok = (this._loadTok || 0) + 1;
    const live = () => this._alive && this._loadTok === tok;
    try {
      this._tagMap = null;
      const recsP = safe(svc("/content/recommendations").getAsync(), {
        items: []
      });
      const connP = safe(svc("/content/connectors").getAsync(), {
        items: []
      });
      const socP = safe(svc("/social/accounts").getAsync(), {
        items: []
      });
      this.loadOverview();
      // A link straight to ?tab=assets showed placeholders forever: only a tab click loaded the assets.
      if (this.state.tab === "assets" && this.state.assets === undefined) this.loadAssets();
      this.loadAllContainers(range, "trashed").then(tr => {
        if (live()) this.setState({
          trashed: tr && tr.items || []
        });
      });
      connP.then(c => {
        if (live()) this.setState({
          connectors: c.items || []
        });
      });
      socP.then(c => {
        if (live()) this.setState({
          social: c.items || []
        });
      });
      const first = await safe(svc(`/content/containers/${range}?$top=100&$skip=0`).getAsync(), null);
      if (!live()) return;
      const withTags = rows => this._tagMap ? rows.map(c => ({
        ...c,
        tags: (this._tagMap[String(c.id)] || []).map(String)
      })) : rows;
      const firstRows = first && first.items || [];
      this.setState({
        data: {
          containers: withTags(firstRows),
          recs: []
        },
        dataComplete: firstRows.length < 100,
        recsLoaded: false
      });
      recsP.then(recs => {
        if (!live()) return;
        this.setState(s => ({
          data: {
            ...s.data,
            recs: recs.items || []
          },
          recsLoaded: true
        }));
        this.loadRecPlaces(recs.items || []);
      });
      this.loadTags();
      if (firstRows.length < 100) return;
      const setRows = (rows, complete) => {
        if (live()) this.setState(s => ({
          data: {
            ...(s.data || {}),
            containers: withTags(rows),
            recs: s.data && s.data.recs || []
          },
          dataComplete: complete
        }));
      };
      const all = await this.loadAllContainers(range, null, rows => setRows(rows, false), first);
      setRows(all.items || [], true);
    } catch (e) {
      if (live()) this.setState({
        error: true
      });
    }
  }
  /** The library piece a refresh card is about (source_ref refresh:<containerId>), to tell same-named pieces apart. */
  recPiece(r) {
    const m = String(r && (r.sourceRef || r.source_ref) || "").match(/^refresh:(\d+)$/);
    if (!m) return null;
    return (this.state.data && this.state.data.containers || []).find(c => String(c.id) === m[1]) || null;
  }
  renderStagePick() {
    const sp = this.state.stagePick;
    if (!sp) return null;
    const list = (this.state.data && this.state.data.containers || []).filter(c => String(c.status || "").toLowerCase() === "active");
    const n = Object.values(sp.picked).filter(Boolean).length;
    return /*#__PURE__*/React.createElement("div", {
      className: "wa-modal-backdrop hub-edit-backdrop",
      onClick: () => {
        if (!sp.busy) this.setState({
          stagePick: null
        });
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-trash-sheet hub-stage-pick",
      onClick: e => e.stopPropagation()
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-create-head"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "Tag content for ", STAGE_PLURAL[sp.stage] || sp.stage), /*#__PURE__*/React.createElement("p", null, "Pick the active pieces that speak to ", STAGE_PLURAL[sp.stage] || sp.stage, ". A piece can carry more than one stage.")), /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle sm",
      style: {
        margin: 0
      },
      disabled: sp.busy,
      onClick: () => this.setState({
        stagePick: null
      })
    }, "Close")), !list.length ? /*#__PURE__*/React.createElement("p", {
      className: "territory-hint"
    }, "No active pieces yet. Draft one for this stage instead.") : /*#__PURE__*/React.createElement("div", {
      className: "hub-stage-list"
    }, list.map(c => {
      const id = String(c.id);
      const on = !!sp.picked[id];
      return /*#__PURE__*/React.createElement("label", {
        key: id,
        className: "hub-stage-row" + (on ? " on" : "")
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        checked: on,
        disabled: sp.busy,
        onChange: () => this.setState({
          stagePick: {
            ...sp,
            picked: {
              ...sp.picked,
              [id]: !on
            }
          }
        })
      }), /*#__PURE__*/React.createElement("span", {
        className: "t"
      }, c.title || "Untitled"), c.campaign ? /*#__PURE__*/React.createElement("span", {
        className: "dim"
      }, c.campaign) : null);
    })), /*#__PURE__*/React.createElement("div", {
      className: "hub-create-foot right"
    }, /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0,
        flex: 1
      }
    }, n ? `${n} picked` : "Nothing picked yet"), /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
      disabled: sp.busy || !n,
      onClick: this.saveStagePick
    }, sp.busy ? "Tagging…" : "Tag for this stage"))));
  }
  // ---------------------------------------------------------------- media panels (a piece OR a whole story — see mediaCtx)
  // Copy for a media prompt: text blocks first; when a piece keeps its copy on variants (imported pages,
  // product copy drafts) those bodies fill in, stripped of HTML.
  ctxText(ctx, sep) {
    const strip = h => String(h || "").replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
    const fromBlocks = (ctx.blocks || []).filter(b => !/image|link|video|previous_|transcript_pending|storyboard|^(comment|social_media|locale_meta|variant_history|seo|seo_brief|builder_state|design_filled)$/i.test(b.kind || "")).map(b => strip(b.body)).filter(Boolean);
    const vs = ctx.variants || (this.state.detail && !ctx.story ? this.state.detail.variants : []) || [];
    const fromVariants = vs.map(v => [v.title, strip(v.body)].filter(Boolean).join(": ")).filter(Boolean);
    return (fromBlocks.length ? fromBlocks : fromVariants).join(sep).trim();
  }
  mediaCtx() {
    if (this.state.storyMedia) return this.state.storyMedia;
    const d = this.state.detail;
    return d ? {
      containerId: String(d.container.id),
      title: d.container.title || "",
      blocks: d.blocks || [],
      story: false
    } : null;
  }
  renderImagePanel() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, this.state.imageOpen && /*#__PURE__*/React.createElement("div", {
      className: "hub-panel"
    }, /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: "0 0 6px"
      }
    }, "A generated image for this piece: describe the scene; pick a product image as the reference so the product stays true. The result lands in Blocks and Assets, ready for social, blog or video scenes.", this.creditsNote(6)), /*#__PURE__*/React.createElement("textarea", {
      value: this.state.imagePrompt,
      rows: 3,
      onChange: e => this.setState({
        imagePrompt: e.target.value
      }),
      className: "hub-panel-ta"
    }), /*#__PURE__*/React.createElement("div", {
      className: "hub-panel-row"
    }, /*#__PURE__*/React.createElement("span", {
      className: "hub-bld-label",
      style: {
        margin: 0
      }
    }, "Shape"), /*#__PURE__*/React.createElement("span", {
      className: "seg"
    }, [["1:1", "Square"], ["4:5", "Portrait"], ["16:9", "Wide"], ["9:16", "Story"]].map(([k, l]) => /*#__PURE__*/React.createElement("button", {
      key: k,
      className: this.state.imageAspect === k ? "on" : "",
      onClick: () => this.setState({
        imageAspect: k
      })
    }, l)))), this.state.assetsPick.length > 0 && /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: 6,
        flexWrap: "wrap",
        marginBottom: 8
      }
    }, this.state.assetsPick.slice(0, 24).map(a => {
      const on = this.state.imageRef === a.url;
      return /*#__PURE__*/React.createElement("img", {
        key: String(a.id),
        src: a.url,
        alt: a.title || "",
        title: a.title || "reference image",
        loading: "lazy",
        onClick: () => this.setState({
          imageRef: on ? "" : a.url
        }),
        style: {
          width: 56,
          height: 56,
          objectFit: "cover",
          borderRadius: 6,
          cursor: "pointer",
          border: on ? "2px solid var(--plk-accent)" : "2px solid transparent",
          opacity: on ? 1 : 0.75
        }
      });
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: 8,
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-sm k-rounded-md k-button-solid k-button-solid-primary",
      disabled: this.state.imageBusy || !(this.state.imagePrompt || "").trim(),
      onClick: this.makeImage
    }, this.state.imageBusy ? "Queuing…" : "Generate image"), /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-sm k-rounded-md k-button-flat",
      onClick: () => this.setState({
        imageOpen: false,
        storyMedia: null
      })
    }, "Cancel"))), this.state.imageJob && /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: "0 0 8px"
      }
    }, "Generating your image\u2026 it appears under Blocks when done."));
  }
  renderVideoPanel() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, this.state.videoOpen && /*#__PURE__*/React.createElement("div", {
      className: "hub-panel"
    }, /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: "0 0 6px"
      }
    }, "A narrated video from this piece: the script is written from the copy below, each scene gets one of the images you pick (catalog images are already here for Shopify stores), and the render lands as a ", /*#__PURE__*/React.createElement("b", null, "video"), " variant you can publish to Facebook, Instagram, your product page or your own endpoint.", this.creditsNote(10)), /*#__PURE__*/React.createElement("textarea", {
      value: this.state.videoPrompt,
      rows: 5,
      onChange: e => this.setState({
        videoPrompt: e.target.value
      }),
      className: "hub-panel-ta"
    }), /*#__PURE__*/React.createElement("div", {
      className: "hub-panel-row"
    }, /*#__PURE__*/React.createElement("span", {
      className: "hub-bld-label",
      style: {
        margin: 0
      }
    }, "Format"), /*#__PURE__*/React.createElement("span", {
      className: "seg"
    }, [["16:9", "16:9 · YouTube / Facebook"], ["9:16", "9:16 · Reels / Stories"], ["1:1", "1:1 · feed"]].map(([k, l]) => /*#__PURE__*/React.createElement("button", {
      key: k,
      className: this.state.videoAspect === k ? "on" : "",
      onClick: () => this.setState({
        videoAspect: k
      })
    }, l)))), /*#__PURE__*/React.createElement("div", {
      className: "hub-bld-fields three"
    }, /*#__PURE__*/React.createElement("label", {
      className: "hub-bld-field"
    }, "Recipe", /*#__PURE__*/React.createElement("select", {
      value: this.state.videoRecipe,
      onChange: e => this.setState({
        videoRecipe: e.target.value
      }),
      style: {
        ...INPUT,
        padding: "4px 8px"
      }
    }, [["promo", "Promo: title card, scenes, call to action"], ["product_tour", "Product tour: scenes, call to action"], ["reel", "Reel: scenes only, big captions"], ["story", "Story: scenes only"]].map(([k, l]) => /*#__PURE__*/React.createElement("option", {
      key: k,
      value: k
    }, l)))), /*#__PURE__*/React.createElement(VoicePicker, {
      labelClass: "hub-bld-field",
      label: "Narration voice",
      value: this.state.videoVoice,
      selectStyle: {
        ...INPUT,
        padding: "4px 8px"
      },
      onChange: videoVoice => this.setState({
        videoVoice
      })
    }), /*#__PURE__*/React.createElement("label", {
      className: "hub-bld-field"
    }, "Music bed (optional mp3 URL, ducked under the voice)", /*#__PURE__*/React.createElement("input", {
      value: this.state.videoMusic,
      placeholder: "https://\u2026 .mp3",
      onChange: e => this.setState({
        videoMusic: e.target.value
      }),
      style: {
        ...INPUT,
        padding: "4px 8px"
      }
    })), this.state.videoRecipe === "promo" && /*#__PURE__*/React.createElement("label", {
      className: "hub-bld-field"
    }, "Title card", /*#__PURE__*/React.createElement("input", {
      value: this.state.videoTitle,
      placeholder: "Headline",
      onChange: e => this.setState({
        videoTitle: e.target.value
      }),
      style: {
        ...INPUT,
        padding: "4px 8px"
      }
    })), this.state.videoRecipe === "promo" && /*#__PURE__*/React.createElement("label", {
      className: "hub-bld-field"
    }, "Title sub-line", /*#__PURE__*/React.createElement("input", {
      value: this.state.videoTitleSub,
      placeholder: "One line under the headline",
      onChange: e => this.setState({
        videoTitleSub: e.target.value
      }),
      style: {
        ...INPUT,
        padding: "4px 8px"
      }
    })), (this.state.videoRecipe === "promo" || this.state.videoRecipe === "product_tour") && /*#__PURE__*/React.createElement("label", {
      className: "hub-bld-field"
    }, "End card: call to action", /*#__PURE__*/React.createElement("input", {
      value: this.state.videoEnd,
      placeholder: "Shop the collection",
      onChange: e => this.setState({
        videoEnd: e.target.value
      }),
      style: {
        ...INPUT,
        padding: "4px 8px"
      }
    })), (this.state.videoRecipe === "promo" || this.state.videoRecipe === "product_tour") && /*#__PURE__*/React.createElement("label", {
      className: "hub-bld-field"
    }, "End card sub-line", /*#__PURE__*/React.createElement("input", {
      value: this.state.videoEndSub,
      placeholder: "yourstore.com \xB7 offer ends \u2026",
      onChange: e => this.setState({
        videoEndSub: e.target.value
      }),
      style: {
        ...INPUT,
        padding: "4px 8px"
      }
    })), /*#__PURE__*/React.createElement("label", {
      style: {
        fontSize: 12,
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        alignSelf: "end"
      }
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: !!this.state.videoCaptions,
      onChange: e => this.setState({
        videoCaptions: e.target.checked
      })
    }), " Burn captions")), this.state.assetsPick.length > 0 && /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: 6,
        flexWrap: "wrap",
        marginBottom: 8
      }
    }, this.state.assetsPick.slice(0, 24).map(a => {
      const on = this.state.videoImages.indexOf(a.url) >= 0;
      const isVid = /\.(mp4|mov|webm)(\?|$)/i.test(a.url || "") || a.kind === "video";
      const toggle = () => this.setState({
        videoImages: on ? this.state.videoImages.filter(u => u !== a.url) : [...this.state.videoImages, a.url]
      });
      const box = {
        width: 64,
        height: 64,
        objectFit: "cover",
        borderRadius: 6,
        cursor: "pointer",
        border: on ? "2px solid var(--plk-accent)" : "2px solid transparent",
        opacity: on ? 1 : 0.75
      };
      if (isVid) return /*#__PURE__*/React.createElement("div", {
        key: String(a.id),
        title: a.title || "video clip",
        onClick: toggle,
        style: {
          ...box,
          background: a.posterUrl ? `center / cover url(${a.posterUrl})` : "#1f2329",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 11,
          fontWeight: 700,
          boxSizing: "border-box"
        }
      }, a.posterUrl ? "" : "▶ clip");
      return /*#__PURE__*/React.createElement("img", {
        key: String(a.id),
        src: a.url,
        alt: a.title || "",
        title: a.title || "",
        loading: "lazy",
        onClick: toggle,
        style: box
      });
    })), (() => {
      const sb = this.state.storyboard;
      const pick = this.state.videoImages.length ? this.state.videoImages : this.state.assetsPick.slice(0, 24).map(a => a.url);
      const setSb = next => this.setState({
        storyboard: next
      });
      if (!sb) return null;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          border: "1px solid var(--plk-border)",
          borderRadius: "8px",
          background: "var(--plk-surface)",
          padding: "8px 10px",
          marginBottom: 8
        }
      }, /*#__PURE__*/React.createElement("p", {
        className: "territory-hint",
        style: {
          margin: "0 0 6px"
        }
      }, /*#__PURE__*/React.createElement("b", null, "Storyboard"), ": edit the narration, swap an image, reorder or drop scenes. The render uses exactly these scenes."), sb.map((sc, i) => /*#__PURE__*/React.createElement("div", {
        key: i,
        style: {
          display: "flex",
          gap: 8,
          alignItems: "flex-start",
          padding: "6px 0",
          borderTop: i ? "1px solid var(--plk-border)" : "none"
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "territory-hint",
        style: {
          margin: "6px 0 0",
          width: 16,
          flexShrink: 0
        }
      }, i + 1), /*#__PURE__*/React.createElement("div", {
        style: {
          position: "relative",
          flexShrink: 0
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: sc.imageUrl,
        alt: "",
        style: {
          width: 64,
          height: 64,
          objectFit: "cover",
          borderRadius: 6,
          border: "1px solid var(--plk-border)"
        }
      }), /*#__PURE__*/React.createElement("select", {
        value: sc.imageUrl,
        title: "Swap image",
        onChange: e => setSb(sb.map((x, k) => k === i ? {
          ...x,
          imageUrl: e.target.value
        } : x)),
        style: {
          position: "absolute",
          inset: 0,
          opacity: 0,
          cursor: "pointer",
          width: "100%"
        }
      }, [sc.imageUrl, ...pick.filter(u => u !== sc.imageUrl)].map((u, k) => /*#__PURE__*/React.createElement("option", {
        key: k,
        value: u
      }, `image ${k + 1}`)))), /*#__PURE__*/React.createElement("textarea", {
        value: sc.narration,
        rows: 2,
        onChange: e => setSb(sb.map((x, k) => k === i ? {
          ...x,
          narration: e.target.value
        } : x)),
        style: {
          flex: 1,
          minWidth: 0,
          fontSize: "12.5px",
          borderRadius: "6px",
          border: "1px solid var(--plk-border)",
          padding: "6px 8px",
          resize: "vertical",
          boxSizing: "border-box",
          fontFamily: "inherit",
          height: 56,
          minHeight: 56
        }
      }), /*#__PURE__*/React.createElement("input", {
        value: sc.overlayText || "",
        placeholder: "On-screen text (optional, 6 words)",
        title: "A brand lower-third burned onto this scene",
        onChange: e => setSb(sb.map((x, k) => k === i ? {
          ...x,
          overlayText: e.target.value
        } : x)),
        style: {
          width: 150,
          flexShrink: 0,
          fontSize: "12px",
          borderRadius: "6px",
          border: "1px solid var(--plk-border)",
          padding: "6px 8px",
          boxSizing: "border-box",
          fontFamily: "inherit",
          alignSelf: "flex-start"
        }
      }), /*#__PURE__*/React.createElement("span", {
        style: {
          display: "inline-flex",
          flexDirection: "column",
          gap: 2,
          flexShrink: 0
        }
      }, /*#__PURE__*/React.createElement("button", {
        className: "territory-toggle xs",
        disabled: i === 0,
        title: "Move up",
        onClick: () => {
          const n = sb.slice();
          [n[i - 1], n[i]] = [n[i], n[i - 1]];
          setSb(n);
        }
      }, "\u2191"), /*#__PURE__*/React.createElement("button", {
        className: "territory-toggle xs",
        disabled: i === sb.length - 1,
        title: "Move down",
        onClick: () => {
          const n = sb.slice();
          [n[i + 1], n[i]] = [n[i], n[i + 1]];
          setSb(n);
        }
      }, "\u2193"), /*#__PURE__*/React.createElement("button", {
        className: "territory-toggle xs",
        disabled: sb.length <= 1,
        title: "Remove scene",
        onClick: () => setSb(sb.filter((_, k) => k !== i))
      }, "\u2715")))), /*#__PURE__*/React.createElement("button", {
        className: "territory-toggle",
        style: {
          margin: "6px 0 0",
          padding: "3px 10px"
        },
        disabled: sb.length >= 8,
        onClick: () => setSb([...sb, {
          imageUrl: pick[sb.length % Math.max(pick.length, 1)] || sb[sb.length - 1].imageUrl,
          narration: ""
        }])
      }, "+ Scene"));
    })(), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: 8,
        alignItems: "center",
        flexWrap: "wrap"
      }
    }, !this.state.storyboard ? /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-sm k-rounded-md k-button-solid k-button-solid-primary",
      disabled: this.state.storyboardBusy || !(this.state.videoPrompt || "").trim(),
      onClick: this.writeStoryboard,
      title: "The storyboard agent writes the scene list from the copy; you edit it before the render (no render credits yet)"
    }, this.state.storyboardBusy ? "Writing storyboard…" : "Write storyboard →") : /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-sm k-rounded-md k-button-solid k-button-solid-primary",
      disabled: this.state.videoBusy || !(this.state.storyboard || []).some(sc => (sc.narration || "").trim()),
      onClick: this.makeVideo
    }, this.state.videoBusy ? "Queuing…" : `Render video · ${(this.state.storyboard || []).length} scene${(this.state.storyboard || []).length === 1 ? "" : "s"} · 10 credits`), !this.state.storyboard ? /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-sm k-rounded-md k-button-flat",
      disabled: this.state.videoBusy || !(this.state.videoPrompt || "").trim(),
      onClick: this.makeVideo,
      title: "Skip the storyboard: the video agent writes and renders in one go (10 credits)"
    }, this.state.videoBusy ? "Queuing…" : "Render without reviewing") : /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-sm k-rounded-md k-button-flat",
      disabled: this.state.storyboardBusy,
      onClick: this.writeStoryboard
    }, this.state.storyboardBusy ? "Writing…" : "Rewrite storyboard"), /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-sm k-rounded-md k-button-flat",
      onClick: () => this.setState({
        videoOpen: false,
        storyMedia: null
      })
    }, "Cancel"))));
  }
  renderStoryMediaPanels(s) {
    const sm = this.state.storyMedia;
    const sid = String(s.storyId);
    const vj = this.state.videoJob && String(this.state.videoJob.containerId) === sid;
    const ij = this.state.imageJob && String(this.state.imageJob.containerId) === sid;
    const jobs = vj || ij ? /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: "8px 0 0"
      }
    }, vj ? "Rendering the story video… a few minutes; it lands on the story's primary piece as a video variant. " : "", ij ? "Generating the story image… under a minute; it lands on the primary piece and in Assets." : "") : null;
    if (!sm || String(sm.storyId) !== sid) return jobs;
    return /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: 8
      }
    }, this.renderImagePanel(), this.renderVideoPanel(), jobs);
  }
  // §220-add-2: contextual slice of the canonical connections registry —
  // Content shows only ITS providers' status and points at Manage Data.
  renderConnectionsSlice() {
    const groupsHere = CONNECT_GROUPS.filter(gr => ["Email", "Publishing"].includes(gr.name)); // PIM / DAM hidden for now (DS 2026-10-01)
    const items = groupsHere.flatMap(gr => gr.items);
    const connected = items.filter(i => connectionStatus(i, this.state.connectors, this.state.social).cls !== "off");
    return /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: "0 0 10px"
      }
    }, connected.length ? /*#__PURE__*/React.createElement(React.Fragment, null, "Importing from ", connected.map(i => i.label).join(" · "), ".") : this.state.shopify ? /*#__PURE__*/React.createElement(React.Fragment, null, "Your storefront pages, products and email automations fill this library on their own. Connect your email or social accounts to import their history too.") : /*#__PURE__*/React.createElement(React.Fragment, null, "No content sources connected: connect Constant Contact, Mailchimp, or WordPress and the archaeology import fills this library from your real campaign history."), " ", /*#__PURE__*/React.createElement("a", {
      style: {
        cursor: "pointer"
      },
      onClick: () => this.props.history.push("/Data/Connect")
    }, "Manage connections"));
  }

  // ---------------------------------------------------------------- library

  // §312 §4.1 — the four-question overview.
  renderOverview() {
    const ov = this.state.ov;
    if (ov === undefined) return /*#__PURE__*/React.createElement("p", {
      className: "territory-hint"
    }, "Loading overview\u2026");
    const {
      tier,
      portfolio,
      trendLane,
      lanes,
      working: working0,
      workingMeta,
      decay,
      coverage
    } = ov;
    const data = this.state.data || {};
    const recsAll = data.recs || [];
    // One list, no repeats: the top ideas by score; "nothing speaks to <stage>" rows fold into one.
    const nextList = (() => {
      const out = [];
      const stages = [];
      recsAll.slice().sort((x, y) => (Number(y.score) || 0) - (Number(x.score) || 0)).forEach(r => {
        const ref = recRef(r);
        if (ref.type === "stage") {
          stages.push(ref.stage);
          if (stages.length > 1) return;
          out.push([r, {
            stageRow: true
          }]);
          return;
        }
        out.push([r, null]);
      });
      if (stages.length > 1) {
        const names = stages.map(st => STAGE_PLURAL[String(st || "").toLowerCase()] || st).filter(Boolean);
        const list = names.length > 1 ? `${names.slice(0, -1).join(", ")} or ${names[names.length - 1]}` : names[0];
        const row = out.find(x => x[1] && x[1].stageRow);
        if (row) row[1] = {
          title: `Nothing speaks to ${list} yet`,
          why: "No piece is tagged for these customer stages"
        };
      }
      return out.slice(0, 5);
    })();
    const containers = data.containers || [];
    const metric = this.state.ovMetric || defaultMetric(tier);
    const currFmt = v => workingMeta.metric === "salesValue" ? usd(v) : num(v);
    // Pipeline: what needs a hand this week, each tile opens its tab.
    const todayIso = ContentHubComponent.isoDay(new Date());
    const drafts = containers.filter(c => String(c.status || "").toLowerCase() === "draft").length;
    const storiesN = this.buildStories(containers).filter(st => !st.members.every(m => String(m.status || "").toLowerCase() === "archived")).length;
    const cal = this.state.cal;
    const ahead = cal ? cal.filter(r => ["planned", "approved"].includes(String(r.status || "")) && String(r.scheduledDate || "").slice(0, 10) >= todayIso).length : null;
    const unapproved = cal ? cal.filter(r => String(r.status || "") === "planned" && String(r.scheduledDate || "").slice(0, 10) >= todayIso).length : 0;
    const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;
    const todo = [["drafts", this.state.dataComplete === false ? "Drafts to review…" : plural(drafts, "draft to review", "drafts to review"), "", "library"], ["stories", this.state.dataComplete === false ? "Stories in progress…" : plural(storiesN, "story in progress", "stories in progress"), "", "stories"], ["sched", ahead == null ? "Scheduled ahead…" : `${ahead} scheduled ahead`, unapproved ? `${unapproved} need approval` : "", "calendar"], ["ideas", this.state.recsLoaded === false ? "Ideas…" : plural(recsAll.length, "idea", "ideas"), "", "recommendations"]];
    // Funnel on the kit ribbon: the tier's stages, channel mix as the sub-line, the trend as the sparkline.
    const allStages = [["reach", "Reach"], ["engagements", "Engagements"]];
    if (tier >= 1) allStages.push(["sessions", "Visits"], ["conversions", "Conversions"]);
    if (tier >= 2) allStages.push(["orders", "Orders"], ["salesValue", "Sales"]);
    // Show reach/engagements/visits always; outcome tiles only once something is traced to content.
    const hasVal = k => portfolio && Number(portfolio[k]) > 0;
    const stages = allStages.filter(([k]) => ["reach", "engagements", "sessions"].includes(k) || hasVal(k));
    const hiddenOutcomes = allStages.length > stages.length;
    const series = trendLane && trendLane.series || [];
    const tiles = portfolio ? stages.map(([k, l]) => {
      const v = Number(portfolio[k]) || 0;
      const ch = Array.from(new Set((portfolio.channels || []).filter(c => Number(c[k]) > 0).map(c => chName(c.channel) || channelTypeLabel(c.channel)).filter(Boolean)));
      return {
        l,
        v: v > 0 ? k === "salesValue" ? usd(v) : num(v) : "0",
        s: ch.length ? "from " + ch.slice(0, 3).join(", ") + (ch.length > 3 ? ` and ${ch.length - 3} more` : "") : "",
        sp: series.map(pt => Number(pt[k]) || 0)
      };
    }) : [];
    const unlock = tier < 1 ? "Link your website tracker to follow this content into visits and conversions." : tier < 2 ? "Connect your store to see orders and sales that came from your content." : hiddenOutcomes ? "No orders or sales traced to content in this range yet. They show here as soon as there are some." : null;
    // Clean titles ("Get started · Plunk · Plunk" → "Get started"): drop repeated segments and the site name that ends most titles.
    const segsOf = t => String(t || "").split(" · ").map(x => x.trim()).filter((x, i, a) => x && x !== a[i - 1]);
    const tails = {};
    working0.forEach(g => {
      const sg = segsOf(g.title || g.key);
      if (sg.length > 1) tails[sg[sg.length - 1]] = (tails[sg[sg.length - 1]] || 0) + 1;
    });
    const brand = Object.keys(tails).sort((a, b) => tails[b] - tails[a])[0];
    const cleanT = t => {
      const sg = segsOf(t);
      if (sg.length > 1 && sg[sg.length - 1] === brand) sg.pop();
      return sg.join(" · ") || String(t || "");
    };
    const merged = {};
    const working = [];
    working0.forEach(g => {
      const t = cleanT(g.title || g.key);
      if (merged[t]) {
        const m = merged[t];
        m[workingMeta.metric] = (Number(m[workingMeta.metric]) || 0) + (Number(g[workingMeta.metric]) || 0);
        m.impressions = (Number(m.impressions) || 0) + (Number(g.impressions) || 0);
        return;
      }
      merged[t] = {
        ...g,
        title: t
      };
      working.push(merged[t]);
    });
    working.sort((a, b) => (Number(b[workingMeta.metric]) || 0) - (Number(a[workingMeta.metric]) || 0));
    const maxW = Math.max(1, ...working.map(g => Number(g[workingMeta.metric]) || 0));
    return /*#__PURE__*/React.createElement("div", {
      className: "wa-grid"
    }, /*#__PURE__*/React.createElement("nav", {
      className: "hub-ov-todo",
      "aria-label": "To do"
    }, /*#__PURE__*/React.createElement("b", {
      className: "lbl"
    }, "To do"), todo.map(([k, text, sub, tab]) => /*#__PURE__*/React.createElement("button", {
      key: k,
      type: "button",
      onClick: () => {
        this.setState({
          tab,
          search: ""
        });
        if (tab === "calendar" && this.state.cal === undefined) this.loadCalendar();
      }
    }, /*#__PURE__*/React.createElement("span", null, text), sub ? /*#__PURE__*/React.createElement("i", null, sub) : null, /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      "aria-hidden": "true"
    }, "chevron_right")))), portfolio ? /*#__PURE__*/React.createElement(Ribbon, {
      tiles: tiles,
      comparing: null,
      cols: tiles.length,
      note: unlock
    }) : /*#__PURE__*/React.createElement(Empty, null, "No content activity in this range yet. Publish or import content and its funnel builds here."), trendLane && (() => {
      const overlaySel = new Set(this.state.ovOverlays || []);
      const overlayObjs = (this.state.ovOverlays || []).map(k => (lanes || []).find(l => l.key === k)).filter(Boolean).map(l => ({
        key: l.key,
        title: l.title || l.key,
        series: l.series,
        color: this.overlayColor(l.key)
      }));
      return /*#__PURE__*/React.createElement(Card, {
        title: "Performance over time",
        hint: "every piece, every channel"
      }, /*#__PURE__*/React.createElement(TrendChart, {
        lane: trendLane,
        tier: tier,
        metric: metric,
        overlays: overlayObjs,
        onMetric: m => this.setState({
          ovMetric: m
        })
      }), /*#__PURE__*/React.createElement(Swimlanes, {
        lanes: lanes,
        metric: metric,
        windowStart: (trendLane.series[0] || {}).date,
        windowEnd: (trendLane.series[trendLane.series.length - 1] || {}).date,
        selected: overlaySel,
        onToggle: this.toggleOverlay,
        colorFor: this.overlayColor,
        onOpen: name => this.openCampaign(name)
      }));
    })(), /*#__PURE__*/React.createElement(Card, {
      title: "What's working",
      hint: working.length ? `${workingMeta.kind === "campaign" ? "campaigns" : "stories"} by ${String(workingMeta.label || "").replace(/^sessions$/i, "visits")}` : null,
      span: 6
    }, working.length ? /*#__PURE__*/React.createElement("div", {
      className: "hub-ov-rank"
    }, working.map((g, i) => {
      const v = Number(g[workingMeta.metric]) || 0;
      return /*#__PURE__*/React.createElement("div", {
        key: g.key,
        className: "hub-ov-row" + (workingMeta.kind === "campaign" ? " clickable" : ""),
        onClick: workingMeta.kind === "campaign" ? () => this.openCampaign(g.key) : undefined
      }, /*#__PURE__*/React.createElement("span", {
        className: "n"
      }, i + 1), /*#__PURE__*/React.createElement("span", {
        className: "t"
      }, /*#__PURE__*/React.createElement("b", {
        title: g.title || g.key
      }, g.title || g.key), /*#__PURE__*/React.createElement("span", {
        className: "bar"
      }, /*#__PURE__*/React.createElement("i", {
        style: {
          width: `${Math.max(2, Math.round(v / maxW * 100))}%`
        }
      }))), /*#__PURE__*/React.createElement("span", {
        className: "v"
      }, /*#__PURE__*/React.createElement("b", null, v > 0 ? currFmt(v) : "—"), /*#__PURE__*/React.createElement("i", null, Number(g.impressions) > 0 ? `${num(g.impressions)} views` : "")));
    })) : /*#__PURE__*/React.createElement("div", {
      className: "hub-bld-empty"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "trending_up"), "Nothing grouped yet. Confirm a campaign on the Campaigns tab or group pieces into a story.")), /*#__PURE__*/React.createElement(Card, {
      title: "What to do next",
      hint: nextList.length ? `top ${nextList.length} of ${recsAll.length}` : null,
      right: recsAll.length > nextList.length ? /*#__PURE__*/React.createElement("a", {
        style: {
          cursor: "pointer"
        },
        onClick: () => this.setState({
          tab: "recommendations"
        })
      }, "See all ", recsAll.length) : null,
      span: 6
    }, nextList.length ? /*#__PURE__*/React.createElement("div", {
      className: "rec-view rec-compact"
    }, nextList.map(([r, opts]) => this.renderRecRow(r, opts))) : /*#__PURE__*/React.createElement("div", {
      className: "hub-bld-empty ok"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "task_alt"), "Nothing to do right now. New ideas arrive every week.")));
  }

  // §312 §4.2 — one campaign, end to end.
  renderCampaignDetail() {
    const cd = this.state.campDetail;
    if (cd === "loading") return /*#__PURE__*/React.createElement("p", {
      className: "territory-hint"
    }, "Loading campaign\u2026");
    const metric = this.state.campMetric || defaultMetric(cd.tier);
    return /*#__PURE__*/React.createElement("div", {
      className: "wa-stack"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        marginBottom: "10px"
      }
    }, /*#__PURE__*/React.createElement("button", {
      className: "territory-back",
      onClick: () => this.setState({
        campDetail: null
      }),
      title: "Back to campaigns"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "arrow_back")), /*#__PURE__*/React.createElement("div", {
      className: "heading-label"
    }, cd.name)), cd.group ? /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(FunnelStrip, {
      group: cd.group,
      tier: cd.tier
    })) : /*#__PURE__*/React.createElement(Empty, null, "No activity for this campaign in the selected range."), /*#__PURE__*/React.createElement(Card, {
      title: "Channel legs"
    }, /*#__PURE__*/React.createElement(ChannelLegs, {
      groups: cd.legs,
      tier: cd.tier
    })), cd.trendLane && /*#__PURE__*/React.createElement(Card, {
      title: "Performance over time"
    }, /*#__PURE__*/React.createElement(TrendChart, {
      lane: cd.trendLane,
      tier: cd.tier,
      metric: metric,
      onMetric: m => this.setState({
        campMetric: m
      })
    })));
  }

  // §310: the Campaigns tab. MONEY GATE (hard rule, defense in depth):
  // campaign legs render ONLY the allowlisted audience metrics below —
  // never cost/spend/budget, regardless of what a payload carries; on
  // managed tenants the API omits money and this list is the second lock.
  renderCampaigns() {
    const camp = this.state.camp;
    if (camp === undefined) return /*#__PURE__*/React.createElement("p", {
      className: "territory-hint"
    }, "Loading campaigns\u2026");
    const {
      campaigns,
      suggests,
      groups,
      tier
    } = camp;
    const byName = {};
    groups.forEach(g => {
      byName[g.key] = g;
    });
    const visSuggests = suggests.filter(sg => !this.state.campDismissed.has(sg.name));
    const day = d => d ? String(d).slice(0, 10) : null;
    const cell = v => Number(v) > 0 ? num(v) : "—";
    const legRow = (c, i) => /*#__PURE__*/React.createElement("tr", {
      key: i
    }, /*#__PURE__*/React.createElement("td", {
      style: {
        textTransform: "capitalize"
      }
    }, String(c.channel || "").replace(/_/g, " ")), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, cell(c.impressions)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, cell(c.reach)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, cell(c.clicks)), tier >= 1 && /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, cell(c.sessions)), tier >= 2 && /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, Number(c.salesValue) > 0 ? usd(c.salesValue) : "—"));
    return /*#__PURE__*/React.createElement("div", null, visSuggests.length > 0 && /*#__PURE__*/React.createElement("div", {
      style: {
        border: "1px dashed var(--plk-border)",
        borderRadius: "10px",
        padding: "12px 14px",
        marginBottom: "14px"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        cursor: "pointer"
      },
      onClick: () => this.setState({
        showSuggests: !this.state.showSuggests
      })
    }, /*#__PURE__*/React.createElement("p", {
      style: {
        fontSize: "13px",
        margin: 0
      }
    }, /*#__PURE__*/React.createElement("b", null, "Suggested groupings (", num(visSuggests.length), ")"), " ", /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0,
        display: "inline-flex",
        alignItems: "center",
        height: "34px"
      }
    }, "\u2014 auto-clustered from naming & timing; most are already grouped by campaign")), /*#__PURE__*/React.createElement("span", {
      style: {
        marginLeft: "auto",
        color: "var(--plk-text-dim)"
      }
    }, this.state.showSuggests ? "▴ hide" : "▾ review")), this.state.showSuggests && /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: "8px"
      }
    }, visSuggests.map(sg => /*#__PURE__*/React.createElement("div", {
      key: sg.name,
      style: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        padding: "6px 0",
        borderBottom: "1px solid var(--plk-border)",
        fontSize: "12.5px"
      }
    }, /*#__PURE__*/React.createElement("b", null, sg.name), /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, num((sg.containerIds || []).length), " piece", (sg.containerIds || []).length === 1 ? "" : "s", day(sg.from) ? ` · ${day(sg.from)} → ${day(sg.to) || "now"}` : ""), /*#__PURE__*/React.createElement("span", {
      style: {
        marginLeft: "auto",
        display: "inline-flex",
        gap: "6px"
      }
    }, /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle sm",
      disabled: this.state.campBusy,
      onClick: () => this.confirmSuggestion(sg)
    }, "Confirm"), /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle sm",
      onClick: () => this.dismissSuggestion(sg.name)
    }, "Dismiss")))))), campaigns.length === 0 ? /*#__PURE__*/React.createElement("p", {
      className: "module-empty"
    }, "No campaigns yet: a campaign groups the pieces of one push (emails, posts, pages", ") into a single trace.", visSuggests.length ? " Confirm a suggested grouping above to start." : "") : campaigns.map(c => {
      const g = byName[c.name];
      return /*#__PURE__*/React.createElement("div", {
        key: c.name,
        onClick: () => this.openCampaign(c.name),
        title: `Open ${c.name}`,
        style: {
          border: "1px solid var(--plk-border)",
          borderRadius: "10px",
          padding: "14px 16px",
          marginBottom: "12px",
          background: "var(--plk-surface)",
          cursor: "pointer"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "6px"
        }
      }, /*#__PURE__*/React.createElement("b", {
        style: {
          fontSize: "14px"
        }
      }, c.name), /*#__PURE__*/React.createElement("span", {
        className: "territory-hint",
        style: {
          margin: 0
        }
      }, num(c.containers), " piece", c.containers === 1 ? "" : "s")), g ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          gap: "14px",
          fontSize: "12px",
          color: "var(--plk-text-dim)",
          marginBottom: "8px"
        }
      }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, cell(g.impressions)), " impr."), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, cell(g.reach)), " reach"), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, cell(g.clicks)), " clicks"), tier >= 1 && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, cell(g.sessions)), " sessions"), tier >= 2 && /*#__PURE__*/React.createElement("span", {
        style: {
          color: Number(g.salesValue) > 0 ? "var(--plk-success-text)" : undefined
        }
      }, /*#__PURE__*/React.createElement("b", null, Number(g.salesValue) > 0 ? usd(g.salesValue) : "—"), " sales")), (g.channels || []).length > 0 && /*#__PURE__*/React.createElement("table", {
        className: "territory-table wa-table"
      }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Channel"), /*#__PURE__*/React.createElement("th", {
        className: "n"
      }, "Impr."), /*#__PURE__*/React.createElement("th", {
        className: "n"
      }, "Reach"), /*#__PURE__*/React.createElement("th", {
        className: "n"
      }, "Clicks"), tier >= 1 && /*#__PURE__*/React.createElement("th", {
        className: "n"
      }, "Sessions"), tier >= 2 && /*#__PURE__*/React.createElement("th", {
        className: "n"
      }, "Sales"))), /*#__PURE__*/React.createElement("tbody", null, (g.channels || []).map(legRow)))) : /*#__PURE__*/React.createElement("p", {
        className: "territory-hint",
        style: {
          margin: 0
        }
      }, "No activity in this range."));
    }));
  }
  // Group the loaded containers into stories (storyId → members). Combined
  // performance is the sum of members; the primary (id === storyId) names it.
  buildStories(containers) {
    const groups = new Map();
    (containers || []).forEach(c => {
      const sid = c.storyId != null ? String(c.storyId) : null;
      if (sid == null) return;
      if (!groups.has(sid)) groups.set(sid, {
        storyId: sid,
        title: c.storyTitle || "Story",
        members: []
      });
      groups.get(sid).members.push(c);
    });
    const out = [...groups.values()].filter(s => s.members.length > 1);
    // A story started from New story is one piece until the Builder makes more: list a single piece once it has been
    // opened in the Builder (it carries builder state), so new and blank stories show here too (2026-10-07).
    const listed = new Set(out.flatMap(s => s.members.map(m => String(m.id))));
    (containers || []).forEach(c => {
      if (listed.has(String(c.id)) || !(c.builderState || c.BuilderState)) return;
      out.push({
        storyId: String(c.storyId != null ? c.storyId : c.id),
        title: c.storyTitle || c.title || "Story",
        members: [c]
      });
    });
    return out;
  }
  renderAssets() {
    const s = this.state;
    const q = (s.search || "").trim().toLowerCase();
    const all = s.assets;
    const type = s.asType || "";
    const show = s.asShow || "all";
    const sort = s.asSort || "new";
    const inTrash = s.assetKind === "trash";
    const inSequences = s.assetKind === "sequences";
    const semantic = s.assetSearch;
    const searching = !!(semantic && q.length >= 3);
    const roots = (all || []).filter(a => a && !a.parentAssetId);
    const counts = {
      "": roots.length,
      image: 0,
      video: 0,
      doc: 0
    };
    roots.forEach(a => {
      if (counts[a.kind] !== undefined) counts[a.kind]++;
    });
    const showOk = a => show === "unused" ? !(Number(a.usedCount) > 0) : show === "edited" ? Number(a.versionCount) > 0 : show === "nodesc" ? a.kind === "image" && !a.altText : true;
    let assets = all === undefined ? undefined : (searching ? semantic : roots.filter(a => !q || `${a.title || ""} ${a.url || ""} ${a.tags || ""} ${a.description || ""} ${a.altText || ""}`.toLowerCase().includes(q))).filter(a => (!type || a.kind === type) && showOk(a));
    if (assets && (sort === "used" || !searching)) {
      const t = a => {
        const x = new Date(a.createdDate).getTime();
        return isNaN(x) ? 0 : x;
      };
      assets = [...assets].sort((a, b) => sort === "used" ? (Number(b.usedCount) || 0) - (Number(a.usedCount) || 0) || t(b) - t(a) : t(b) - t(a));
    }
    const missing = roots.filter(a => a.kind === "image" && !a.altText).length;
    const picked = this.pickedAssets();
    const nPicked = picked.length;
    const pickedImgs = picked.filter(a => a.kind === "image");
    const typeName = type === "image" ? "images" : type === "video" ? "videos" : type === "doc" ? "documents" : "";
    const fmtDur = d => `${Math.floor(d / 60)}:${String(Math.round(d) % 60).padStart(2, "0")}`;
    const openAlt = s.altOpen || {};
    const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;
    const pieces = s.data && s.data.containers || [];
    const docExt = a => ((/\.([a-z0-9]{2,5})(?:[?#]|$)/i.exec(a.url || "") || [])[1] || "file").toUpperCase();
    const metaLine = a => {
      const d = a.createdDate ? fmtDay(a.createdDate) : "";
      if (a.kind === "doc") return ["Document", docExt(a), d].filter(Boolean).join(" · ");
      if (a.kind === "audio") return ["Music", docExt(a), d].filter(Boolean).join(" · ");
      const used = Number(a.usedCount) > 0 ? `In ${plural(Number(a.usedCount), "piece", "pieces")}` : "Not used yet";
      return [used, d].filter(Boolean).join(" · ");
    };
    const togglePick = id => this.setState({
      bulkPicked: {
        ...s.bulkPicked,
        [id]: !s.bulkPicked[id]
      }
    });
    const closeMenus = {
      asMenu: null,
      asUploadMenu: false,
      asEditMenu: false,
      asBadgeOpen: false
    };

    // Trash and the sequences list replace the grid, each with a way back.
    if (inTrash || inSequences) {
      return /*#__PURE__*/React.createElement("div", {
        className: "as-view"
      }, /*#__PURE__*/React.createElement("div", {
        className: "as-subhead"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "as-back",
        onClick: () => this.setState({
          assetKind: "",
          assets: undefined
        }, () => this.loadAssets())
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "arrow_back"), "Back to Assets"), /*#__PURE__*/React.createElement("div", {
        className: "as-subhead-t"
      }, /*#__PURE__*/React.createElement("h2", null, inTrash ? "Trash" : "Sequences"), /*#__PURE__*/React.createElement("span", null, inTrash ? "Deleted files stay here for 30 days. Restore one to put it back where it was." : "Videos built from a run of pictures. Open one to change it or make it again.")), inSequences && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "as-btn primary",
        onClick: () => this.setState({
          createMedia: "sequence"
        })
      }, "New sequence")), inSequences ? /*#__PURE__*/React.createElement(SequencesList, {
        q: (s.search || "").trim(),
        onOpen: id => this.props.history.push(`/Content/sequences/${id}`),
        onNew: () => this.props.history.push("/Content/sequences/new")
      }) : /*#__PURE__*/React.createElement(TrashList, {
        kind: "",
        q: (s.search || "").trim(),
        onChange: () => {
          this._assetIndexKicked = true;
        }
      }), s.createMedia && this.renderCreateMedia());
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "as-view" + (s.bulkMode ? " picking" : "") + (s.bulkMode && nPicked ? " has-bar" : "")
    }, (s.asMenu || s.asUploadMenu || s.asEditMenu) && /*#__PURE__*/React.createElement("div", {
      className: "as-scrim",
      onMouseDown: () => this.setState(closeMenus)
    }), s.bulkMode ? /*#__PURE__*/React.createElement("div", {
      className: "as-pickhead"
    }, /*#__PURE__*/React.createElement("b", null, "Pick the ones you want"), /*#__PURE__*/React.createElement("span", null, "Click to pick, click again to drop."), assets && assets.length > 0 && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "as-link",
      onClick: () => {
        const p = {};
        assets.forEach(a => {
          p[String(a.id)] = true;
        });
        this.setState({
          bulkPicked: p
        });
      }
    }, "Pick all ", assets.length, typeName ? ` ${typeName}` : ""), nPicked > 0 && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "as-link quiet",
      onClick: () => this.setState({
        bulkPicked: {}
      })
    }, "Drop all"), /*#__PURE__*/React.createElement("span", {
      className: "as-sp"
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "as-btn ink-line",
      onClick: () => this.setState({
        bulkMode: false,
        bulkPicked: {},
        showcaseUrl: null,
        ...closeMenus
      })
    }, "Done")) : /*#__PURE__*/React.createElement("div", {
      className: "as-bar"
    }, /*#__PURE__*/React.createElement("label", {
      className: "as-search",
      onInput: e => this.searchAssets(e.target.value)
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "search"), /*#__PURE__*/React.createElement("input", {
      type: "search",
      value: s.search,
      "aria-label": "Search assets",
      placeholder: "Search, or describe what you need",
      onChange: e => this.setState({
        search: e.target.value
      })
    }), s.assetSearchBusy ? /*#__PURE__*/React.createElement("span", {
      className: "as-searchnote"
    }, "Searching\u2026") : searching ? /*#__PURE__*/React.createElement("span", {
      className: "as-searchnote"
    }, plural(semantic.length, "match", "matches")) : null), /*#__PURE__*/React.createElement("div", {
      className: "as-pills",
      role: "group",
      "aria-label": "Type"
    }, [["", "All"], ["image", "Images"], ["video", "Videos"], ["doc", "Documents"]].map(([k, label]) => /*#__PURE__*/React.createElement("button", {
      key: k || "all",
      type: "button",
      className: "as-pill" + (type === k ? " on" : ""),
      "aria-pressed": type === k,
      onClick: () => this.setState({
        asType: k
      }, () => {
        if (searching) this.searchAssets(s.search);
      })
    }, label, all !== undefined && k ? /*#__PURE__*/React.createElement("span", {
      className: "c"
    }, counts[k]) : null))), /*#__PURE__*/React.createElement("label", {
      className: "as-sel"
    }, "Show", /*#__PURE__*/React.createElement("select", {
      value: show,
      onChange: e => {
        if (e.target.value === "trash" || e.target.value === "sequences") {
          this.setState({
            assetKind: e.target.value,
            ...closeMenus
          });
          return;
        }
        this.setState({
          asShow: e.target.value
        });
      }
    }, /*#__PURE__*/React.createElement("option", {
      value: "all"
    }, "Everything"), /*#__PURE__*/React.createElement("option", {
      value: "unused"
    }, "Not used yet"), /*#__PURE__*/React.createElement("option", {
      value: "edited"
    }, "Edited"), /*#__PURE__*/React.createElement("option", {
      value: "nodesc"
    }, "Needs a description"), /*#__PURE__*/React.createElement("option", {
      value: "sequences"
    }, "Sequences"), /*#__PURE__*/React.createElement("option", {
      value: "trash"
    }, "In Trash"))), /*#__PURE__*/React.createElement("label", {
      className: "as-sel"
    }, "Sort", /*#__PURE__*/React.createElement("select", {
      value: sort,
      onChange: e => this.setState({
        asSort: e.target.value
      })
    }, /*#__PURE__*/React.createElement("option", {
      value: "new"
    }, searching ? "Best match" : "Newest"), /*#__PURE__*/React.createElement("option", {
      value: "used"
    }, "Most used"))), /*#__PURE__*/React.createElement("span", {
      className: "as-sp"
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "as-btn",
      title: "Pick several to add them to a piece, edit them together, share or download them",
      onClick: () => this.setState({
        bulkMode: true,
        bulkPicked: {},
        showcaseUrl: null,
        ...closeMenus
      })
    }, "Select"), /*#__PURE__*/React.createElement("span", {
      className: "as-menuwrap"
    }, /*#__PURE__*/React.createElement("input", {
      type: "file",
      multiple: true,
      accept: "image/*,video/mp4,video/quicktime,video/webm,application/pdf",
      style: {
        display: "none"
      },
      ref: r => {
        this._fileInput = r;
      },
      onChange: e => {
        this.uploadFiles(e.target.files);
        e.target.value = "";
      }
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "as-btn" + (s.asUploadMenu ? " on" : ""),
      disabled: s.uploadBusy,
      "aria-haspopup": "menu",
      "aria-expanded": !!s.asUploadMenu,
      onClick: () => this.setState({
        asUploadMenu: !s.asUploadMenu,
        asMenu: null
      })
    }, s.uploadBusy ? "Uploading…" : /*#__PURE__*/React.createElement(React.Fragment, null, "Upload ", /*#__PURE__*/React.createElement("span", {
      className: "as-caret"
    }, "\u25BE"))), s.asUploadMenu && /*#__PURE__*/React.createElement("div", {
      className: "as-menu right",
      role: "menu"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      role: "menuitem",
      onClick: () => {
        this.setState({
          asUploadMenu: false
        });
        if (this._fileInput) this._fileInput.click();
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "upload"), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, "Upload files"), /*#__PURE__*/React.createElement("i", null, "Pictures, videos or PDFs from your computer"))), /*#__PURE__*/React.createElement("button", {
      type: "button",
      role: "menuitem",
      onClick: () => this.setState({
        asUploadMenu: false,
        addByUrl: true
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "link"), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, "Add by URL"), /*#__PURE__*/React.createElement("i", null, "A link to a picture, video or document"))), s.hasBrandLibrary ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      role: "menuitem",
      onClick: () => this.setState({
        asUploadMenu: false,
        asLibraryPick: true
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "collections_bookmark"), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, "From the brand library"), /*#__PURE__*/React.createElement("i", null, "Approved photos, renders and documents"))) : null)), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "as-btn primary",
      title: "Make a picture, a clip or a sequence, saved straight into Assets",
      onClick: () => this.setState({
        createMedia: true,
        ...closeMenus
      })
    }, "Create")), s.createMedia && this.renderCreateMedia(), s.asLibraryPick && /*#__PURE__*/React.createElement("div", {
      className: "as-libpick card",
      role: "dialog",
      "aria-label": "Add from the brand library"
    }, /*#__PURE__*/React.createElement("div", {
      className: "as-libpick-head"
    }, /*#__PURE__*/React.createElement("b", null, "Add from the brand library"), /*#__PURE__*/React.createElement("span", {
      className: "as-sp"
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "as-btn ink-line",
      onClick: () => this.setState({
        asLibraryPick: false
      })
    }, "Done")), /*#__PURE__*/React.createElement(BrandLibraryPane, {
      accept: "any",
      hint: "Each one you pick is added to Assets.",
      onPicked: x => {
        const t = document.querySelector("paper-toast");
        if (t) t.show(x.reused ? `“${x.title || "It"}” is already in Assets.` : `Added “${x.title || "it"}” to Assets.`);
        this.loadAssets();
      }
    })), s.addByUrl && !s.bulkMode && /*#__PURE__*/React.createElement("div", {
      className: "as-url"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "link"), /*#__PURE__*/React.createElement("input", {
      value: s.newAssetUrl,
      placeholder: "Paste a link to a picture, video or document",
      autoFocus: true,
      "aria-label": "Link to add",
      onChange: e => this.setState({
        newAssetUrl: e.target.value
      }),
      onKeyDown: e => {
        if (e.key === "Enter") this.addAsset2();
        if (e.key === "Escape") this.setState({
          addByUrl: false
        });
      }
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "as-btn primary sm",
      disabled: s.assetBusy || !(s.newAssetUrl || "").trim(),
      onClick: this.addAsset2
    }, s.assetBusy ? "Adding…" : "Add"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "as-x",
      "aria-label": "Close",
      onClick: () => this.setState({
        addByUrl: false,
        newAssetUrl: ""
      })
    }, "\u2715")), s.uploadNote && /*#__PURE__*/React.createElement("p", {
      className: "as-note"
    }, s.uploadNote), !s.bulkMode && missing > 0 && !this.descBannerHidden() && /*#__PURE__*/React.createElement("div", {
      className: "as-banner",
      role: "status"
    }, /*#__PURE__*/React.createElement("span", {
      className: "as-dot",
      "aria-hidden": "true"
    }), /*#__PURE__*/React.createElement("span", {
      className: "t"
    }, /*#__PURE__*/React.createElement("b", null, plural(missing, "image has", "images have"), " no description"), " for screen readers and search. Plunk can write them from what is in each picture."), show !== "nodesc" && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "as-link quiet",
      onClick: () => this.setState({
        asShow: "nodesc"
      })
    }, "Show them"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "as-btn ink sm",
      disabled: s.altFillBusy,
      onClick: this.fillAlt
    }, s.altFillBusy ? s.altFillNote || "Writing…" : `Write all ${missing}`), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "as-x",
      "aria-label": "Hide this message",
      title: "Hide for now",
      onClick: this.hideDescBanner
    }, "\u2715")), assets === undefined ? /*#__PURE__*/React.createElement("div", {
      className: "as-grid"
    }, Array.from({
      length: 12
    }).map((_, i) => /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "as-card skel"
    }, /*#__PURE__*/React.createElement("div", {
      className: "as-cover"
    }), /*#__PURE__*/React.createElement("div", {
      className: "as-body"
    }, /*#__PURE__*/React.createElement("span", {
      className: "sk1"
    }), /*#__PURE__*/React.createElement("span", {
      className: "sk2"
    }))))) : !assets.length ? !roots.length && !searching ? /*#__PURE__*/React.createElement("div", {
      className: "as-empty"
    }, /*#__PURE__*/React.createElement("b", null, "Nothing here yet"), /*#__PURE__*/React.createElement("span", null, "Upload pictures, videos or documents, or make something new with Create. Files also arrive here as your content is imported. One file can be used in many pieces."), /*#__PURE__*/React.createElement("div", {
      className: "as-empty-acts"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "as-btn",
      onClick: () => this._fileInput && this._fileInput.click()
    }, "Upload files"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "as-btn primary",
      onClick: () => this.setState({
        createMedia: true
      })
    }, "Create"))) : /*#__PURE__*/React.createElement("div", {
      className: "as-empty"
    }, /*#__PURE__*/React.createElement("b", null, "Nothing matches"), /*#__PURE__*/React.createElement("span", null, q ? "Try other words, or describe what is in the picture." : show !== "all" ? "Nothing fits this view right now." : `No ${typeName || "files"} yet.`), /*#__PURE__*/React.createElement("div", {
      className: "as-empty-acts"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "as-btn",
      onClick: () => this.setState({
        search: "",
        assetSearch: null,
        asType: "",
        asShow: "all"
      })
    }, "Show everything"))) : /*#__PURE__*/React.createElement("div", {
      className: "as-grid"
    }, assets.map(a => {
      const id = String(a.id);
      const isImg = a.kind === "image";
      const isVid = a.kind === "video";
      const isDoc = !isImg && !isVid;
      const thumb = isImg ? a.latestUrl || a.url : isVid ? a.posterUrl : null;
      const isPicked = !!s.bulkPicked[id];
      const menuOpen = s.asMenu === id;
      const draft = s.altDraft[id];
      const altBusy = !!s.altBusy[id];
      const altValue = draft !== undefined ? draft : a.altText || "";
      const title = a.title || (isVid ? "Untitled video" : isDoc ? "Untitled document" : "Untitled picture");
      const open = () => s.bulkMode ? togglePick(id) : this.openAssetEditor(a);
      return /*#__PURE__*/React.createElement("div", {
        key: id,
        role: "button",
        tabIndex: 0,
        "aria-pressed": s.bulkMode ? isPicked : undefined,
        className: "as-card" + (isPicked ? " picked" : "") + (menuOpen ? " menu-open" : ""),
        onClick: open,
        onKeyDown: e => {
          if ((e.key === "Enter" || e.key === " ") && e.target === e.currentTarget) {
            e.preventDefault();
            open();
          }
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "as-cover" + (isVid ? " video" : "") + (isDoc ? " doc" : "")
      }, thumb && isImg && isBroken(thumb) ? /*#__PURE__*/React.createElement("span", {
        className: "as-imgph as-broken",
        title: "The picture file can't be loaded from where it's stored. Replace it or move it to Trash."
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons",
        "aria-hidden": "true"
      }, "broken_image"), /*#__PURE__*/React.createElement("small", null, "Picture can't be loaded")) : thumb ? /*#__PURE__*/React.createElement("img", {
        src: thumb,
        alt: "",
        loading: "lazy",
        onError: e => {
          if (isImg) {
            markBroken(thumb);
            this.forceUpdate();
          } else e.target.style.display = "none";
        }
      }) : isVid ? /*#__PURE__*/React.createElement("span", {
        className: "as-vidph",
        "aria-hidden": "true"
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "play_arrow")) : isDoc ? /*#__PURE__*/React.createElement("span", {
        className: "as-docph"
      }, /*#__PURE__*/React.createElement("span", null, docExt(a))) : /*#__PURE__*/React.createElement("span", {
        className: "as-imgph",
        "aria-hidden": "true"
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "image")), isVid && /*#__PURE__*/React.createElement("span", {
        className: "as-dur"
      }, "\u25B6 ", a.durationSeconds ? fmtDur(Number(a.durationSeconds)) : "Video"), Number(a.versionCount) > 0 && /*#__PURE__*/React.createElement("span", {
        className: "as-ver",
        title: `${Number(a.versionCount)} edited version${Number(a.versionCount) === 1 ? "" : "s"} on top of the original`
      }, "v", Number(a.versionCount) + 1), searching && a.why ? /*#__PURE__*/React.createElement("span", {
        className: "as-why",
        title: "Why this matched"
      }, a.why) : null, s.bulkMode && /*#__PURE__*/React.createElement("span", {
        className: "as-check" + (isPicked ? " on" : ""),
        "aria-hidden": "true"
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "check")), !s.bulkMode && /*#__PURE__*/React.createElement("div", {
        className: "as-hover",
        onClick: e => e.stopPropagation()
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        title: isImg ? "Open in the picture editor" : isVid ? "Open in the clip editor" : "Open the document",
        onClick: () => this.openAssetEditor(a)
      }, isDoc ? "Open" : "Edit"), /*#__PURE__*/React.createElement("button", {
        type: "button",
        title: "Add it to one of your pieces",
        onClick: () => this.setState({
          asAddPiece: {
            ids: [id]
          },
          asPieceQ: "",
          asMenu: null
        })
      }, "Use in a piece"), /*#__PURE__*/React.createElement("button", {
        type: "button",
        "aria-label": "More",
        "aria-haspopup": "menu",
        "aria-expanded": menuOpen,
        onClick: () => this.setState({
          asMenu: menuOpen ? null : id,
          asUploadMenu: false
        })
      }, "\xB7\xB7\xB7"))), menuOpen && /*#__PURE__*/React.createElement("div", {
        className: "as-menuanchor"
      }, /*#__PURE__*/React.createElement("div", {
        className: "as-menu card",
        role: "menu",
        onClick: e => e.stopPropagation()
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        role: "menuitem",
        onClick: () => this.setState({
          asMenu: null,
          asRename: id,
          asRenameDraft: a.title || ""
        })
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "edit"), "Rename"), /*#__PURE__*/React.createElement("button", {
        type: "button",
        role: "menuitem",
        onClick: () => this.downloadAssets([a])
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "download"), "Download"), /*#__PURE__*/React.createElement("button", {
        type: "button",
        role: "menuitem",
        onClick: () => this.copyAssetLink(a)
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "link"), "Copy link"), s.hasBrandLibrary && a.source !== "brand_library" && (isImg || isVid || isDoc) ? /*#__PURE__*/React.createElement("button", {
        type: "button",
        role: "menuitem",
        onClick: () => this.saveToBrandLibrary(a)
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "collections_bookmark"), "Save to brand library") : null, isImg && /*#__PURE__*/React.createElement("button", {
        type: "button",
        role: "menuitem",
        onClick: () => this.setState({
          asMenu: null,
          editAsset: a
        })
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "tune"), "Quick edit"), isImg && /*#__PURE__*/React.createElement("button", {
        type: "button",
        role: "menuitem",
        onClick: () => this.setState({
          asMenu: null,
          altOpen: {
            ...openAlt,
            [id]: true
          }
        })
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "notes"), a.altText ? "Change the description" : "Write a description"), /*#__PURE__*/React.createElement("span", {
        className: "sep"
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        role: "menuitem",
        className: "danger",
        onClick: () => this.setState({
          asMenu: null,
          deleteAsset: a
        })
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "delete_outline"), "Move to Trash"))), /*#__PURE__*/React.createElement("div", {
        className: "as-body"
      }, s.asRename === id ? /*#__PURE__*/React.createElement("input", {
        className: "as-rename",
        autoFocus: true,
        "aria-label": "Name",
        value: s.asRenameDraft || "",
        maxLength: 200,
        onClick: e => e.stopPropagation(),
        onChange: e => this.setState({
          asRenameDraft: e.target.value
        }),
        onKeyDown: e => {
          if (e.key === "Enter") this.renameAsset(a);
          if (e.key === "Escape") this.setState({
            asRename: null
          });
        },
        onBlur: () => this.renameAsset(a)
      }) : /*#__PURE__*/React.createElement("b", {
        className: "as-title",
        title: title
      }, /*#__PURE__*/React.createElement("span", null, title), isImg && !a.altText && /*#__PURE__*/React.createElement("span", {
        className: "as-dot",
        title: "No description for screen readers yet"
      })), /*#__PURE__*/React.createElement("span", {
        className: "as-meta"
      }, metaLine(a)), isImg && openAlt[id] && /*#__PURE__*/React.createElement("div", {
        className: "as-altedit",
        onClick: e => e.stopPropagation()
      }, /*#__PURE__*/React.createElement("input", {
        value: altValue,
        autoFocus: true,
        "aria-label": "Description",
        placeholder: altBusy ? "Writing…" : "What the picture shows",
        onChange: e => this.setState({
          altDraft: {
            ...s.altDraft,
            [id]: e.target.value
          }
        }),
        onBlur: () => {
          if (draft !== undefined && draft !== (a.altText || "")) this.saveAlt(a, draft.trim());
        },
        onKeyDown: e => {
          if (e.key === "Enter") e.target.blur();
          if (e.key === "Escape") this.setState({
            altOpen: {
              ...openAlt,
              [id]: false
            }
          });
        }
      }), /*#__PURE__*/React.createElement("span", {
        className: "as-altacts"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "as-link",
        disabled: altBusy,
        title: "Plunk looks at the picture and writes it",
        onClick: () => this.writeAlt(a)
      }, altBusy ? "Writing…" : "Write it for me"), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "as-link quiet",
        onClick: () => this.setState({
          altOpen: {
            ...openAlt,
            [id]: false
          }
        })
      }, "Done")))));
    })), !s.bulkMode && all !== undefined && /*#__PURE__*/React.createElement("p", {
      className: "as-trashline"
    }, "Looking for something you deleted? ", /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "as-link",
      onClick: () => this.setState({
        assetKind: "trash",
        ...closeMenus
      })
    }, "Open Trash")), s.bulkMode && nPicked > 0 && /*#__PURE__*/React.createElement("div", {
      className: "as-dock",
      role: "toolbar",
      "aria-label": "Picked files"
    }, s.showcaseUrl && /*#__PURE__*/React.createElement("div", {
      className: "as-share"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "public"), /*#__PURE__*/React.createElement("a", {
      href: s.showcaseUrl,
      target: "_blank",
      rel: "noreferrer"
    }, s.showcaseUrl.replace(/^https?:\/\//, "")), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "as-link",
      onClick: () => {
        try {
          navigator.clipboard.writeText(s.showcaseUrl);
          toast("Link copied.");
        } catch (e) {/* ignore */}
      }
    }, "Copy"), /*#__PURE__*/React.createElement("span", {
      className: "q"
    }, "Anyone with the link can see the pictures for 30 days."), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "as-x",
      "aria-label": "Close",
      onClick: () => this.setState({
        showcaseUrl: null
      })
    }, "\u2715")), /*#__PURE__*/React.createElement("div", {
      className: "as-dockbar"
    }, /*#__PURE__*/React.createElement("b", null, nPicked, " picked"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: () => this.setState({
        asAddPiece: {
          ids: picked.map(a => String(a.id))
        },
        asPieceQ: "",
        ...closeMenus
      })
    }, "Add to a piece"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      title: "Start a new story with these pictures and videos (up to 20)",
      onClick: this.useInNewStory
    }, "Use in a new story"), /*#__PURE__*/React.createElement("span", {
      className: "as-menuwrap"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: s.asEditMenu ? "on" : "",
      "aria-haspopup": "menu",
      "aria-expanded": !!s.asEditMenu,
      disabled: s.bulkBusy,
      onClick: () => this.setState({
        asEditMenu: !s.asEditMenu,
        asBadgeOpen: false
      })
    }, s.bulkBusy ? "Sending…" : "Edit them together ▾"), s.asEditMenu && /*#__PURE__*/React.createElement("div", {
      className: "as-menu up",
      role: "menu"
    }, pickedImgs.length ? /*#__PURE__*/React.createElement("span", {
      className: "h"
    }, pickedImgs.length === nPicked ? "" : `Applies to the ${plural(pickedImgs.length, "picture", "pictures")} you picked. `, "You approve it in Autopilot first. Each one then gets a new version; the originals stay.") : /*#__PURE__*/React.createElement("span", {
      className: "h"
    }, "Pick at least one picture to edit them together."), BULK_ACTIONS.filter(([k]) => k !== "badge").map(([k]) => /*#__PURE__*/React.createElement("button", {
      key: k,
      type: "button",
      role: "menuitem",
      disabled: !pickedImgs.length,
      onClick: () => this.setState({
        bulkAction: k,
        asEditMenu: false
      }, this.proposeBulk)
    }, BULK_LABELS[k] || k)), BULK_ACTIONS.some(([k]) => k === "badge") && (s.asBadgeOpen ? /*#__PURE__*/React.createElement("span", {
      className: "as-badgerow"
    }, /*#__PURE__*/React.createElement("input", {
      value: s.bulkText,
      maxLength: 24,
      autoFocus: true,
      "aria-label": "Badge text",
      placeholder: "SALE",
      onChange: e => this.setState({
        bulkText: e.target.value
      }),
      onKeyDown: e => {
        if (e.key === "Enter" && (s.bulkText || "").trim()) this.setState({
          bulkAction: "badge",
          asEditMenu: false,
          asBadgeOpen: false
        }, this.proposeBulk);
      }
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "as-btn ink sm",
      disabled: !(s.bulkText || "").trim(),
      onClick: () => this.setState({
        bulkAction: "badge",
        asEditMenu: false,
        asBadgeOpen: false
      }, this.proposeBulk)
    }, "Add")) : /*#__PURE__*/React.createElement("button", {
      type: "button",
      role: "menuitem",
      disabled: !pickedImgs.length,
      onClick: () => this.setState({
        asBadgeOpen: true
      })
    }, BULK_LABELS.badge, "\u2026")), /*#__PURE__*/React.createElement("span", {
      className: "sep"
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      role: "menuitem",
      disabled: !pickedImgs.length,
      onClick: this.describePicked
    }, "Write descriptions"))), /*#__PURE__*/React.createElement("button", {
      type: "button",
      disabled: !pickedImgs.length || s.showcaseBusy,
      title: pickedImgs.length ? "A web page with the picked pictures that anyone with the link can see (30 days)" : "Pick pictures to share a link",
      onClick: this.createShowcase
    }, s.showcaseBusy ? "Making the link…" : "Share a link"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      disabled: s.asDlBusy,
      onClick: () => this.downloadAssets(picked)
    }, s.asDlBusy ? "Downloading…" : "Download"), /*#__PURE__*/React.createElement("span", {
      className: "div"
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "danger",
      disabled: s.bulkBusy,
      title: "Restore from Trash within 30 days",
      onClick: this.deletePicked
    }, "Move to Trash"))), s.asAddPiece && (() => {
      const pq = (s.asPieceQ || "").trim().toLowerCase();
      const when = c => {
        const x = new Date(c.modifiedDate || c.createdDate).getTime();
        return isNaN(x) ? 0 : x;
      };
      const list = pieces.filter(c => !pq || String(cleanTitle(c.title) || "").toLowerCase().includes(pq)).sort((x, y) => when(y) - when(x)).slice(0, 60);
      const n = s.asAddPiece.ids.length;
      return /*#__PURE__*/React.createElement("div", {
        className: "as-modal-back",
        onMouseDown: e => {
          if (e.target === e.currentTarget && !s.asAddBusy) this.setState({
            asAddPiece: null
          });
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "as-modal",
        role: "dialog",
        "aria-modal": "true",
        "aria-label": "Add to a piece",
        onKeyDown: e => {
          if (e.key === "Escape" && !s.asAddBusy) this.setState({
            asAddPiece: null
          });
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "as-modal-h"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "Add to a piece"), /*#__PURE__*/React.createElement("span", null, n === 1 ? "The file is added to the piece you choose." : `${n} files are added to the piece you choose.`)), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "as-x",
        "aria-label": "Close",
        disabled: s.asAddBusy,
        onClick: () => this.setState({
          asAddPiece: null
        })
      }, "\u2715")), /*#__PURE__*/React.createElement("label", {
        className: "as-search sm"
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "search"), /*#__PURE__*/React.createElement("input", {
        type: "search",
        value: s.asPieceQ || "",
        autoFocus: true,
        placeholder: "Find a piece",
        "aria-label": "Find a piece",
        onChange: e => this.setState({
          asPieceQ: e.target.value
        })
      })), /*#__PURE__*/React.createElement("div", {
        className: "as-plist"
      }, !list.length ? /*#__PURE__*/React.createElement("p", {
        className: "as-note"
      }, pieces.length ? "No piece has that name." : "No pieces yet. Make one from the Library or start a new story.") : list.map(c => /*#__PURE__*/React.createElement("button", {
        key: String(c.id),
        type: "button",
        className: "as-prow",
        disabled: s.asAddBusy,
        onClick: () => this.linkAssetsToPiece(c)
      }, /*#__PURE__*/React.createElement("span", {
        className: "th"
      }, c.coverUrl && c.coverKind !== "video" ? /*#__PURE__*/React.createElement("img", {
        src: c.coverUrl,
        alt: "",
        loading: "lazy",
        onError: e => {
          e.target.style.display = "none";
        }
      }) : /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "article")), /*#__PURE__*/React.createElement("span", {
        className: "tx"
      }, /*#__PURE__*/React.createElement("b", null, cleanTitle(c.title) || "Untitled"), /*#__PURE__*/React.createElement("i", null, this.pieceKindLine(c)))))), s.asAddBusy && /*#__PURE__*/React.createElement("p", {
        className: "as-note"
      }, "Adding\u2026")));
    })(), s.asNote && /*#__PURE__*/React.createElement("div", {
      className: "as-toast" + (s.bulkMode && nPicked ? " raised" : ""),
      role: "status"
    }, /*#__PURE__*/React.createElement("span", null, s.asNote.text), s.asNote.pieceId && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "as-link light",
      onClick: () => {
        const pid = s.asNote.pieceId;
        this.setState({
          asNote: null,
          bulkMode: false,
          bulkPicked: {}
        });
        this.openDetail({
          id: pid
        });
      }
    }, "Open"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "as-x light",
      "aria-label": "Close",
      onClick: () => this.setState({
        asNote: null
      })
    }, "\u2715")), s.editAsset && /*#__PURE__*/React.createElement(EditModeModal, {
      asset: s.editAsset,
      runAgent: this.runAgent,
      waitAgent: this.waitAgent,
      creditsToast: this.creditsToast,
      onSaved: () => {
        this.loadAssets();
        this.loadCredits();
      },
      onClose: () => this.setState({
        editAsset: null
      })
    }), s.deleteAsset && /*#__PURE__*/React.createElement(DeleteSheet, {
      asset: s.deleteAsset,
      onDone: () => this.loadAssets(),
      onClose: () => this.setState({
        deleteAsset: null
      })
    }), s.videoEditAsset && /*#__PURE__*/React.createElement(VideoEditModal, {
      asset: s.videoEditAsset,
      onSaved: () => {
        this.loadAssets();
      },
      onClose: () => this.setState({
        videoEditAsset: null
      })
    }), s.videoResizeAsset && /*#__PURE__*/React.createElement(VideoResizeModal, {
      asset: s.videoResizeAsset,
      onSaved: () => {
        this.loadAssets();
      },
      onClose: () => this.setState({
        videoResizeAsset: null
      })
    }), s.trimAsset && /*#__PURE__*/React.createElement(TrimModal, {
      asset: s.trimAsset,
      onSaved: () => {
        this.loadAssets();
      },
      onClose: () => this.setState({
        trimAsset: null
      })
    }), s.clipsAsset && /*#__PURE__*/React.createElement(ClipsModal, {
      asset: s.clipsAsset,
      onSaved: () => {
        this.loadAssets();
      },
      onClose: () => this.setState({
        clipsAsset: null
      })
    }), s.resizeAsset && /*#__PURE__*/React.createElement(SmartResizeModal, {
      asset: s.resizeAsset,
      runAgent: this.runAgent,
      waitAgent: this.waitAgent,
      creditsToast: this.creditsToast,
      onSaved: () => {
        this.loadAssets();
        this.loadCredits();
      },
      onClose: () => this.setState({
        resizeAsset: null
      })
    }));
  }
  renderCreateMedia() {
    const s = this.state;
    return /*#__PURE__*/React.createElement(CreateMediaSheet, {
      tab: s.createMedia === "sequence" ? "sequence" : undefined,
      assets: (s.assets || []).filter(a => a && a.kind === "image" && !a.parentAssetId),
      onClose: () => this.setState({
        createMedia: null
      }),
      onDone: () => {
        if (this._alive) this.setState({
          assets: undefined
        }, () => this.loadAssets());
      },
      onOpenWorkspace: q => {
        this.setState({
          createMedia: null
        });
        this.props.history.push("/Content/images/new" + (q || "?mode=create"));
      },
      onOpenSequence: id => {
        this.setState({
          createMedia: null
        });
        this.props.history.push(`/Content/sequences/${id}`);
      },
      onNavigate: path => {
        this.setState({
          createMedia: null
        });
        this.props.history.push(path);
      }
    });
  }

  // ---- Forward content calendar (CONTENT_HUB_NEXT §4; redesign 2026-10-09, mockup calflow/Main) ----
  // Month or week grid of what is scheduled (amber) and what went out (green), a channel filter, and a
  // "Ready to schedule" column of approved pieces with no date. Clicking a day or "Pick a day" opens the
  // schedule sheet; dragging a ready piece onto a day opens the same sheet prefilled (never a silent schedule);
  // dragging a scheduled chip to another day moves it.
  static ym(d) {
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
  }
  static isoDay(d) {
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  }
  static weekStart(d) {
    const x = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    x.setDate(x.getDate() - x.getDay());
    return x;
  }
  calWindow() {
    if (this.state.calView === "week") {
      const gridStart = this.state.calWeek || ContentHubComponent.weekStart(new Date());
      const gridEnd = new Date(gridStart);
      gridEnd.setDate(gridStart.getDate() + 6);
      const first = new Date(gridStart.getFullYear(), gridStart.getMonth(), 1);
      return {
        m: first,
        first,
        last: gridEnd,
        gridStart,
        gridEnd,
        week: true
      };
    }
    const m = this.state.calMonth || (() => {
      const t = new Date();
      return new Date(t.getFullYear(), t.getMonth(), 1);
    })();
    const first = new Date(m.getFullYear(), m.getMonth(), 1);
    const last = new Date(m.getFullYear(), m.getMonth() + 1, 0);
    // Pad to whole weeks (Sun-first) so the grid is rectangular.
    const gridStart = new Date(first);
    gridStart.setDate(first.getDate() - first.getDay());
    const gridEnd = new Date(last);
    gridEnd.setDate(last.getDate() + (6 - last.getDay()));
    return {
      m: first,
      first,
      last,
      gridStart,
      gridEnd
    };
  }
  /** Pieces ready to schedule: approved (some version approved), nothing published, not archived, and no open date
   *  on the calendar from today on (or in the window on screen). Channel names use the calendar's labels. */
  calReady(containers) {
    const dated = new Set();
    [...(this.state.cal || []), ...(this.state.calAhead || [])].forEach(r => {
      if (r && r.containerId != null && ["planned", "approved"].includes(String(r.status || ""))) dated.add(String(r.containerId));
    });
    return (containers || []).filter(c => Number(c.approvedCount) > 0 && !(Number(c.publicationCount) > 0) && !["archived", "trashed"].includes(String(c.status || "").toLowerCase()) && !dated.has(String(c.id))).map(c => ({
      c,
      chs: Array.from(new Set(chCodes(c).map(k => chName(k) || channelTypeLabel(k))))
    }));
  }
  renderCalendar(containers) {
    const s = this.state;
    const rows = s.cal;
    const w = this.calWindow();
    const week = !!w.week;
    const iso = ContentHubComponent.isoDay;
    const todayIso = iso(new Date());
    const fmt = (d, o) => d.toLocaleDateString(undefined, o);
    const label = !week ? fmt(w.m, {
      month: "long",
      year: "numeric"
    }) : w.gridStart.getMonth() === w.gridEnd.getMonth() ? `${fmt(w.gridStart, {
      month: "short",
      day: "numeric"
    })} – ${w.gridEnd.getDate()}, ${w.gridEnd.getFullYear()}` : `${fmt(w.gridStart, {
      month: "short",
      day: "numeric"
    })} – ${fmt(w.gridEnd, {
      month: "short",
      day: "numeric",
      year: "numeric"
    })}`;
    const titles = {};
    (containers || []).forEach(c => {
      titles[String(c.id)] = c.title || "";
    });
    // Plain channel names, the same everywhere (Landing page and Webpage are both "Website").
    const chLabel = r => chName(r.target) || chName(r.channel) || channelTypeLabel(r.channel, r.target);
    const all = (rows || []).map(r0 => ({
      ...r0,
      containerTitle: r0.containerTitle || titles[String(r0.containerId)] || ""
    }));
    const readyAll = this.calReady(containers);
    // Every place a piece can go, plus anything else found in this month's rows.
    const CAL_CHANNELS = ["Website", "Email", "Instagram", "Facebook", "Pinterest", "LinkedIn", "TikTok", "YouTube", "Google", "Product page", "Search ad", "Display ad", "Social ad", "TV ad"];
    const found = [...all.map(chLabel), ...readyAll.reduce((a, x) => a.concat(x.chs), [])].filter(Boolean);
    const channels = [...CAL_CHANNELS, ...found.filter(x => !CAL_CHANNELS.includes(x)).sort()].filter((x, i, a) => a.indexOf(x) === i);
    const chf = channels.includes(s.calChannel) ? s.calChannel : "";
    const shown = chf ? all.filter(r => chLabel(r) === chf) : all;
    const ready = chf ? readyAll.filter(x => x.chs.includes(chf)) : readyAll;
    const ORDER = {
      published: 0,
      approved: 1,
      planned: 2,
      skipped: 3
    };
    const byDay = {};
    shown.forEach(r => {
      const k = String(r.scheduledDate || "").slice(0, 10);
      (byDay[k] = byDay[k] || []).push(r);
    });
    Object.values(byDay).forEach(l => l.sort((a, b) => (ORDER[a.status] ?? 2) - (ORDER[b.status] ?? 2)));
    const days = [];
    const cur = new Date(w.gridStart);
    while (cur <= w.gridEnd) {
      days.push(new Date(cur));
      cur.setDate(cur.getDate() + 1);
    }
    const dow = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
    const KIND = {
      published: "out",
      approved: "sched",
      planned: "wait",
      skipped: "skip"
    };
    const STATE_NAME = {
      published: "went out",
      approved: "scheduled",
      planned: "needs approval",
      skipped: "skipped, will not go out"
    };
    const MAX = week ? Infinity : 3;
    const endDrag = () => {
      this._calDrag = null;
      if (this.state.calDrop) this.setState({
        calDrop: ""
      });
    };
    const chip = (it, dayIso) => {
      const st = KIND[it.status] ? it.status : "planned";
      const ch = chLabel(it);
      const title = it.containerTitle || it.variantTitle || "Untitled";
      const movable = st !== "published";
      return /*#__PURE__*/React.createElement("button", {
        type: "button",
        key: String(it.id),
        className: "cal-chip " + KIND[st],
        draggable: movable,
        title: `${ch}: ${title} (${STATE_NAME[st]})${it.note ? ` · ${it.note}` : ""}`,
        onDragStart: e => {
          this._calDrag = {
            sched: it
          };
          try {
            e.dataTransfer.setData("text/plain", title);
            e.dataTransfer.effectAllowed = "move";
          } catch (x) {/* older browsers */}
        },
        onDragEnd: endDrag,
        onClick: e => {
          e.stopPropagation();
          // What went out opens the piece; anything still to come opens its sheet (approve, move, skip, remove, open the piece).
          if (st === "published" && it.containerId != null) {
            this.setState({
              calMore: ""
            });
            this.openDetail({
              id: String(it.containerId)
            });
          } else this.setState({
            calMore: "",
            schedEdit: it,
            schedEditDate: dayIso,
            schedEditNote: it.note || ""
          });
        }
      }, /*#__PURE__*/React.createElement("b", null, ch), /*#__PURE__*/React.createElement("span", null, title));
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "cal-view"
    }, /*#__PURE__*/React.createElement("div", {
      className: "cal-bar"
    }, /*#__PURE__*/React.createElement("div", {
      className: "cal-nav"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      "aria-label": week ? "Previous week" : "Previous month",
      onClick: () => this.shiftMonth(-1)
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "chevron_left")), /*#__PURE__*/React.createElement("b", {
      "aria-live": "polite"
    }, label), /*#__PURE__*/React.createElement("button", {
      type: "button",
      "aria-label": week ? "Next week" : "Next month",
      onClick: () => this.shiftMonth(1)
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "chevron_right"))), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "cal-btn",
      onClick: this.calToday
    }, "Today"), /*#__PURE__*/React.createElement("div", {
      className: "cal-seg",
      role: "group",
      "aria-label": "View"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: !week ? "on" : "",
      "aria-pressed": !week,
      onClick: () => this.setCalView("month")
    }, "Month"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: week ? "on" : "",
      "aria-pressed": week,
      onClick: () => this.setCalView("week")
    }, "Week")), rows === undefined && /*#__PURE__*/React.createElement("span", {
      className: "cal-loading"
    }, "Loading\u2026"), /*#__PURE__*/React.createElement("span", {
      className: "cal-sp"
    }), /*#__PURE__*/React.createElement("span", {
      className: "cal-legend"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
      className: "out"
    }), "Went out"), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
      className: "sched"
    }), "Scheduled"), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
      className: "wait"
    }), "Needs approval")), /*#__PURE__*/React.createElement("label", {
      className: "cal-ch"
    }, "Channel", /*#__PURE__*/React.createElement("select", {
      value: chf,
      onChange: e => this.setState({
        calChannel: e.target.value,
        calMore: ""
      })
    }, /*#__PURE__*/React.createElement("option", {
      value: ""
    }, "All channels"), channels.map(c => /*#__PURE__*/React.createElement("option", {
      key: c,
      value: c
    }, c))))), /*#__PURE__*/React.createElement("div", {
      className: "cal-body"
    }, /*#__PURE__*/React.createElement("div", {
      className: "cal-grid-wrap" + (week ? " week" : "")
    }, /*#__PURE__*/React.createElement("div", {
      className: "cal-head"
    }, dow.map(d => /*#__PURE__*/React.createElement("span", {
      key: d
    }, d))), /*#__PURE__*/React.createElement("div", {
      className: "cal-grid"
    }, days.map(d => {
      const dayIso = iso(d);
      const inMonth = week || d.getMonth() === w.m.getMonth();
      const items = byDay[dayIso] || [];
      const extra = items.length > MAX ? items.length - MAX : 0;
      const visible = extra ? items.slice(0, MAX) : items;
      const dayName = fmt(d, {
        weekday: "long",
        month: "long",
        day: "numeric"
      });
      return /*#__PURE__*/React.createElement("div", {
        key: dayIso,
        className: "cal-day" + (inMonth ? "" : " out") + (dayIso === todayIso ? " today" : "") + (s.calDrop === dayIso ? " drop" : ""),
        onClick: () => this.openScheduler(dayIso),
        onDragOver: e => {
          if (!this._calDrag) return;
          e.preventDefault();
          if (this.state.calDrop !== dayIso) this.setState({
            calDrop: dayIso
          });
        },
        onDragLeave: e => {
          if (!e.currentTarget.contains(e.relatedTarget) && this.state.calDrop === dayIso) this.setState({
            calDrop: ""
          });
        },
        onDrop: e => {
          e.preventDefault();
          const drag = this._calDrag;
          endDrag();
          if (!drag) return;
          if (drag.piece) this.openScheduler(dayIso, drag.piece.id);else if (drag.sched && String(drag.sched.scheduledDate || "").slice(0, 10) !== dayIso) this.rescheduleItem(drag.sched.id, dayIso);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "cal-daytop"
      }, /*#__PURE__*/React.createElement("span", {
        className: "cal-num"
      }, week ? `${fmt(d, {
        month: "short"
      })} ${d.getDate()}` : d.getDate()), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "cal-add",
        "aria-label": `Schedule something on ${dayName}`,
        title: "Schedule on this day",
        onClick: e => {
          e.stopPropagation();
          this.openScheduler(dayIso);
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "add"))), visible.map(it => chip(it, dayIso)), extra > 0 && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "cal-more",
        "aria-expanded": s.calMore === dayIso,
        onClick: e => {
          e.stopPropagation();
          this.setState({
            calMore: s.calMore === dayIso ? "" : dayIso
          });
        }
      }, "+", extra, " more"), s.calMore === dayIso && /*#__PURE__*/React.createElement("div", {
        className: "cal-pop" + (d.getDay() >= 5 ? " r" : ""),
        role: "dialog",
        "aria-label": dayName,
        onClick: e => e.stopPropagation()
      }, /*#__PURE__*/React.createElement("div", {
        className: "cal-pop-h"
      }, /*#__PURE__*/React.createElement("b", null, dayName), /*#__PURE__*/React.createElement("button", {
        type: "button",
        "aria-label": "Close",
        onClick: () => this.setState({
          calMore: ""
        })
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "close"))), items.map(it => chip(it, dayIso))));
    }))), /*#__PURE__*/React.createElement("aside", {
      className: "cal-side",
      "aria-label": "Ready to schedule"
    }, /*#__PURE__*/React.createElement("b", {
      className: "cal-side-t"
    }, "Ready to schedule"), /*#__PURE__*/React.createElement("span", {
      className: "cal-side-s"
    }, "Approved pieces with no date yet. Drag one onto a day, or pick a day."), ready.length ? (s.calReadyAll ? ready : ready.slice(0, 8)).map(({
      c,
      chs
    }) => /*#__PURE__*/React.createElement("div", {
      key: String(c.id),
      className: "cal-ready",
      draggable: true,
      onDragStart: e => {
        this._calDrag = {
          piece: c
        };
        try {
          e.dataTransfer.setData("text/plain", c.title || "Untitled");
          e.dataTransfer.effectAllowed = "copy";
        } catch (x) {/* older browsers */}
      },
      onDragEnd: endDrag
    }, /*#__PURE__*/React.createElement("span", {
      className: "cal-grip",
      "aria-hidden": "true"
    }), /*#__PURE__*/React.createElement("div", {
      className: "cal-ready-b"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "cal-ready-t",
      title: "Open this piece",
      onClick: () => this.openDetail({
        id: String(c.id)
      })
    }, c.title || "Untitled"), /*#__PURE__*/React.createElement("span", null, chs.length ? chs.slice(0, 2).join(", ") + (chs.length > 2 ? ` +${chs.length - 2}` : "") : "No channel yet", " \xB7 approved")), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "cal-pick",
      onClick: () => this.openScheduler("", c.id)
    }, "Pick a day"))) : /*#__PURE__*/React.createElement("div", {
      className: "cal-side-empty"
    }, rows === undefined ? "Loading…" : chf ? `Nothing approved for ${chf} is waiting for a date.` : "Nothing is waiting. Approved pieces without a date show up here."), ready.length > 8 && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "cal-link",
      onClick: () => this.setState({
        calReadyAll: !s.calReadyAll
      })
    }, s.calReadyAll ? "Show fewer" : `Show all ${ready.length}`), /*#__PURE__*/React.createElement("span", {
      className: "cal-side-note"
    }, "Approved pieces go out on their day: Plunk checks every hour and sends what is due. Pieces that need approval wait until someone approves them."))), s.calMore && /*#__PURE__*/React.createElement("div", {
      className: "cal-pop-back",
      onClick: () => this.setState({
        calMore: ""
      })
    }), s.schedOpen && this.renderScheduleModal(containers), s.schedEdit && this.renderScheduleEdit());
  }

  // Click an item on the calendar (2026-10-02): move it, change its status or remove it from one sheet.
  renderScheduleEdit() {
    const it = this.state.schedEdit;
    const date = this.state.schedEditDate || String(it.scheduledDate || "").slice(0, 10);
    const note = this.state.schedEditNote != null ? this.state.schedEditNote : it.note || "";
    const dateChanged = date && date !== String(it.scheduledDate || "").slice(0, 10);
    const noteChanged = note !== (it.note || "");
    const close = () => this.setState({
      schedEdit: null,
      schedEditDate: "",
      schedEditNote: null
    });
    const status = String(it.status || "planned");
    const act = async fn => {
      await fn();
      close();
    };
    const STATUS = [["planned", "Needs approval"], ["approved", "Approved"], ["skipped", "Skipped"]];
    return /*#__PURE__*/React.createElement("div", {
      className: "wa-modal-backdrop hub-edit-backdrop",
      onClick: close
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-trash-sheet hub-sched",
      onClick: e => e.stopPropagation()
    }, /*#__PURE__*/React.createElement("h3", {
      className: "hub-h3",
      style: {
        marginBottom: 2
      }
    }, it.containerTitle || "Untitled"), /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: "0 0 14px"
      }
    }, channelTypeLabel(it.channel, it.target), status === "published" ? " · went out" : status === "planned" ? " · needs approval" : status === "skipped" ? " · skipped" : " · scheduled", ". The name is the piece's title; rename it from the Library."), status === "published" ? /*#__PURE__*/React.createElement("p", {
      className: "territory-hint"
    }, "This one already went out. The publication is recorded under the piece.") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", null, "Day", /*#__PURE__*/React.createElement("input", {
      type: "date",
      value: date,
      onChange: e => this.setState({
        schedEditDate: e.target.value
      }),
      style: {
        ...INPUT,
        height: "34px",
        padding: "0 10px",
        marginTop: "4px"
      }
    })), /*#__PURE__*/React.createElement("label", null, "Label ", /*#__PURE__*/React.createElement("i", {
      style: {
        fontStyle: "normal",
        fontWeight: 500,
        letterSpacing: 0,
        textTransform: "none"
      }
    }, "optional, shows on the calendar"), /*#__PURE__*/React.createElement("input", {
      value: note,
      placeholder: "e.g. tie to the fall sale",
      onChange: e => this.setState({
        schedEditNote: e.target.value
      }),
      style: {
        ...INPUT,
        height: "34px",
        padding: "0 10px",
        marginTop: "4px"
      }
    })), /*#__PURE__*/React.createElement("label", null, "Status"), /*#__PURE__*/React.createElement("span", {
      className: "seg",
      style: {
        marginTop: 4
      }
    }, STATUS.map(([k, l]) => /*#__PURE__*/React.createElement("button", {
      key: k,
      className: status === k ? "on" : "",
      onClick: () => act(() => this.setScheduleStatus(it.id, k))
    }, l))), /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: "8px 0 0"
      }
    }, "Approved items go out on their day. Skipped items stay on the calendar but never publish.")), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: 8,
        alignItems: "center",
        marginTop: 18
      }
    }, status !== "published" && /*#__PURE__*/React.createElement("button", {
      className: "hub-rec-dismiss",
      onClick: () => act(() => this.deleteScheduleItem(it.id))
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "delete_outline"), "Remove"), it.containerId != null && /*#__PURE__*/React.createElement("button", {
      className: "hub-rec-dismiss",
      onClick: () => {
        close();
        this.openDetail({
          id: String(it.containerId)
        });
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "open_in_new"), "Open the piece"), /*#__PURE__*/React.createElement("span", {
      style: {
        marginLeft: "auto",
        display: "inline-flex",
        gap: 8
      }
    }, /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle",
      style: {
        margin: 0
      },
      onClick: close
    }, "Cancel"), status !== "published" && /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
      disabled: !dateChanged && !noteChanged,
      onClick: () => act(() => this.updateScheduleItem(it.id, {
        ...(dateChanged ? {
          scheduledDate: date
        } : {}),
        ...(noteChanged ? {
          note
        } : {})
      }))
    }, dateChanged ? `Move to ${date}` : "Save")))));
  }
  renderScheduleModal(containers) {
    const {
      schedContainerId,
      schedVariants,
      schedVariantId,
      schedTarget,
      schedDate,
      schedNote,
      schedBusy
    } = this.state;
    const inputStyle = {
      ...INPUT,
      height: "34px",
      padding: "0 10px",
      marginTop: "4px"
    };
    const TARGETS = [["blog", "Blog"], ["web", "Website"], ["landing", "Landing page"], ["email", "Email"], ["social_facebook", "Facebook"], ["social_instagram", "Instagram"], ["social_pinterest", "Pinterest"], ["gbp_post", "Google Business"], ["product_copy", "Product copy"]];
    const canSave = schedVariantId && schedTarget && schedDate && !schedBusy;
    return /*#__PURE__*/React.createElement("div", {
      className: "wa-modal-backdrop hub-edit-backdrop",
      onClick: () => this.setState({
        schedOpen: false
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-trash-sheet hub-sched",
      onClick: e => e.stopPropagation()
    }, /*#__PURE__*/React.createElement("h3", {
      className: "hub-h3",
      style: {
        marginBottom: 2
      }
    }, "Schedule content"), /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: "0 0 14px"
      }
    }, "Pick a piece, which version and the channel, then the day it goes out."), /*#__PURE__*/React.createElement("label", {
      style: {
        fontSize: "11px",
        fontWeight: 700,
        color: "var(--plk-text-muted)",
        textTransform: "uppercase",
        letterSpacing: ".04em"
      }
    }, "Content", (() => {
      const q = String(this.state.schedQuery || "").trim().toLowerCase();
      const picked = (containers || []).find(c => String(c.id) === String(schedContainerId));
      const list = q ? (containers || []).filter(c => `${c.title || ""} ${c.storyTitle || ""} ${c.topic || ""}`.toLowerCase().includes(q)).slice(0, 8) : [];
      return /*#__PURE__*/React.createElement("div", {
        className: "hub-pick"
      }, /*#__PURE__*/React.createElement("span", {
        className: "hub-pick-input"
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, picked ? "check_circle" : "search"), /*#__PURE__*/React.createElement("input", {
        value: picked && !this.state.schedPickOpen ? picked.title || "Untitled" : this.state.schedQuery || "",
        placeholder: "Type to find a piece",
        onFocus: () => this.setState({
          schedPickOpen: true,
          schedQuery: ""
        }),
        onBlur: () => setTimeout(() => this._alive !== false && this.setState({
          schedPickOpen: false
        }), 150),
        onChange: e => this.setState({
          schedQuery: e.target.value,
          schedPickOpen: true
        })
      }), picked && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "hub-pick-clear",
        title: "Clear",
        onMouseDown: e => e.preventDefault(),
        onClick: () => {
          this.pickSchedContainer("");
          this.setState({
            schedQuery: "",
            schedPickOpen: true
          });
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "close"))), this.state.schedPickOpen && (q ? /*#__PURE__*/React.createElement("div", {
        className: "hub-pick-list"
      }, list.length ? list.map(c => /*#__PURE__*/React.createElement("div", {
        key: String(c.id),
        className: "hub-pick-row",
        onMouseDown: e => e.preventDefault(),
        onClick: () => {
          this.pickSchedContainer(String(c.id));
          this.setState({
            schedPickOpen: false,
            schedQuery: ""
          });
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, originIcon(c.origin)), /*#__PURE__*/React.createElement("span", {
        className: "t"
      }, c.title || "Untitled"), /*#__PURE__*/React.createElement("span", {
        className: "m"
      }, c.storyTitle ? c.storyTitle : String(c.origin || "").replace(/_/g, " "), Number(c.variantCount) ? ` · ${num(c.variantCount)} version${c.variantCount === 1 ? "" : "s"}` : ""))) : /*#__PURE__*/React.createElement("div", {
        className: "hub-pick-row none"
      }, "No pieces match \"", this.state.schedQuery, "\"")) : /*#__PURE__*/React.createElement("div", {
        className: "hub-pick-list"
      }, /*#__PURE__*/React.createElement("div", {
        className: "hub-pick-row none"
      }, "Start typing a title, story or topic"))));
    })()), /*#__PURE__*/React.createElement("label", {
      style: {
        display: "block",
        marginTop: "12px",
        fontSize: "11px",
        fontWeight: 700,
        color: "var(--plk-text-muted)",
        textTransform: "uppercase",
        letterSpacing: ".04em"
      }
    }, "Version", /*#__PURE__*/React.createElement("select", {
      value: schedVariantId,
      disabled: !schedContainerId || schedVariants === undefined,
      onChange: e => this.setState({
        schedVariantId: e.target.value
      }),
      style: inputStyle
    }, schedVariants === undefined ? /*#__PURE__*/React.createElement("option", {
      value: ""
    }, schedContainerId ? "Loading…" : "Pick content first") : !schedVariants.length ? /*#__PURE__*/React.createElement("option", {
      value: ""
    }, "No versions yet: make it for a channel first") : schedVariants.map(v => /*#__PURE__*/React.createElement("option", {
      key: String(v.id),
      value: String(v.id)
    }, channelTypeLabel(v.channel), v.title ? `: ${v.title}` : "")))), /*#__PURE__*/React.createElement("label", {
      style: {
        display: "block",
        marginTop: "12px",
        fontSize: "11px",
        fontWeight: 700,
        color: "var(--plk-text-muted)",
        textTransform: "uppercase",
        letterSpacing: ".04em"
      }
    }, "Channel", /*#__PURE__*/React.createElement("select", {
      value: schedTarget,
      onChange: e => this.setState({
        schedTarget: e.target.value
      }),
      style: inputStyle
    }, /*#__PURE__*/React.createElement("option", {
      value: ""
    }, "Choose a channel\u2026"), TARGETS.map(([k, label]) => /*#__PURE__*/React.createElement("option", {
      key: k,
      value: k
    }, label)))), /*#__PURE__*/React.createElement("label", {
      style: {
        display: "block",
        marginTop: "12px",
        fontSize: "11px",
        fontWeight: 700,
        color: "var(--plk-text-muted)",
        textTransform: "uppercase",
        letterSpacing: ".04em"
      }
    }, "Date", /*#__PURE__*/React.createElement("input", {
      type: "date",
      value: schedDate,
      onChange: e => this.setState({
        schedDate: e.target.value
      }),
      style: inputStyle
    })), /*#__PURE__*/React.createElement("label", {
      style: {
        display: "block",
        marginTop: "12px",
        fontSize: "11px",
        fontWeight: 700,
        color: "var(--plk-text-muted)",
        textTransform: "uppercase",
        letterSpacing: ".04em"
      }
    }, "Note (optional)", /*#__PURE__*/React.createElement("input", {
      value: schedNote,
      onChange: e => this.setState({
        schedNote: e.target.value
      }),
      placeholder: "e.g. tie to the fall sale",
      style: inputStyle
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "flex-end",
        gap: "8px",
        marginTop: "20px"
      }
    }, /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle",
      onClick: () => this.setState({
        schedOpen: false
      })
    }, "Cancel"), /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
      disabled: !canSave,
      onClick: this.saveSchedule
    }, schedBusy ? "Scheduling…" : "Schedule"))));
  }

  // Stories (redesign 2026-10-08, mockup storyflow/Main): search + In progress / Live / Archived pills, one card per
  // story; the whole card opens it in the Builder, everything else lives in the card's ··· menu.
  renderStories(containers) {
    const q = (this.state.search || "").trim().toLowerCase();
    const isArch = st => st.members.length > 0 && st.members.every(m => String(m.status || "").toLowerCase() === "archived");
    const all = this.buildStories(containers).map(s => ({
      ...s,
      f: storyFacts(s)
    }));
    const trashList = this.trashStories().map(s => ({
      ...s,
      f: storyFacts(s)
    }));
    const groups = {
      progress: all.filter(s => !isArch(s) && !s.f.live),
      live: all.filter(s => !isArch(s) && s.f.live),
      archived: all.filter(isArch),
      trash: trashList
    };
    const want = this.state.storiesView === "active" ? "progress" : this.state.storiesView;
    const view = groups[want] && (want === "progress" || want === "live" || groups[want].length) ? want : "progress";
    let stories = groups[view];
    if (q) stories = stories.filter(s => (s.title || "").toLowerCase().includes(q) || s.members.some(m => (m.title || "").toLowerCase().includes(q)));
    const nothing = !all.length && !trashList.length;
    const pill = (k, l) => /*#__PURE__*/React.createElement("button", {
      type: "button",
      key: k,
      className: "st-pill" + (view === k ? " on" : ""),
      "aria-pressed": view === k,
      onClick: () => this.setState({
        storiesView: k,
        storyMenu: null,
        storyArchiveAsk: null,
        storyTrashAsk: null
      })
    }, l, /*#__PURE__*/React.createElement("span", {
      className: "c"
    }, num(groups[k].length)));
    const why = q ? `No stories match "${this.state.search}".` : view === "trash" ? "The Trash is empty." : view === "archived" ? "No archived stories." : view === "live" ? "Nothing is live yet. A story shows here once its pieces are published." : groups.live.length ? "Nothing in progress. Your published stories are under Live." : "Nothing in progress.";
    const activeStory = all.find(s => this.state.storyRepurpose === s.storyId || this.state.storyPublish === s.storyId || this.state.storyMedia && String(this.state.storyMedia.storyId) === String(s.storyId));
    const closeSheet = () => this.setState({
      storyRepurpose: null,
      storyPublish: null,
      storyPublishPlan: undefined,
      storyMedia: null,
      imageOpen: false,
      videoOpen: false
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "st-view"
    }, /*#__PURE__*/React.createElement("div", {
      className: "st-bar"
    }, /*#__PURE__*/React.createElement("label", {
      className: "st-search"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      "aria-hidden": "true"
    }, "search"), /*#__PURE__*/React.createElement("input", {
      type: "search",
      value: this.state.search,
      placeholder: "Search stories",
      "aria-label": "Search stories",
      onChange: e => this.setState({
        search: e.target.value
      })
    })), /*#__PURE__*/React.createElement("div", {
      className: "st-pills",
      role: "group",
      "aria-label": "Show"
    }, pill("progress", "In progress"), pill("live", "Live"), pill("archived", "Archived"), trashList.length > 0 && pill("trash", "Trash")), /*#__PURE__*/React.createElement("span", {
      className: "st-sp"
    })), /*#__PURE__*/React.createElement("p", {
      className: "st-intro"
    }, "A story is one campaign: you describe it once, Plunk writes every piece for every channel, you approve and publish them together."), nothing ? /*#__PURE__*/React.createElement("div", {
      className: "st-empty"
    }, /*#__PURE__*/React.createElement("b", null, "No stories yet"), /*#__PURE__*/React.createElement("span", null, "Start one with New story. Or, in the Library, select pieces that belong together and group them into a story.")) : !stories.length ? /*#__PURE__*/React.createElement("div", {
      className: "st-empty"
    }, /*#__PURE__*/React.createElement("span", null, why)) : /*#__PURE__*/React.createElement("div", {
      className: "st-grid"
    }, stories.map(s => this.storyCard(s, view))), activeStory && /*#__PURE__*/React.createElement("div", {
      className: "wa-modal-backdrop hub-edit-backdrop",
      onClick: closeSheet
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-trash-sheet hub-story-sheet",
      onClick: e => e.stopPropagation()
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-story-sheet-head"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "hub-h3",
      style: {
        margin: 0
      }
    }, activeStory.title), /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, this.state.storyRepurpose === activeStory.storyId ? "Repurpose the story" : this.state.storyPublish === activeStory.storyId ? "Publish everywhere" : this.state.imageOpen ? "Generate an image" : "Make a video"), /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle sm",
      style: {
        margin: "0 0 0 auto"
      },
      onClick: closeSheet
    }, "Close")), this.renderStoryPanels(activeStory, true))));
  }
  /** One story card: cover, title + ··· menu, the four-step bar with one status line, one results line. */
  storyCard(s, view) {
    const id = String(s.storyId);
    const f = s.f;
    const trash = view === "trash";
    const arch = view === "archived";
    const open = () => {
      if (!trash) this.props.history.push(`/Content/build/${id}`);
    };
    const tint = id.split("").reduce((a, ch) => a + ch.charCodeAt(0), 0) % 4;
    const menuOpen = this.state.storyMenu === id;
    const busy = this.state.libraryBusy;
    const close = () => this.setState({
      storyMenu: null,
      storyArchiveAsk: null,
      storyTrashAsk: null
    });
    const item = (label, fn, opts = {}) => /*#__PURE__*/React.createElement("button", {
      type: "button",
      role: "menuitem",
      className: opts.danger ? "danger" : "",
      disabled: busy,
      title: opts.title,
      onClick: fn
    }, label);
    const n = s.members.length;
    let menu;
    if (this.state.storyArchiveAsk === id) menu = /*#__PURE__*/React.createElement("div", {
      className: "st-ask"
    }, /*#__PURE__*/React.createElement("span", null, "Archive this story and its ", plural(n, "piece"), "? Anything published stays live. You can restore it from Archived."), /*#__PURE__*/React.createElement("span", {
      className: "st-ask-acts"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "st-mini dark",
      disabled: busy,
      onClick: () => {
        close();
        this.setContainersStatus(s.members, "archived");
      }
    }, "Archive"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "st-mini",
      onClick: close
    }, "Keep")));else if (this.state.storyTrashAsk === id) menu = /*#__PURE__*/React.createElement("div", {
      className: "st-ask"
    }, /*#__PURE__*/React.createElement("span", null, "Move it to the Trash? You can restore it for 30 days; after that it is deleted for good. Anything published stays live."), /*#__PURE__*/React.createElement("span", {
      className: "st-ask-acts"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "st-mini dark",
      disabled: busy,
      onClick: () => {
        close();
        this.trashStory(s.members, true);
      }
    }, "Move to Trash"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "st-mini",
      onClick: close
    }, "Keep")));else if (trash) menu = item("Restore to Archived", () => {
      close();
      this.trashStory(s.members, false);
    });else if (arch) menu = /*#__PURE__*/React.createElement(React.Fragment, null, item("Open in the Builder", () => {
      close();
      open();
    }), item("Restore", () => {
      close();
      this.setContainersStatus(s.members, "active");
    }, {
      title: "Bring the story and all its pieces back"
    }), item("Move to Trash", () => this.setState({
      storyTrashAsk: id
    }), {
      danger: true
    }));else menu = /*#__PURE__*/React.createElement(React.Fragment, null, item("Open in the Builder", () => {
      close();
      open();
    }), n > 1 && item("Ungroup the pieces", () => {
      close();
      this.ungroupStory(s.members);
    }, {
      title: "The pieces go back to the Library on their own"
    }), item("Archive", () => this.setState({
      storyArchiveAsk: id
    })));
    let line = f.line;
    if (arch) line = ["Archived", "restore it from the menu"];
    if (trash) {
      const d = this.trashDaysLeft(s.members);
      line = ["In the Trash", d == null ? "restore it from the menu" : d === 0 ? "deleted for good tonight" : `deleted for good in ${plural(d, "day")}`];
    }
    return /*#__PURE__*/React.createElement("div", {
      key: id,
      role: trash ? undefined : "button",
      tabIndex: trash ? undefined : 0,
      "aria-label": trash ? undefined : `Open ${s.title} in the Builder`,
      className: "st-card" + (trash ? " still" : "") + (menuOpen ? " menu-open" : ""),
      onClick: open,
      onKeyDown: e => {
        if ((e.key === "Enter" || e.key === " ") && e.target === e.currentTarget) {
          e.preventDefault();
          open();
        }
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "st-cover"
    }, /*#__PURE__*/React.createElement(StoryCover, {
      storyId: id,
      members: s.members,
      title: s.title,
      tint: tint
    }), /*#__PURE__*/React.createElement("span", {
      className: "st-count"
    }, plural(f.pieces, "piece"))), /*#__PURE__*/React.createElement("div", {
      className: "st-body"
    }, /*#__PURE__*/React.createElement("div", {
      className: "st-titlerow"
    }, /*#__PURE__*/React.createElement("b", {
      className: "st-title",
      title: s.title
    }, s.title), /*#__PURE__*/React.createElement("span", {
      className: "st-menuwrap",
      onClick: e => e.stopPropagation(),
      onKeyDown: e => e.stopPropagation()
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "st-more",
      "aria-label": "More actions",
      "aria-haspopup": "menu",
      "aria-expanded": menuOpen,
      onClick: () => this.setState({
        storyMenu: menuOpen ? null : id,
        storyArchiveAsk: null,
        storyTrashAsk: null
      })
    }, "\xB7\xB7\xB7"), menuOpen && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "st-scrim",
      onClick: close
    }), /*#__PURE__*/React.createElement("div", {
      className: "st-menu",
      role: "menu"
    }, menu)))), /*#__PURE__*/React.createElement("div", {
      className: "st-prog"
    }, /*#__PURE__*/React.createElement("div", {
      className: "st-steps",
      role: "img",
      "aria-label": `${ST_SEGMENTS[f.idx]} step${f.live ? ", live" : ""}`
    }, ST_SEGMENTS.map((l, i) => /*#__PURE__*/React.createElement("span", {
      key: l,
      title: l,
      className: i < f.idx ? "done" : i === f.idx ? "cur" : ""
    }))), /*#__PURE__*/React.createElement("span", {
      className: "st-line"
    }, /*#__PURE__*/React.createElement("b", null, line[0]), " \xB7 ", line[1])), /*#__PURE__*/React.createElement("span", {
      className: "st-res"
    }, f.results.length ? f.results.map(([v, l], i) => /*#__PURE__*/React.createElement(React.Fragment, {
      key: l
    }, i > 0 && " · ", /*#__PURE__*/React.createElement("b", null, v), " ", l)) : /*#__PURE__*/React.createElement("span", {
      className: "q"
    }, f.empty))));
  }

  // Builder stage chips (spec design rule 5, 2026-09-27): the primary piece's builder_state (from the list rows) +
  // approved counts → "Brief · Plan · Write 3/5 · Media 2 · Ship ✓", current stage highlighted, click → Builder.
  storyStageLabel(s) {
    const members = s.members || [];
    const primary = members.find(c => String(c.id) === String(s.storyId)) || members[0];
    let bs = null;
    try {
      bs = primary && primary.builderState ? JSON.parse(primary.builderState) : null;
    } catch (e) {
      bs = null;
    }
    const shipped = !!(bs && bs.stageDone && bs.stageDone.ship) || members.some(c => Number(c.publicationCount) > 0);
    if (shipped) return "Shipped";
    const stage = bs && bs.stage;
    return stage ? stage.charAt(0).toUpperCase() + stage.slice(1) : null;
  }
  trashDaysLeft(members) {
    // server times are UTC without a zone marker: read them as UTC, not local time
    const utc = d => {
      const x = String(d || "");
      return new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(x) ? x : x.replace(" ", "T") + "Z").getTime();
    };
    const when = Math.max(...members.map(m => utc(m.modifiedDate || m.ModifiedDate)).filter(x => !isNaN(x)));
    if (!isFinite(when)) return null;
    return Math.max(0, 30 - Math.floor((Date.now() - when) / 86400000));
  }
  trashStories() {
    const groups = new Map();
    (this.state.trashed || []).forEach(c => {
      const sid = String(c.storyId != null ? c.storyId : c.id);
      if (!groups.has(sid)) groups.set(sid, {
        storyId: sid,
        title: c.storyTitle || c.title || "Story",
        members: []
      });
      groups.get(sid).members.push(c);
    });
    return [...groups.values()];
  }

  // Story-level actions (Stories tab + Library grouped view share these, 2026-09-27): text repurpose, media
  // (image / video from every piece's blocks), publish everywhere, ungroup.
  storyActionButtons(s) {
    const open = this.state.storyRepurpose === s.storyId;
    const pubOpen = this.state.storyPublish === s.storyId;
    const media = this.state.storyMedia && String(this.state.storyMedia.storyId) === String(s.storyId) ? this.state.storyMedia : null;
    const on = (cond, color) => cond ? {
      background: color,
      color: "var(--plk-text-inverse)",
      borderColor: color
    } : {};
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle",
      style: {
        margin: 0,
        background: "var(--plk-accent)",
        color: "var(--plk-text-inverse)",
        borderColor: "var(--plk-accent)"
      },
      title: "Brief \u2192 Plan \u2192 Write \u2192 Media \u2192 Ship, on one surface",
      onClick: () => this.props.history.push(`/Content/build/${String(s.storyId)}`)
    }, "Open in Builder \u2192"), /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle",
      style: {
        margin: 0,
        ...on(open, "var(--plk-accent)")
      },
      onClick: () => this.setState({
        storyRepurpose: open ? null : s.storyId,
        storyRepurposeSel: new Set(),
        storyPublish: null,
        storyMedia: null,
        imageOpen: false,
        videoOpen: false
      })
    }, "Repurpose the story \u2192"), /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle",
      style: {
        margin: 0,
        ...on(media && this.state.imageOpen, "var(--plk-accent)")
      },
      title: "One generated image for the story: prompt from every piece's copy, reference from its images; lands on the story's primary piece and in Assets (6 credits)",
      onClick: () => media && this.state.imageOpen ? this.setState({
        imageOpen: false,
        storyMedia: null
      }) : this.openStoryMedia(s, "image")
    }, "Generate image \u2192"), /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle",
      style: {
        margin: 0,
        ...on(media && this.state.videoOpen, "var(--plk-accent)")
      },
      title: "A narrated video of the whole story: storyboard from every piece's copy and images (10 credits to render)",
      onClick: () => media && this.state.videoOpen ? this.setState({
        videoOpen: false,
        storyMedia: null
      }) : this.openStoryMedia(s, "video")
    }, "Make a video \u2192"), /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle",
      style: {
        margin: 0,
        ...on(pubOpen, "var(--plk-accent)")
      },
      title: "Every approved piece of this story goes to the first target that fits its channel: review the plan, then publish in one go",
      onClick: () => {
        if (pubOpen) {
          this.setState({
            storyPublish: null,
            storyPublishPlan: undefined
          });
        } else {
          this.setState({
            storyRepurpose: null,
            storyMedia: null,
            imageOpen: false,
            videoOpen: false
          });
          this.openStoryPublish(s);
        }
      }
    }, "Publish everywhere \u25BE"), /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle",
      style: {
        margin: 0
      },
      disabled: this.state.libraryBusy,
      onClick: () => this.ungroupStory(s.members),
      title: "Split these pieces back out of the story"
    }, "Ungroup"));
  }
  renderStoryPanels(s, cover) {
    const open = this.state.storyRepurpose === s.storyId;
    return /*#__PURE__*/React.createElement(React.Fragment, null, !cover && /*#__PURE__*/React.createElement(StoryMedia, {
      storyId: String(s.storyId),
      onOpen: a => {
        if (a.kind === "video" || a.url) window.open(a.url, "_blank", "noopener");
      }
    }), open && /*#__PURE__*/React.createElement("div", {
      className: "hub-panel accent"
    }, /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: "0 0 6px"
      }
    }, "Drafts for new channels from the whole story, grounded on every piece's blocks."), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexWrap: "wrap",
        gap: "10px 22px",
        marginBottom: "8px"
      }
    }, REPURPOSE_CHANNELS.map(([ch, label]) => /*#__PURE__*/React.createElement("label", {
      key: ch,
      style: {
        fontSize: "12px",
        display: "inline-flex",
        gap: "8px",
        alignItems: "center",
        whiteSpace: "nowrap",
        cursor: "pointer"
      }
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: this.state.storyRepurposeSel.has(ch),
      style: {
        margin: 0,
        flexShrink: 0,
        appearance: "auto",
        WebkitAppearance: "checkbox",
        position: "static",
        width: "14px",
        height: "14px"
      },
      onChange: () => {
        const next = new Set(this.state.storyRepurposeSel);
        if (next.has(ch)) next.delete(ch);else next.add(ch);
        this.setState({
          storyRepurposeSel: next
        });
      }
    }), label))), /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle",
      style: {
        margin: 0,
        ...(this.state.storyRepurposeSel.size ? {
          background: "var(--plk-accent)",
          color: "var(--plk-text-inverse)",
          borderColor: "var(--plk-accent)"
        } : {})
      },
      disabled: this.state.storyRepurposeBusy || !this.state.storyRepurposeSel.size,
      onClick: () => this.repurposeStory(s.storyId)
    }, this.state.storyRepurposeBusy ? "Queuing…" : `Generate ${this.state.storyRepurposeSel.size || ""} draft${this.state.storyRepurposeSel.size === 1 ? "" : "s"}`)), this.renderStoryMediaPanels(s), this.state.storyPublish === s.storyId && (() => {
      const plan = this.state.storyPublishPlan;
      if (plan === undefined) return /*#__PURE__*/React.createElement("p", {
        className: "territory-hint",
        style: {
          margin: "8px 0 0"
        }
      }, "Reading each piece\u2026");
      if (!plan.length) return /*#__PURE__*/React.createElement("p", {
        className: "territory-hint",
        style: {
          margin: "8px 0 0"
        }
      }, "Nothing to publish yet: approve a variant on a piece first (Publish only sends approved variants), and connect a target under Manage Data \u203A Connect.");
      const setRow = (key, patch) => this.setState({
        storyPublishPlan: plan.map(r => r.key === key ? {
          ...r,
          ...patch
        } : r)
      });
      const onCount = plan.filter(r => r.on).length;
      return /*#__PURE__*/React.createElement("div", {
        className: "hub-panel accent"
      }, /*#__PURE__*/React.createElement("p", {
        className: "territory-hint",
        style: {
          margin: "0 0 6px"
        }
      }, "Approved variants and where each one goes. Shopify writes happen right away; the rest queue to their provider."), plan.map(r => /*#__PURE__*/React.createElement("label", {
        key: r.key,
        style: {
          display: "flex",
          gap: 8,
          alignItems: "center",
          fontSize: "12px",
          padding: "3px 0",
          cursor: "pointer"
        }
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        checked: r.on,
        onChange: () => setRow(r.key, {
          on: !r.on
        }),
        style: {
          margin: 0,
          flexShrink: 0,
          appearance: "auto",
          WebkitAppearance: "checkbox",
          position: "static",
          width: "14px",
          height: "14px"
        }
      }), /*#__PURE__*/React.createElement("span", {
        style: {
          flex: 1,
          minWidth: 0,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        },
        title: r.piece
      }, r.piece, " ", /*#__PURE__*/React.createElement("span", {
        className: "territory-hint",
        style: {
          margin: 0
        }
      }, "\xB7 ", String(r.variant.channel || "").replace(/_/g, " "))), /*#__PURE__*/React.createElement("select", {
        value: r.target,
        onChange: e => setRow(r.key, {
          target: e.target.value
        }),
        style: {
          fontSize: "11.5px",
          height: 26,
          borderRadius: 5,
          border: "1px solid var(--plk-border)",
          maxWidth: "46%"
        }
      }, r.targets.map(tg => /*#__PURE__*/React.createElement("option", {
        key: tg.key,
        value: tg.key
      }, tg.label))))), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          gap: 8,
          alignItems: "center",
          marginTop: 8
        }
      }, /*#__PURE__*/React.createElement("button", {
        className: "k-button k-button-sm k-rounded-md k-button-solid k-button-solid-primary",
        disabled: this.state.storyPublishBusy || !onCount,
        onClick: this.runStoryPublish
      }, this.state.storyPublishBusy ? "Publishing…" : `Publish ${onCount} now`), /*#__PURE__*/React.createElement("button", {
        className: "k-button k-button-sm k-rounded-md k-button-flat",
        onClick: () => this.setState({
          storyPublish: null,
          storyPublishPlan: undefined
        })
      }, "Cancel")));
    })());
  }
  patchContainerTags(ids, fn) {
    const set = new Set((ids || []).map(String));
    this.setState(s => s.data ? {
      data: {
        ...s.data,
        containers: s.data.containers.map(c => set.has(String(c.id)) ? {
          ...c,
          tags: fn(c.tags || [])
        } : c)
      }
    } : null);
  }
  /** Tag ids on the piece that still exist in the registry (a deleted tag's leftovers never show). */
  pieceTagIds(c, byId) {
    return (c.tags || []).map(String).filter(id => byId.has(id));
  }
  renderLibrary(containers) {
    if (!containers.length) {
      return /*#__PURE__*/React.createElement("div", {
        className: "lb-view"
      }, /*#__PURE__*/React.createElement("div", {
        className: "lb-empty"
      }, /*#__PURE__*/React.createElement("b", null, "Nothing in the library yet"), /*#__PURE__*/React.createElement("span", null, "Pieces you make in the Builder land here, and Plunk brings in your past emails, social posts and web pages each night.")));
    }
    const tags = this.state.tags || [];
    const byId = new Map(tags.map(t => [t.id, t]));
    const tagFilter = (this.state.tagFilter || []).filter(id => id === UNTAGGED || byId.has(id));
    const tagMode = this.state.tagMode === "all" ? "all" : "any";
    const groupBy = this.state.libGroupBy || "story";
    const view = this.state.libView === "list" ? "list" : "grid";
    const rawQ = (this.state.search || "").trim().toLowerCase();
    const hashQ = rawQ.startsWith("#") ? rawQ.slice(1) : null; // "#fall" searches tag names only
    const q = hashQ != null ? "" : rawQ;

    // Status pills (counts over everything the Library holds; All = live + drafts, archived pieces only under Archived).
    const statusCounts = {
      live: 0,
      draft: 0,
      archived: 0
    };
    containers.forEach(c => {
      statusCounts[libStatus(c)]++;
    });
    const status = ["live", "draft", "archived"].includes(this.state.libStatus) ? this.state.libStatus : "all";
    const visible = containers.filter(c => status === "all" ? libStatus(c) !== "archived" : libStatus(c) === status);

    // Channel select: plain names across what the pills show, most used first.
    const chTally = new Map();
    visible.forEach(c => chNames(c).forEach(n => chTally.set(n, (chTally.get(n) || 0) + 1)));
    const chOptions = [...chTally.keys()].sort((a, b) => chTally.get(b) - chTally.get(a) || a.localeCompare(b));
    const chFilter = this.state.libChannel && (chTally.has(this.state.libChannel) || this.state.libChannel === "__none__") ? this.state.libChannel : "";

    // Chip counts are over what the Library can show (before search and tag filters).
    const counts = new Map();
    let untaggedCount = 0;
    visible.forEach(c => {
      const ids = this.pieceTagIds(c, byId);
      if (!ids.length) untaggedCount++;
      ids.forEach(id => counts.set(id, (counts.get(id) || 0) + 1));
    });
    const filtered = visible.filter(c => {
      const ids = this.pieceTagIds(c, byId);
      if (q && !`${c.title || ""} ${c.storyTitle || ""} ${c.topic || ""} ${c.summary || ""} ${ids.map(id => byId.get(id).name).join(" ")}`.toLowerCase().includes(q)) return false;
      if (hashQ && !ids.some(id => tagMatches(byId.get(id).name, hashQ))) return false;
      if (chFilter === "__none__" ? chNames(c).length > 0 : chFilter && !chNames(c).includes(chFilter)) return false;
      if (tagFilter.length) {
        const has = id => id === UNTAGGED ? ids.length === 0 : ids.includes(id);
        if (tagMode === "all" ? !tagFilter.every(has) : !tagFilter.some(has)) return false;
      }
      // Hidden tags: their pieces stay out of the Library unless that tag is filtered.
      if (ids.some(id => byId.get(id).hidden && !tagFilter.includes(id))) return false;
      return true;
    });
    const {
      librarySelect,
      librarySel,
      libraryBusy
    } = this.state;
    const selCount = librarySel.size;
    const selPieces = selCount ? containers.filter(c => librarySel.has(String(c.id))) : [];

    // Tag chip row: selected first, then by count; "+ N more" past eight.
    const ordered = tags.slice().sort((a, b) => (counts.get(b.id) || 0) - (counts.get(a.id) || 0) || a.name.localeCompare(b.name));
    const selectedChips = tagFilter.filter(id => id !== UNTAGGED).map(id => byId.get(id));
    const rest = ordered.filter(t => !tagFilter.includes(t.id));
    const LIMIT = 8;
    const shownRest = this.state.tagsMore ? rest : rest.slice(0, LIMIT);
    const chip = (t, on) => {
      const n = counts.get(t.id) || 0;
      return /*#__PURE__*/React.createElement("button", {
        type: "button",
        key: t.id,
        className: "lb-tagf" + (on ? " on" : "") + (t.hidden ? " hid" : ""),
        onClick: () => this.toggleTagFilter(t.id),
        title: t.hidden ? "Hidden unless filtered" : on ? "Remove this filter" : `Show pieces tagged ${t.name}`
      }, tagDot(t.color), t.name, /*#__PURE__*/React.createElement("span", {
        className: "c"
      }, n), on && /*#__PURE__*/React.createElement("span", {
        className: "x",
        "aria-hidden": "true"
      }, "\xD7"));
    };
    const pill = (k, l, n) => /*#__PURE__*/React.createElement("button", {
      type: "button",
      key: k,
      className: "lb-pill" + (status === k ? " on" : ""),
      "aria-pressed": status === k,
      onClick: () => this.setState({
        libStatus: k
      })
    }, l, n != null && /*#__PURE__*/React.createElement("span", {
      className: "c"
    }, num(n)));
    const header = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "lb-bar"
    }, /*#__PURE__*/React.createElement("label", {
      className: "lb-search"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      "aria-hidden": "true"
    }, "search"), /*#__PURE__*/React.createElement("input", {
      type: "search",
      value: this.state.search,
      placeholder: "Search by title, text or #tag",
      "aria-label": "Search the library",
      onChange: e => this.setState({
        search: e.target.value
      })
    })), /*#__PURE__*/React.createElement("div", {
      className: "lb-pills",
      role: "group",
      "aria-label": "Status"
    }, pill("all", "All", null), pill("live", "Live", statusCounts.live), pill("draft", "Drafts", statusCounts.draft), statusCounts.archived > 0 && pill("archived", "Archived", statusCounts.archived)), /*#__PURE__*/React.createElement("span", {
      className: "lb-sp"
    }), /*#__PURE__*/React.createElement("label", {
      className: "lb-sel"
    }, "Channel", /*#__PURE__*/React.createElement("select", {
      value: chFilter,
      onChange: e => this.setState({
        libChannel: e.target.value
      })
    }, /*#__PURE__*/React.createElement("option", {
      value: ""
    }, "All channels"), chOptions.map(n => /*#__PURE__*/React.createElement("option", {
      key: n,
      value: n
    }, n)), /*#__PURE__*/React.createElement("option", {
      value: "__none__"
    }, "No channel yet"))), /*#__PURE__*/React.createElement("label", {
      className: "lb-sel"
    }, "Group by", /*#__PURE__*/React.createElement("select", {
      value: groupBy,
      onChange: e => this.setGroupBy(e.target.value)
    }, /*#__PURE__*/React.createElement("option", {
      value: "story"
    }, "Story"), /*#__PURE__*/React.createElement("option", {
      value: "tag"
    }, "Tag"), /*#__PURE__*/React.createElement("option", {
      value: "channel"
    }, "Channel"), /*#__PURE__*/React.createElement("option", {
      value: "none"
    }, "Nothing"))), /*#__PURE__*/React.createElement("div", {
      className: "lb-viewseg",
      role: "group",
      "aria-label": "View"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      "aria-label": "Grid",
      title: "Grid",
      "aria-pressed": view === "grid",
      className: view === "grid" ? "on" : "",
      onClick: () => this.setLibView("grid")
    }, /*#__PURE__*/React.createElement("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("rect", {
      x: "3",
      y: "3",
      width: "7",
      height: "7"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "14",
      y: "3",
      width: "7",
      height: "7"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "3",
      y: "14",
      width: "7",
      height: "7"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "14",
      y: "14",
      width: "7",
      height: "7"
    }))), /*#__PURE__*/React.createElement("button", {
      type: "button",
      "aria-label": "List",
      title: "List",
      "aria-pressed": view === "list",
      className: view === "list" ? "on" : "",
      onClick: () => this.setLibView("list")
    }, /*#__PURE__*/React.createElement("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M4 6h16M4 12h16M4 18h16"
    })))), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "lb-btn" + (librarySelect ? " on" : ""),
      title: "Pick pieces to tag, group into a story or archive",
      onClick: () => this.setState({
        librarySelect: !librarySelect,
        librarySel: new Set(),
        bulkTagsOpen: false
      })
    }, librarySelect ? "Cancel" : "Select"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "lb-btn",
      onClick: () => this.setState({
        manageTagsOpen: true
      })
    }, "Manage tags")), /*#__PURE__*/React.createElement("div", {
      className: "lb-tagsrow"
    }, (tags.length > 0 || tagFilter.length > 0) && /*#__PURE__*/React.createElement("div", {
      className: "lb-tags"
    }, /*#__PURE__*/React.createElement("span", {
      className: "h"
    }, "Tags"), selectedChips.map(t => chip(t, true)), tagFilter.includes(UNTAGGED) && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "lb-tagf on",
      onClick: () => this.toggleTagFilter(UNTAGGED),
      title: "Remove this filter"
    }, tagDot("#c9cdd3"), "No tag", /*#__PURE__*/React.createElement("span", {
      className: "c"
    }, untaggedCount), /*#__PURE__*/React.createElement("span", {
      className: "x",
      "aria-hidden": "true"
    }, "\xD7")), tagFilter.length >= 2 && /*#__PURE__*/React.createElement("span", {
      className: "lb-anyall",
      role: "group",
      "aria-label": "Match"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: tagMode === "any" ? "on" : "",
      title: "Pieces with any of these tags",
      onClick: () => this.setState({
        tagMode: "any"
      })
    }, "Any"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: tagMode === "all" ? "on" : "",
      title: "Pieces with all of these tags",
      onClick: () => this.setState({
        tagMode: "all"
      })
    }, "All")), tagFilter.length > 0 && /*#__PURE__*/React.createElement("span", {
      className: "sep"
    }), shownRest.map(t => chip(t, false)), !tagFilter.includes(UNTAGGED) && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "lb-tagf",
      onClick: () => this.toggleTagFilter(UNTAGGED),
      title: "Show pieces with no tags"
    }, tagDot("#c9cdd3"), "No tag", /*#__PURE__*/React.createElement("span", {
      className: "c"
    }, untaggedCount)), rest.length > LIMIT && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "lb-link",
      onClick: () => this.setState({
        tagsMore: !this.state.tagsMore
      })
    }, this.state.tagsMore ? "Fewer" : `+ ${rest.length - LIMIT} more`), tagFilter.length > 0 && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "lb-link",
      onClick: () => this.setState({
        tagFilter: []
      })
    }, "Clear")), /*#__PURE__*/React.createElement("div", {
      className: "lb-count"
    }, num(filtered.length), " piece", filtered.length === 1 ? "" : "s", filtered.length !== visible.length ? ` of ${num(visible.length)}` : "", this.state.dataComplete === false ? " so far, loading the rest…" : "", librarySelect && filtered.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, " \xB7 ", /*#__PURE__*/React.createElement("label", {
      className: "lb-selall"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: filtered.every(c => librarySel.has(String(c.id))),
      onChange: e => {
        const s = new Set(librarySel);
        filtered.forEach(c => e.target.checked ? s.add(String(c.id)) : s.delete(String(c.id)));
        this.setState({
          librarySel: s
        });
      }
    }), "Select all ", num(filtered.length)), !tagFilter.length && /*#__PURE__*/React.createElement("i", null, " \xB7 pick a tag above first to narrow this, for example No tag to tag the rest in one go")))));
    const selBar = librarySelect && /*#__PURE__*/React.createElement("div", {
      className: "hub-tag-selwrap"
    }, this.state.bulkTagsOpen && selCount > 0 && /*#__PURE__*/React.createElement(BulkTagPanel, {
      tags: tags,
      pieces: selPieces.map(c => ({
        ...c,
        tags: this.pieceTagIds(c, byId)
      })),
      onCreate: this.createTag,
      onApply: this.bulkTags,
      onClose: () => this.setState({
        bulkTagsOpen: false
      })
    }), /*#__PURE__*/React.createElement("div", {
      className: "hub-tag-selbar"
    }, /*#__PURE__*/React.createElement("b", null, selCount, " selected"), /*#__PURE__*/React.createElement("span", {
      className: "sep"
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "pri",
      disabled: !selCount || libraryBusy,
      onClick: () => this.setState({
        bulkTagsOpen: !this.state.bulkTagsOpen
      })
    }, "Tags"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      disabled: selCount < 2 || libraryBusy,
      title: "Merge the selected pieces into one story; the first one picked names it",
      onClick: this.groupSelected
    }, libraryBusy ? "Working…" : "Group into story"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      disabled: !selCount || libraryBusy,
      onClick: async () => {
        await this.setContainersStatus(selPieces, "archived");
        this.setState({
          librarySel: new Set(),
          bulkTagsOpen: false
        });
      }
    }, "Archive"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "clr",
      onClick: () => this.setState({
        librarySel: new Set(),
        bulkTagsOpen: false
      })
    }, "Clear")));
    const manage = this.state.manageTagsOpen && /*#__PURE__*/React.createElement(ManageTagsSheet, {
      tags: tags.map(t => ({
        ...t
      })),
      onClose: () => this.setState({
        manageTagsOpen: false
      }),
      onChanged: this.loadTags
    });
    const rootCls = "lb-view" + (librarySelect ? " hub-lib-selecting" : "");
    if (!filtered.length) {
      const why = status === "archived" ? "Nothing is archived." : status === "draft" ? "No drafts." : status === "live" ? "Nothing is live yet." : "Nothing matches.";
      return /*#__PURE__*/React.createElement("div", {
        className: rootCls
      }, header, /*#__PURE__*/React.createElement("div", {
        className: "lb-empty"
      }, /*#__PURE__*/React.createElement("b", null, rawQ || tagFilter.length || chFilter ? `Nothing matches${rawQ ? ` "${this.state.search.trim()}"` : ""}${tagFilter.length ? " with these tags" : ""}${chFilter ? ` on ${chFilter === "__none__" ? "no channel" : chFilter}` : ""}.` : why)), selBar, manage);
    }
    const pieces = list => view === "list" ? /*#__PURE__*/React.createElement("div", {
      className: "lb-list",
      role: "list"
    }, list.map(c => this.libraryRow(c, librarySelect))) : /*#__PURE__*/React.createElement("div", {
      className: "lb-grid"
    }, list.map(c => this.libraryCard(c, librarySelect)));
    const sumViews = list => list.reduce((a, c) => a + (Number(c.impressions) || 0), 0);
    const groupHead = (g, shownCount, open, extra) => {
      const views = sumViews(g.members);
      return /*#__PURE__*/React.createElement("header", {
        className: "lb-ghead"
      }, /*#__PURE__*/React.createElement("span", {
        className: "lb-gdot",
        style: {
          background: g.color || "#b9bec6"
        }
      }), /*#__PURE__*/React.createElement("b", {
        title: g.name
      }, g.name), /*#__PURE__*/React.createElement("span", {
        className: "m"
      }, plural(g.members.length, "piece"), views > 0 ? ` · ${num(views)} views` : "", g.note ? ` · ${g.note}` : ""), extra, /*#__PURE__*/React.createElement("span", {
        className: "lb-sp"
      }), (g.members.length > shownCount || open) && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "lb-link",
        onClick: () => {
          const n = new Set(this.state.libGroupOpen || []);
          if (open) n.delete(g.key);else n.add(g.key);
          this.setState({
            libGroupOpen: n
          });
        }
      }, open ? "Show fewer" : `Show all ${g.members.length}`));
    };
    const CAP = view === "list" ? 12 : 8;
    const openSet = this.state.libGroupOpen || new Set();
    let body;
    if (groupBy === "tag" || groupBy === "channel") {
      // A piece with several tags (or channels) shows once, under the first group; later headers say how many were shown above.
      const groups = [];
      if (groupBy === "tag") {
        const order = tagFilter.length ? tagFilter.filter(id => id !== UNTAGGED) : ordered.map(t => t.id);
        order.forEach(id => {
          const t = byId.get(id);
          const members = filtered.filter(c => this.pieceTagIds(c, byId).includes(id));
          if (members.length) groups.push({
            key: id,
            name: t.name,
            color: t.color,
            members
          });
        });
        const un = filtered.filter(c => !this.pieceTagIds(c, byId).length);
        if (un.length) groups.push({
          key: UNTAGGED,
          name: "No tag",
          color: null,
          members: un
        });
      } else {
        const tally = new Map();
        filtered.forEach(c => chNames(c).forEach(l => tally.set(l, (tally.get(l) || 0) + 1)));
        const labels = [...tally.keys()].sort((a, b) => tally.get(b) - tally.get(a) || a.localeCompare(b));
        labels.forEach(l => groups.push({
          key: "ch:" + l,
          name: l,
          color: "#1c1f24",
          members: filtered.filter(c => chNames(c).includes(l))
        }));
        const none = filtered.filter(c => !chNames(c).length);
        if (none.length) groups.push({
          key: "ch:none",
          name: "No channel yet",
          color: null,
          members: none
        });
      }
      const shownIn = new Map(); // piece id -> group name it first appeared under
      body = groups.map(g => {
        const fresh = g.members.filter(c => !shownIn.has(String(c.id)));
        const above = g.members.filter(c => shownIn.has(String(c.id)));
        const aboveFrom = [...new Set(above.map(c => shownIn.get(String(c.id))))];
        fresh.forEach(c => shownIn.set(String(c.id), g.name));
        const open = openSet.has(g.key);
        const list = open ? g.members : fresh.slice(0, CAP);
        const note = above.length ? `${above.length} also in ${aboveFrom.length === 1 ? aboveFrom[0] : "groups above"}${fresh.length ? "" : ", all shown above"}` : "";
        return /*#__PURE__*/React.createElement("section", {
          key: g.key,
          className: "lb-group"
        }, groupHead({
          ...g,
          note
        }, list.length, open), list.length > 0 && pieces(list));
      });
    } else if (groupBy === "none") {
      body = pieces(filtered);
    } else {
      // Story (default): pieces sharing story_id; the primary's title names the story. Pieces in no story get their own section.
      const groups = new Map();
      filtered.forEach(c => {
        const sid = c.storyId != null ? String(c.storyId) : null;
        if (!sid) return;
        if (!groups.has(sid)) groups.set(sid, {
          title: c.storyTitle || "Story",
          members: []
        });
        groups.get(sid).members.push(c);
      });
      const stories = [...groups.entries()].sort((a, b) => b[1].members.length - a[1].members.length);
      const ungrouped = filtered.filter(c => c.storyId == null);
      body = /*#__PURE__*/React.createElement(React.Fragment, null, stories.map(([sid, story]) => {
        const st = {
          storyId: sid,
          title: story.title,
          members: story.members
        };
        const key = "story:" + sid;
        const open = openSet.has(key);
        const list = open ? story.members : story.members.slice(0, CAP);
        const stage = this.storyStageLabel(st);
        const extra = /*#__PURE__*/React.createElement("span", {
          className: "lb-gacts"
        }, stage && /*#__PURE__*/React.createElement("span", {
          className: "lb-gstage",
          title: "Where this story is in the Builder"
        }, stage === "Shipped" ? "Published" : `In the Builder: ${stage}`), /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "lb-link",
          onClick: () => this.props.history.push(`/Content/build/${String(sid)}`)
        }, "Open in the Builder"), /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "lb-link quiet",
          disabled: libraryBusy,
          title: "Split these pieces back out of the story",
          onClick: () => this.ungroupStory(story.members)
        }, "Ungroup"), /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "lb-link quiet",
          disabled: libraryBusy,
          title: "Archive this story and its pieces (restore them under Archived)",
          onClick: () => this.setContainersStatus(story.members, "archived")
        }, "Archive"));
        return /*#__PURE__*/React.createElement("section", {
          key: sid,
          className: "lb-group"
        }, groupHead({
          key,
          name: story.title,
          color: "#ff6358",
          members: story.members
        }, list.length, open, extra), this.renderStoryPanels(st, true), pieces(list));
      }), ungrouped.length > 0 && (() => {
        const key = "story:none";
        const open = openSet.has(key) || !stories.length;
        const list = open ? ungrouped : ungrouped.slice(0, CAP);
        return /*#__PURE__*/React.createElement("section", {
          className: "lb-group"
        }, stories.length > 0 && groupHead({
          key,
          name: "Not in a story",
          color: null,
          members: ungrouped
        }, list.length, openSet.has(key)), pieces(list));
      })());
    }
    return /*#__PURE__*/React.createElement("div", {
      className: rootCls
    }, header, body, selBar, manage);
  }

  /** Tags on a card or row, with the "+ Tag" picker (saved as picked). */
  pieceTagRow(c, selectable, cls) {
    const tags = this.state.tags || [];
    const byId = new Map(tags.map(t => [t.id, t]));
    const ids = this.pieceTagIds(c, byId);
    const picking = this.state.tagPickerFor === String(c.id);
    return /*#__PURE__*/React.createElement("div", {
      className: cls || "lb-ctags"
    }, ids.map(id => /*#__PURE__*/React.createElement(TagChip, {
      key: id,
      tag: byId.get(id),
      small: true
    })), !selectable && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "lb-tagadd" + (picking ? " on" : ""),
      onClick: e => {
        e.stopPropagation();
        this.setState({
          tagPickerFor: picking ? null : String(c.id)
        });
      }
    }, "+ Tag"), picking && /*#__PURE__*/React.createElement(TagPicker, {
      tags: tags,
      value: ids,
      onAdd: id => this.setPieceTags(c, [...ids, id]),
      onRemove: id => this.setPieceTags(c, ids.filter(x => x !== id)),
      onCreate: this.createTag,
      onClose: () => this.setState({
        tagPickerFor: null
      })
    }));
  }
  /** "Social post · Oct 1", "Email · Draft". */
  pieceKindLine(c) {
    const st = libStatus(c);
    const d = fmtDay(c.modifiedDate || c.createdDate);
    return `${pieceKind(c)} · ${st === "draft" ? "Draft" : st === "archived" ? `Archived${d ? ` ${d}` : ""}` : d}`;
  }
  resultsLine(c) {
    const parts = resultsParts(c);
    if (parts) return parts.map(([v, l], i) => /*#__PURE__*/React.createElement(React.Fragment, {
      key: l
    }, i > 0 && " · ", /*#__PURE__*/React.createElement("b", null, v), " ", l));
    const st = libStatus(c);
    return /*#__PURE__*/React.createElement("span", {
      className: "q"
    }, st === "live" ? "No results yet" : pieceKind(c) === "Email" ? "Not sent yet" : "Not published yet");
  }
  libraryCard(c, selectable) {
    const sel = this.state.librarySel.has(String(c.id));
    const picking = this.state.tagPickerFor === String(c.id);
    const st = libStatus(c);
    const names = chNames(c);
    const tint = String(c.id).split("").reduce((a, ch) => a + ch.charCodeAt(0), 0) % 4;
    const open = () => selectable ? this.toggleLibrarySel(c.id) : this.openDetail(c);
    return /*#__PURE__*/React.createElement("div", {
      key: String(c.id),
      role: "button",
      tabIndex: 0,
      className: "lb-card" + (sel ? " picked" : "") + (selectable ? " selectable" : "") + (picking ? " picking" : ""),
      onClick: open,
      onKeyDown: e => {
        if ((e.key === "Enter" || e.key === " ") && e.target === e.currentTarget) {
          e.preventDefault();
          open();
        }
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "lb-cover"
    }, /*#__PURE__*/React.createElement(LbCover, {
      url: c.coverUrl,
      kind: c.coverKind,
      title: c.title || "Untitled",
      tint: tint
    }), selectable && /*#__PURE__*/React.createElement("span", {
      className: "lb-check" + (sel ? " on" : ""),
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "check")), st !== "live" && /*#__PURE__*/React.createElement("span", {
      className: "lb-state"
    }, LB_STATUS_LABEL[st], st === "archived" && !selectable && /*#__PURE__*/React.createElement("button", {
      type: "button",
      title: "Bring this piece back",
      disabled: this.state.libraryBusy,
      onClick: e => {
        e.stopPropagation();
        this.setContainersStatus(c, "active");
      }
    }, "Restore")), names.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "lb-chs"
    }, names.slice(0, 3).map(n => /*#__PURE__*/React.createElement("span", {
      key: n
    }, n)), names.length > 3 && /*#__PURE__*/React.createElement("span", null, "+", names.length - 3))), /*#__PURE__*/React.createElement("div", {
      className: "lb-cbody"
    }, /*#__PURE__*/React.createElement("b", {
      className: "lb-ctitle",
      title: c.title || "Untitled"
    }, c.title || "Untitled"), /*#__PURE__*/React.createElement("span", {
      className: "lb-ckind"
    }, this.pieceKindLine(c)), this.pieceTagRow(c, selectable), /*#__PURE__*/React.createElement("span", {
      className: "lb-cres"
    }, this.resultsLine(c))));
  }

  /** List view row: thumb, title (+ tags), kind, channels, results, date. */
  libraryRow(c, selectable) {
    const sel = this.state.librarySel.has(String(c.id));
    const picking = this.state.tagPickerFor === String(c.id);
    const st = libStatus(c);
    const tint = String(c.id).split("").reduce((a, ch) => a + ch.charCodeAt(0), 0) % 4;
    const open = () => selectable ? this.toggleLibrarySel(c.id) : this.openDetail(c);
    return /*#__PURE__*/React.createElement("div", {
      key: String(c.id),
      role: "listitem",
      tabIndex: 0,
      className: "lb-row" + (sel ? " picked" : "") + (selectable ? " selectable" : "") + (picking ? " picking" : ""),
      onClick: open,
      onKeyDown: e => {
        if ((e.key === "Enter" || e.key === " ") && e.target === e.currentTarget) {
          e.preventDefault();
          open();
        }
      }
    }, selectable && /*#__PURE__*/React.createElement("span", {
      className: "lb-check inline" + (sel ? " on" : ""),
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "check")), /*#__PURE__*/React.createElement("span", {
      className: "lb-rthumb"
    }, /*#__PURE__*/React.createElement(LbCover, {
      url: c.coverUrl,
      kind: c.coverKind,
      title: (c.title || "Untitled").slice(0, 2),
      tint: tint
    })), /*#__PURE__*/React.createElement("span", {
      className: "lb-rmain"
    }, /*#__PURE__*/React.createElement("b", {
      title: c.title || "Untitled"
    }, c.title || "Untitled"), this.pieceTagRow(c, selectable, "lb-ctags row")), /*#__PURE__*/React.createElement("span", {
      className: "lb-rkind"
    }, pieceKind(c), st !== "live" && /*#__PURE__*/React.createElement("i", {
      className: "lb-rstate " + st
    }, LB_STATUS_LABEL[st])), /*#__PURE__*/React.createElement("span", {
      className: "lb-rch"
    }, chNames(c).join(", ") || /*#__PURE__*/React.createElement("span", {
      className: "q"
    }, "No channel yet")), /*#__PURE__*/React.createElement("span", {
      className: "lb-rres"
    }, this.resultsLine(c)), /*#__PURE__*/React.createElement("span", {
      className: "lb-rdate"
    }, fmtDay(c.modifiedDate || c.createdDate), st === "archived" && !selectable && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "lb-link",
      disabled: this.state.libraryBusy,
      onClick: e => {
        e.stopPropagation();
        this.setContainersStatus(c, "active");
      }
    }, "Restore")));
  }
  /** Pictures for a channel version, best first: its own media, the piece's hero (heroImage), other linked media, the post's current picture, image blocks. Expired network links are dropped. */
  pdMediaFor(d, v) {
    const out = [];
    const seen = new Set();
    let expired = false;
    const add = (url, kind, poster, alt) => {
      if (!url || seen.has(url)) return;
      seen.add(url);
      if (cdnExpired(url)) {
        expired = true;
        return;
      }
      out.push({
        url,
        kind,
        poster: poster || undefined,
        alt
      });
    };
    const assets = d && d.assets || [];
    if (v && String(v.channel || "").toLowerCase() === "video") {
      const vu = this.videoUrlFor(v, d);
      if (vu) add(vu, "video", this.posterFor(vu, d));
    }
    if (v) assets.filter(a => a.variantId && String(a.variantId) === String(v.id)).forEach(a => a.kind === "video" ? add(a.url, "video", a.posterUrl) : a.kind === "image" ? add(a.url, "image", null, a.altText) : null);
    add(this.heroImage(d, v), "image");
    assets.filter(a => a.kind === "image").forEach(a => add(a.url, "image", null, a.altText));
    const social = d && d.socialMedia || [];
    social.filter(s => v && s.variantId === String(v.id)).concat(social).forEach(s => add(s.url, s.kind));
    assets.filter(a => a.kind === "video").forEach(a => add(a.url, "video", a.posterUrl));
    this.mediaChoices(d).forEach(m => add(m.url, m.kind, m.poster));
    (d && d.blocks || []).forEach(b => {
      const u = String(b && (b.assetRef || b.body) || "").trim();
      if (!/(image|asset)_ref/i.test(b && b.kind || "") || !/^https?:\/\//i.test(u) || seen.has(u)) return;
      if (/\.(mp4|mov|webm|m4v)(\?|#|$)/i.test(u)) add(u, "video", this.posterFor(u, d));else {
        add(u, "image");
        const last = out[out.length - 1];
        if (last && last.url === u && !/\.(jpe?g|png|gif|webp|avif)(\?|#|$)/i.test(u)) last.maybeVideo = true;
      }
    });
    adImagesFrom(d).forEach(u => add(u, "image"));
    return {
      items: out,
      expired
    };
  }
  /** A text block's body: ad creatives as cards, JSON as a quiet code view, the rest as text. */
  pdBlockBody(b) {
    const val = x => x.body || x.assetRef || "";
    const tryJson = s => {
      const t = (s || "").trim();
      if (!(t.startsWith("{") || t.startsWith("["))) return null;
      try {
        const x = JSON.parse(t);
        return x && typeof x === "object" ? x : null;
      } catch {
        return null;
      }
    };
    const asAds = j => {
      const arr = Array.isArray(j) ? j : [j];
      return arr.length && arr.every(a => a && typeof a === "object" && ("Headline" in a || "Description" in a || "ImageUrls" in a)) ? arr : null;
    };
    if (/transcript_pending/i.test(b.kind || "")) return /*#__PURE__*/React.createElement("p", {
      className: "pd-quiet"
    }, "The transcript is on its way: Plunk is listening to the video.");
    const raw = val(b);
    const j = tryJson(raw);
    const ads = j && asAds(j);
    if (ads) return /*#__PURE__*/React.createElement("div", {
      className: "pd-ads"
    }, ads.map((ad, i) => /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "hub-det-ad"
    }, (ad.ImageUrls || []).length > 0 ? /*#__PURE__*/React.createElement("a", {
      className: "img",
      href: ad.ImageUrls[0],
      target: "_blank",
      rel: "noreferrer"
    }, /*#__PURE__*/React.createElement("img", {
      src: ad.ImageUrls[0],
      alt: "Ad picture",
      loading: "lazy"
    }), ad.ImageUrls.length > 1 && /*#__PURE__*/React.createElement("span", {
      className: "hub-asset-tag"
    }, "+", ad.ImageUrls.length - 1), /*#__PURE__*/React.createElement("span", {
      className: "hub-det-rail sm",
      onClick: e => {
        e.preventDefault();
        e.stopPropagation();
      }
    }, /*#__PURE__*/React.createElement("button", {
      title: "Edit in the image editor",
      onClick: () => this.openInEditor({
        url: ad.ImageUrls[0],
        kind: "image"
      }, this.state.detail && this.state.detail.container && this.state.detail.container.id)
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "tune")))) : /*#__PURE__*/React.createElement("span", {
      className: "img none"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "campaign")), /*#__PURE__*/React.createElement("div", {
      className: "txt"
    }, ad.Headline ? /*#__PURE__*/React.createElement("b", null, ad.Headline) : /*#__PURE__*/React.createElement("b", {
      className: "quiet"
    }, "Ad ", i + 1), ad.Headline2 && /*#__PURE__*/React.createElement("span", null, ad.Headline2), ad.Description && /*#__PURE__*/React.createElement("p", null, ad.Description), ad.FinalUrl && /*#__PURE__*/React.createElement("a", {
      href: ad.FinalUrl,
      target: "_blank",
      rel: "noreferrer"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "open_in_new"), (() => {
      try {
        return new URL(ad.FinalUrl).hostname;
      } catch (e) {
        return "where it links";
      }
    })())))));
    if (j) {
      const parts = JSON.stringify(j, null, 2).split(/(https?:\/\/[^\s"]+)/g);
      return /*#__PURE__*/React.createElement("pre", {
        className: "pd-pre"
      }, parts.map((p, i) => /^https?:\/\//.test(p) ? /*#__PURE__*/React.createElement("a", {
        key: i,
        href: p,
        target: "_blank",
        rel: "noreferrer"
      }, p) : p));
    }
    return /*#__PURE__*/React.createElement("p", {
      className: "pd-text"
    }, raw || "Empty");
  }
  renderDetail() {
    const {
      detail
    } = this.state;
    const c = detail.container;
    const f = detail.funnel;
    const variants = detail.variants || [];
    const pubs = detail.publications || [];
    const archived = String(c.status || "").toLowerCase() === "archived";
    const busyPiece = this.state.libraryBusy;
    const row = (this.state.data && this.state.data.containers || []).find(x => String(x.id) === String(c.id)) || {
      ...c,
      tags: []
    };

    // Status line
    const livePubs = pubs.filter(isLive);
    const liveChannels = [...new Set(livePubs.map(p => chName(p.target) || chName((variants.find(v => String(v.id) === String(p.variantId)) || {}).channel)))].filter(Boolean);
    const kind = pieceKind(c, variants.map(v => v.channel));
    const when = isImported(c) ? `Imported ${fmtDay(c.createdDate)}` : c.modifiedDate ? `Updated ${fmtDay(c.modifiedDate)}` : "";

    // Channel versions: archived ones last.
    const ordered = variants.slice().sort((a, b) => (String(a.status).toLowerCase() === "archived") - (String(b.status).toLowerCase() === "archived"));
    const pick = ordered.find(v => String(v.id) === this.state.pdVariant) || ordered.find(v => ["published", "live"].includes(String(v.status || "").toLowerCase())) || ordered[0] || null;
    const nameCount = {};
    const vLabel = new Map(ordered.map(v => {
      const n = chName(v.channel) || "Version";
      nameCount[n] = (nameCount[n] || 0) + 1;
      return [String(v.id), nameCount[n] > 1 ? `${n} ${nameCount[n]}` : n];
    }));
    const vStatus = pick ? String(pick.status || "").toLowerCase() : "";
    const pickName = pick ? vLabel.get(String(pick.id)) : "";
    const pickPubs = pick ? pubs.filter(p => String(p.variantId) === String(pick.id)) : [];
    const pickLive = pickPubs.find(p => isLive(p) && p.url) || pickPubs.find(isLive) || null;
    const busy = pick && !!this.state.variantBusy[`${pick.id}|publish`];
    const menuOpen = pick && this.state.publishMenu === String(pick.id);
    const editing = pick && this.state.editVariant === String(pick.id);
    const fv = pick && f && (f.variants || []).find(x => String(x.variantId) === String(pick.id));

    // Media
    const media = this.pdMediaFor(detail, pick);
    const blocks = detail.blocks || [];
    const META = /^(comment|social_media|locale_meta|variant_history|seo|design_filled)$|^(storyboard|video_ref|previous_|seo_brief|builder_state)/i;
    const val = b => b.body || b.assetRef || "";
    const kindOf = b => {
      if (META.test(b.kind || "")) return "meta";
      if (/transcript/i.test(b.kind || "")) return "text";
      const v = val(b).trim();
      const isUrl = /^https?:\/\//i.test(v);
      if (isUrl && (/(image|asset)_ref/i.test(b.kind || "") || /\.(jpe?g|png|gif|webp|avif)(\?|$)/i.test(v)) && !/\.(mp4|mov|webm|m4v)(\?|$)/i.test(v)) return "image";
      if (isUrl && /\.(mp4|mov|webm|m4v)(\?|$)/i.test(v)) return "video";
      if (isUrl) return "link";
      return "text";
    };
    const g = {
      text: [],
      image: [],
      video: [],
      link: [],
      meta: []
    };
    blocks.forEach(b => g[kindOf(b)].push(b));
    const variantBodies = new Set(variants.map(v => String(v.body || "").trim()).filter(Boolean));
    const notes = g.text.filter(b => !variantBodies.has(String(val(b)).trim()));
    const storyboards = g.meta.filter(b => String(b.kind || "") === "storyboard");
    const sbScenes = b => {
      try {
        const j = JSON.parse(b.body || "{}");
        return (j.scenes || j || []).length;
      } catch (e) {
        return 0;
      }
    };
    const hasTranscript = g.text.some(b => /transcript/i.test(b.kind || ""));
    const canShopify = !!this.state.shopify && (detail.links || []).some(l => String(l.linkType || l.link_type || "").toLowerCase() === "product");
    const fileLabel = u => {
      try {
        const x = new URL(u);
        return decodeURIComponent(x.pathname.split("/").pop() || x.hostname) || x.hostname;
      } catch {
        return "Open link";
      }
    };
    const blockName = k => ({
      copy: "Text",
      caption: "Caption",
      subject_line: "Subject line",
      meta_description: "Page description",
      cta: "Button text",
      transcript: "Video transcript",
      transcript_pending: "Video transcript"
    })[String(k || "").toLowerCase()] || String(k || "Text").replace(/_/g, " ").replace(/^\w/, x => x.toUpperCase());

    // Images and video: linked media (open in the editors), image blocks never registered (edit in place), clips on the piece.
    const tiles = [];
    const seenT = new Set();
    this.mediaChoices(detail).forEach(m => {
      if (!seenT.has(m.url)) {
        seenT.add(m.url);
        tiles.push({
          ...m,
          src: "asset"
        });
      }
    });
    g.image.forEach(b => {
      const u = val(b);
      if (u && !seenT.has(u)) {
        seenT.add(u);
        tiles.push({
          url: u,
          id: null,
          kind: "image",
          src: "block"
        });
      }
    });
    g.video.forEach(b => {
      const u = val(b);
      if (u && !seenT.has(u)) {
        seenT.add(u);
        tiles.push({
          url: u,
          id: null,
          kind: "video",
          poster: this.posterFor(u),
          src: "block"
        });
      }
    });
    adImagesFrom(detail).forEach(u => {
      if (!seenT.has(u)) {
        seenT.add(u);
        tiles.push({
          url: u,
          id: null,
          kind: "image",
          src: "ad"
        });
      }
    });
    (detail.socialMedia || []).forEach(s => {
      if (!seenT.has(s.url)) {
        seenT.add(s.url);
        tiles.push({
          url: s.url,
          id: null,
          kind: s.kind,
          src: "social",
          permalink: s.permalink
        });
      }
    });
    const openTile = m => {
      if (m.src === "social") {
        window.open(m.permalink || m.url, "_blank", "noopener");
        return;
      }
      this.openInEditor(m, c.id);
    };
    const shownMedia = media.items[0];

    // Results
    const n = x => Number(x) || 0;
    const sameRange = !detail.funnelRange || detail.funnelRange === this.range();

    // Social page name for the preview
    const plat = pick ? chName(pick.channel) : "";
    const acct = (this.state.social || []).find(a => chName(a.platform) === plat && String(a.status || "").toLowerCase() === "connected") || (this.state.social || []).find(a => chName(a.platform) === plat);
    const pageName = acct && (acct.displayName || acct.handle) || "Your page";
    const pickKind = pick ? pieceKind({}, [pick.channel]) : kind;
    const socialStyle = pickKind === "Social post" || pickKind === "Ad";
    const bodyOpen = !!(this.state.blockOpen && pick && this.state.blockOpen.has("v" + String(pick.id)));
    const longBody = pick && String(pick.body || "").length > 600;
    const toggleBody = () => {
      const s = new Set(this.state.blockOpen || []);
      const k = "v" + String(pick.id);
      if (s.has(k)) s.delete(k);else s.add(k);
      this.setState({
        blockOpen: s
      });
    };
    const stageOn = k => (detail.links || []).some(x => String(x.linkType || x.link_type || "").toLowerCase() === "stage" && String(x.refId || x.ref_id || "").toLowerCase() === k);
    const vis = detail.visibility;
    const builder = () => this.props.history.push(`/Content/build/${String(c.storyId || c.id)}`);
    const varMap = {};
    variants.forEach(v => {
      varMap[String(v.id)] = v;
    });
    const imported = /import|crawl|campaign/i.test(String(c.origin || ""));
    // the page this piece was read from (newest source_url block) — the Refresh action needs one
    const sourcePage = (() => {
      const b = (detail.blocks || []).filter(x => String(x.kind || "") === "source_url" && x.body);
      if (b.length) return String(b[b.length - 1].body);
      const w = (detail.publications || []).find(x => String(x.target || "").toLowerCase() === "website" && /^https?:/i.test(String(x.url || "")));
      return w ? String(w.url) : null;
    })();
    const shipItems = pubs.map(pub => ({
      pub,
      v: varMap[String(pub.variantId)] || {
        id: pub.variantId,
        channel: pub.target,
        containerId: c.id
      },
      d: detail
    }));
    const menuItem = (label, onClick, opts = {}) => /*#__PURE__*/React.createElement("button", {
      type: "button",
      role: "menuitem",
      className: opts.danger ? "danger" : "",
      disabled: opts.disabled,
      title: opts.title,
      onClick: () => {
        this.setState({
          pdMenu: false
        });
        onClick();
      }
    }, label);
    const fallbackPic = /*#__PURE__*/React.createElement("div", {
      className: "pd-nopic"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      "aria-hidden": "true"
    }, "image"), /*#__PURE__*/React.createElement("span", null, media.expired ? `The picture link from ${plat && plat !== "Video" ? plat : "the network"} has expired. Add the picture from Assets to keep it here.` : "No picture yet"));
    return /*#__PURE__*/React.createElement("div", {
      className: "pd-view"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pd-top"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "pd-back",
      onClick: () => {
        try {
          const u = new URL(window.location.href);
          u.searchParams.delete("piece");
          window.history.replaceState(window.history.state, "", u.pathname + u.search + u.hash);
        } catch (e) {/* old browser */}
        this.setState({
          detail: null
        });
      },
      "aria-label": "Back to the library",
      title: "Back to the library"
    }, /*#__PURE__*/React.createElement("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M15 18l-6-6 6-6"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "pd-title"
    }, /*#__PURE__*/React.createElement("h1", {
      title: c.title || "Untitled"
    }, c.title || "Untitled"), /*#__PURE__*/React.createElement("span", {
      className: "pd-status"
    }, archived ? /*#__PURE__*/React.createElement("span", {
      className: "st off"
    }, "Archived") : liveChannels.length ? /*#__PURE__*/React.createElement("span", {
      className: "st live"
    }, /*#__PURE__*/React.createElement("i", null), "Live on ", liveChannels.length === 1 ? liveChannels[0] : `${liveChannels.length} channels`) : /*#__PURE__*/React.createElement("span", {
      className: "st draft"
    }, "Draft"), /*#__PURE__*/React.createElement("span", null, "\xB7 ", kind, when ? ` · ${when}` : ""))), /*#__PURE__*/React.createElement("span", {
      className: "pd-sp"
    }), /*#__PURE__*/React.createElement("span", {
      className: "pd-menuwrap"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "pd-more",
      "aria-label": "More actions",
      "aria-haspopup": "menu",
      "aria-expanded": !!this.state.pdMenu,
      onClick: () => this.setState({
        pdMenu: !this.state.pdMenu,
        publishMenu: null
      })
    }, "\xB7\xB7\xB7"), this.state.pdMenu && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "pd-scrim",
      onClick: () => this.setState({
        pdMenu: false
      })
    }), /*#__PURE__*/React.createElement("div", {
      className: "pd-menu",
      role: "menu"
    }, menuItem("Open in the Builder", builder), pick && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "h"
    }, pickName, " version"), vStatus === "draft" && menuItem("Approve it", () => this.setVariantStatus(pick, "approved"), {
      title: "Approved versions can be published"
    }), vStatus === "approved" && menuItem("Back to draft", () => this.setVariantStatus(pick, "draft")), vStatus === "archived" && menuItem("Restore as a draft", () => this.setVariantStatus(pick, "draft")), (vStatus === "approved" || vStatus === "published") && pick.channel !== "video" && menuItem("Save as template", () => this.setState({
      tplSheet: {
        variantId: String(pick.id),
        channel: String(pick.channel || "").toLowerCase()
      }
    }), {
      title: "Reuse the shape of this piece for new ones"
    }), vStatus !== "published" && vStatus !== "archived" && menuItem("Remove this version", () => this.setVariantStatus(pick, "archived"), {
      danger: true
    })), /*#__PURE__*/React.createElement("span", {
      className: "h"
    }, "Piece"), !archived && sourcePage && menuItem("Refresh from the website", this.refreshFromWebsite, {
      disabled: busyPiece,
      title: `Read ${sourcePage} again: new text and pictures come in, what you wrote stays`
    }), archived ? menuItem("Restore to the Library", () => this.setContainersStatus(c, "active"), {
      disabled: busyPiece
    }) : menuItem("Archive", () => this.setContainersStatus(c, "archived"), {
      disabled: busyPiece,
      title: "It leaves the Library and results. Anything published stays live."
    })))), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "pd-btn",
      title: "Write it for Facebook, email, your website and more in the Builder",
      onClick: builder
    }, "Make a version for another channel"), /*#__PURE__*/React.createElement("span", {
      className: "pd-menuwrap"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "pd-primary",
      disabled: !pick || busy || vStatus === "archived",
      title: !pick ? "Make a channel version first" : vStatus === "archived" ? "Restore this version first" : vStatus === "draft" ? "Approves this version, then asks where it goes" : undefined,
      onClick: () => this.pdPublish(pick)
    }, busy ? "Publishing…" : vStatus === "published" ? "Publish again" : "Publish"), menuOpen && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "pd-scrim",
      onClick: () => this.setState({
        publishMenu: null
      })
    }), /*#__PURE__*/React.createElement("div", {
      className: "pd-menu pub",
      role: "menu"
    }, /*#__PURE__*/React.createElement("span", {
      className: "h"
    }, "Publish the ", pickName, " version to"), this.publishTargets(pick).map(tg => /*#__PURE__*/React.createElement("button", {
      type: "button",
      role: "menuitem",
      key: tg.key,
      disabled: tg.disabled,
      onClick: () => !tg.disabled && this.publishTo(pick, tg.key)
    }, tg.label)))))), /*#__PURE__*/React.createElement("div", {
      className: "pd-body"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pd-main"
    }, this.state.shopifyConfirm && (() => {
      const sc = this.state.shopifyConfirm;
      const link = (detail.links || []).find(l => String(l.linkType || l.link_type || "").toLowerCase() === "product");
      return /*#__PURE__*/React.createElement("div", {
        className: "pd-confirm"
      }, /*#__PURE__*/React.createElement("b", null, "Replace the product description in Shopify?"), /*#__PURE__*/React.createElement("p", null, "Product ", /*#__PURE__*/React.createElement("code", null, link ? link.refId || link.ref_id : "not linked"), " gets this text as its description on your live store. The current description is kept, so you can put it back from Where it's live."), /*#__PURE__*/React.createElement("div", {
        className: "a"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "pd-primary sm",
        onClick: () => {
          this.setState({
            shopifyConfirm: {
              ...sc,
              confirmed: true
            }
          }, () => this.publishTo(sc.variant, sc.target));
        }
      }, "Replace description"), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "pd-btn sm",
        onClick: () => this.setState({
          shopifyConfirm: null
        })
      }, "Cancel")));
    })(), this.state.videoJob && /*#__PURE__*/React.createElement("p", {
      className: "pd-note"
    }, "Your video is rendering. It takes a few minutes and shows up here as a video version when it is done."), ordered.length > 0 ? /*#__PURE__*/React.createElement("div", {
      className: "pd-switchrow"
    }, /*#__PURE__*/React.createElement("span", {
      className: "l"
    }, "How it looks on"), /*#__PURE__*/React.createElement("div", {
      className: "pd-seg",
      role: "group",
      "aria-label": "Channel"
    }, ordered.map(v => /*#__PURE__*/React.createElement("button", {
      type: "button",
      key: String(v.id),
      className: pick && String(v.id) === String(pick.id) ? "on" : "",
      "aria-pressed": pick && String(v.id) === String(pick.id),
      onClick: () => this.setState({
        pdVariant: String(v.id),
        editVariant: null,
        publishMenu: null
      })
    }, vLabel.get(String(v.id)), String(v.status || "").toLowerCase() === "archived" && /*#__PURE__*/React.createElement("i", null, " (removed)")))), /*#__PURE__*/React.createElement("span", {
      className: "pd-sp"
    }), pickLive ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "pd-pubd"
    }, "Published ", fmtDay(pickLive.publishedDate || pickLive.createdDate)), pickLive.url && /*#__PURE__*/React.createElement("a", {
      href: pickLive.url,
      target: "_blank",
      rel: "noreferrer"
    }, "Open on ", chName(pickLive.target) || pickName, " \u2197")) : /*#__PURE__*/React.createElement("span", {
      className: "pd-pubd q"
    }, vStatus === "approved" ? "Approved, ready to publish" : vStatus === "archived" ? "Removed version" : vStatus === "draft" ? "Draft, not published yet" : "")) : null, /*#__PURE__*/React.createElement("div", {
      className: "pd-stage"
    }, pick ? /*#__PURE__*/React.createElement("div", {
      className: "pd-preview" + (socialStyle ? " social" : " doc")
    }, socialStyle ? /*#__PURE__*/React.createElement("div", {
      className: "pd-pvhead"
    }, /*#__PURE__*/React.createElement("span", {
      className: "av",
      "aria-hidden": "true"
    }, (pageName === "Your page" ? c.title || "P" : pageName).trim().charAt(0).toUpperCase()), /*#__PURE__*/React.createElement("span", {
      className: "who"
    }, /*#__PURE__*/React.createElement("b", null, pageName), /*#__PURE__*/React.createElement("span", null, pickLive ? fmtDay(pickLive.publishedDate || pickLive.createdDate) : "Not posted yet"))) : pickKind === "Email" ? /*#__PURE__*/React.createElement("div", {
      className: "pd-pvmail"
    }, /*#__PURE__*/React.createElement("span", null, "Subject"), /*#__PURE__*/React.createElement("b", null, pick.title || c.title || "No subject yet")) : null, socialStyle && /*#__PURE__*/React.createElement("p", {
      className: "pd-pvtext" + (longBody && !bodyOpen ? " clamp" : "")
    }, pick.body || pick.title || ""), /*#__PURE__*/React.createElement("div", {
      className: "pd-pvmedia"
    }, /*#__PURE__*/React.createElement(PdMedia, {
      items: media.items,
      imgClass: "pd-pvimg",
      videoClass: "pd-pvvideo",
      fallback: fallbackPic
    })), !socialStyle && /*#__PURE__*/React.createElement("div", {
      className: "pd-pvdoc"
    }, pickKind !== "Email" && pick.title && /*#__PURE__*/React.createElement("h3", null, pick.title), /*#__PURE__*/React.createElement("p", {
      className: "pd-pvtext" + (longBody && !bodyOpen ? " clamp" : "")
    }, pick.body || "")), longBody && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "pd-more-link",
      onClick: toggleBody
    }, bodyOpen ? "Show less" : "Show all"), /*#__PURE__*/React.createElement("div", {
      className: "pd-pvfoot"
    }, fv && (n(fv.impressions) > 0 || n(fv.clicks) > 0 || n(fv.sessions) > 0) ? /*#__PURE__*/React.createElement(React.Fragment, null, n(fv.impressions) > 0 && /*#__PURE__*/React.createElement("span", null, num(fv.impressions), " views"), /*#__PURE__*/React.createElement("span", null, num(fv.clicks), " clicks"), n(fv.sessions) > 0 && /*#__PURE__*/React.createElement("span", null, num(fv.sessions), " site visits"), n(fv.salesValue) > 0 && /*#__PURE__*/React.createElement("span", null, usd(fv.salesValue), " sales")) : /*#__PURE__*/React.createElement("span", null, pickLive ? "No results yet" : "Results show here once it is published"))) : /*#__PURE__*/React.createElement("div", {
      className: "pd-preview empty"
    }, /*#__PURE__*/React.createElement("b", null, "No channel versions yet"), /*#__PURE__*/React.createElement("span", null, "Write this piece for Facebook, email, your website and more. Each version keeps its own text and shares the pictures below."), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "pd-primary",
      onClick: builder
    }, "Make a version for another channel")), /*#__PURE__*/React.createElement("div", {
      className: "pd-side"
    }, pick && /*#__PURE__*/React.createElement("section", {
      className: "pd-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pd-cardh"
    }, /*#__PURE__*/React.createElement("b", null, pickName, " text"), !editing && vStatus !== "published" && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "pd-btn sm",
      onClick: () => this.startEdit(pick)
    }, "Edit"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "pd-ghost sm",
      onClick: () => this.copyVariant(pick)
    }, "Copy")), editing ? /*#__PURE__*/React.createElement("div", {
      className: "pd-edit"
    }, /*#__PURE__*/React.createElement("input", {
      value: this.state.editTitle,
      placeholder: pickKind === "Email" ? "Subject line" : "Title",
      "aria-label": "Title",
      onChange: e => this.setState({
        editTitle: e.target.value
      })
    }), /*#__PURE__*/React.createElement("textarea", {
      value: this.state.editBody,
      rows: 8,
      "aria-label": "Text",
      onChange: e => this.setState({
        editBody: e.target.value
      })
    }), /*#__PURE__*/React.createElement("div", {
      className: "a"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "pd-primary sm",
      onClick: this.saveEdit
    }, "Save"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "pd-ghost sm",
      onClick: () => this.setState({
        editVariant: null
      })
    }, "Cancel"))) : /*#__PURE__*/React.createElement(React.Fragment, null, pick.title && /*#__PURE__*/React.createElement("p", {
      className: "pd-vtitle"
    }, pick.title), /*#__PURE__*/React.createElement("p", {
      className: "pd-text" + (longBody && !bodyOpen ? " clamp" : "")
    }, pick.body || "No text yet."), vStatus === "published" && /*#__PURE__*/React.createElement("span", {
      className: "pd-quiet"
    }, "Published text cannot be edited here. Make a new version to change it."))), /*#__PURE__*/React.createElement("section", {
      className: "pd-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pd-cardh"
    }, /*#__PURE__*/React.createElement("b", null, "Images and video"), /*#__PURE__*/React.createElement("span", {
      className: "pd-cardacts"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "pd-linkbtn" + (this.state.addOpen ? " on" : ""),
      onClick: () => this.setState({
        addOpen: !this.state.addOpen
      })
    }, this.state.addOpen ? "Close" : "Add text or a link"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "pd-btn sm",
      onClick: () => this.setState({
        pdPick: []
      })
    }, "Add from Assets"))), tiles.length ? /*#__PURE__*/React.createElement("div", {
      className: "pd-thumbs"
    }, (tiles.some(m => !cdnExpired(m.url)) ? tiles.filter(m => !cdnExpired(m.url)) : tiles).map(m => {
      const isSel = shownMedia && shownMedia.url === m.url;
      const src = m.kind === "video" ? m.poster : m.url;
      const dead = cdnExpired(m.url);
      return /*#__PURE__*/React.createElement("span", {
        key: m.url,
        className: "pd-thumb" + (isSel ? " on" : "") + (dead ? " dead" : "")
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "pic",
        title: dead ? "This picture link has expired" : m.src === "social" ? "The picture on the post (opens the post)" : m.id ? `Open in the ${m.kind === "video" ? "clip" : "image"} editor` : "Edit this picture",
        disabled: dead,
        onClick: () => openTile(m)
      }, dead ? /*#__PURE__*/React.createElement("span", {
        className: "dead-t"
      }, "Link expired") : src ? /*#__PURE__*/React.createElement("img", {
        src: src,
        alt: m.title || "",
        loading: "lazy",
        onError: e => {
          const el = e.currentTarget;
          el.style.display = "none";
          if (el.parentNode) el.parentNode.classList.add("broken");
        }
      }) : /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, m.kind === "video" ? "movie" : "image"), m.kind === "video" && !dead && /*#__PURE__*/React.createElement("span", {
        className: "lb-play sm"
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "play_arrow"))), (m.src === "asset" || m.src === "block" || dead) && m.src !== "social" && m.src !== "ad" && (this.state.pdRemove === m.url ? /*#__PURE__*/React.createElement("span", {
        className: "pd-rm-ask",
        role: "group",
        "aria-label": "Remove from this piece"
      }, /*#__PURE__*/React.createElement("span", {
        title: "Remove from this piece? It stays in Assets."
      }, "Remove?"), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "yes",
        disabled: this.state.pdRemoveBusy,
        onClick: () => this.removePieceMedia(m)
      }, this.state.pdRemoveBusy ? "Removing…" : "Remove"), /*#__PURE__*/React.createElement("button", {
        type: "button",
        disabled: this.state.pdRemoveBusy,
        onClick: () => this.setState({
          pdRemove: null
        })
      }, "Keep")) : /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "pd-rm",
        "aria-label": "Remove from this piece",
        title: "Remove from this piece (it stays in Assets)",
        onClick: () => this.setState({
          pdRemove: m.url
        })
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "close"))), !dead && m.kind === "image" && canShopify && m.src !== "social" && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "shop",
        title: "Add this picture to the linked product in Shopify, with its alt text",
        onClick: () => this.addImageToShopify(m.url)
      }, "Add to Shopify"), !dead && m.kind === "video" && m.src === "block" && !hasTranscript && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "shop",
        disabled: this.state.transcribeBusy,
        title: "Turn what is said into text, so it can be reused and found",
        onClick: () => this.transcribe(m.url)
      }, this.state.transcribeBusy ? "Asking…" : "Transcribe"));
    })) : /*#__PURE__*/React.createElement("p", {
      className: "pd-quiet"
    }, "No pictures or video yet."), /*#__PURE__*/React.createElement("span", {
      className: "pd-quiet"
    }, "Shared by every channel version of this piece. Click one to open it in the editor."), this.state.addOpen && (() => {
      const tab = this.state.addTab;
      const tabs = [["paste", "Paste text"], ["page", "Copy a web page"], ["image", "Picture link"], ["doc", "Document link"], ["video", "Video link"]];
      return /*#__PURE__*/React.createElement("div", {
        className: "pd-add"
      }, /*#__PURE__*/React.createElement("div", {
        className: "pd-seg sm",
        role: "group",
        "aria-label": "What to add"
      }, tabs.map(([k, l]) => /*#__PURE__*/React.createElement("button", {
        type: "button",
        key: k,
        className: tab === k ? "on" : "",
        onClick: () => this.setState({
          addTab: k
        })
      }, l))), tab === "paste" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("textarea", {
        value: this.state.addBlockText,
        placeholder: "Paste or write the text this piece is based on: a product story, an announcement, an article\u2026",
        "aria-label": "Text",
        onChange: e => this.setState({
          addBlockText: e.target.value
        }),
        rows: 5
      }), /*#__PURE__*/React.createElement("div", {
        className: "a"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "pd-primary sm",
        disabled: this.state.addBusy || !this.state.addBlockText.trim(),
        onClick: this.addBlock
      }, this.state.addBusy ? "Adding…" : "Add text"))), tab === "page" && /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("input", {
        value: this.state.importUrl,
        placeholder: "https://\u2026 the page whose text you want to reuse",
        "aria-label": "Page address",
        onChange: e => this.setState({
          importUrl: e.target.value
        })
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "pd-primary sm",
        disabled: this.state.addBusy || !this.state.importUrl.trim(),
        onClick: this.importPage
      }, this.state.addBusy ? "Copying…" : "Copy page")), tab === "image" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("input", {
        value: this.state.addImageUrl,
        placeholder: "https://\u2026 a picture's address",
        "aria-label": "Picture address",
        onChange: e => this.setState({
          addImageUrl: e.target.value
        })
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "pd-primary sm",
        disabled: this.state.addBusy || !this.state.addImageUrl.trim(),
        onClick: () => this.addAsset("addImageUrl", "image_ref", "Picture")
      }, "Add picture")), /*#__PURE__*/React.createElement("p", {
        className: "pd-quiet"
      }, "Everything you have made or uploaded is in ", /*#__PURE__*/React.createElement("a", {
        href: "#",
        onClick: e => {
          e.preventDefault();
          this.setState({
            tab: "assets",
            detail: null
          });
        }
      }, "Assets"), ". Copy a picture's address from there, or make one in the Builder.")), tab === "doc" && /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("input", {
        value: this.state.addDocUrl,
        placeholder: "https://\u2026 a PDF, spec sheet or document",
        "aria-label": "Document address",
        onChange: e => this.setState({
          addDocUrl: e.target.value
        })
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "pd-primary sm",
        disabled: this.state.addBusy || !this.state.addDocUrl.trim(),
        onClick: () => this.addAsset("addDocUrl", "link", "Document link")
      }, "Add link")), tab === "video" && /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("input", {
        value: this.state.addVideoUrl || "",
        placeholder: "https://\u2026 a video (mp4 or YouTube). Plunk writes down what is said.",
        "aria-label": "Video address",
        onChange: e => this.setState({
          addVideoUrl: e.target.value
        })
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "pd-primary sm",
        disabled: this.state.transcribeBusy || !(this.state.addVideoUrl || "").trim(),
        onClick: () => this.transcribe(this.state.addVideoUrl)
      }, this.state.transcribeBusy ? "Adding…" : "Add video")));
    })()))), (notes.length > 0 || g.link.length > 0 || storyboards.length > 0 || c.summary) && (() => {
      const open = !!this.state.pdNotesOpen;
      const count = notes.length + g.link.length + (c.summary ? 1 : 0);
      return /*#__PURE__*/React.createElement("section", {
        className: "pd-notes" + (open ? " open" : "")
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "pd-notes-h",
        "aria-expanded": open,
        onClick: () => this.setState({
          pdNotesOpen: !open
        })
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons",
        "aria-hidden": "true"
      }, open ? "expand_less" : "expand_more"), /*#__PURE__*/React.createElement("b", null, "Notes and source text"), /*#__PURE__*/React.createElement("span", null, count)), open && /*#__PURE__*/React.createElement("div", {
        className: "pd-notes-b"
      }, c.summary && /*#__PURE__*/React.createElement("div", {
        className: "pd-note-b"
      }, /*#__PURE__*/React.createElement("span", {
        className: "k"
      }, "Summary"), /*#__PURE__*/React.createElement("p", {
        className: "pd-text"
      }, c.summary)), storyboards.length > 0 && /*#__PURE__*/React.createElement("p", {
        className: "pd-quiet"
      }, "A video storyboard is saved (", sbScenes(storyboards[storyboards.length - 1]), " scenes). ", /*#__PURE__*/React.createElement("a", {
        href: "#",
        onClick: e => {
          e.preventDefault();
          this.openVideo();
        }
      }, "Open it in Make a video"), " to change it or render again."), notes.map(b => {
        const long = String(val(b) || "").length > 420;
        const bo = !!(this.state.blockOpen && this.state.blockOpen.has(String(b.id)));
        return /*#__PURE__*/React.createElement("div", {
          key: String(b.id),
          className: "pd-note-b"
        }, /*#__PURE__*/React.createElement("span", {
          className: "k"
        }, blockName(b.kind)), /*#__PURE__*/React.createElement("div", {
          className: "hub-det-clamp" + (long && !bo ? " on" : "")
        }, this.pdBlockBody(b)), long && /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "pd-more-link",
          onClick: () => {
            const s = new Set(this.state.blockOpen || []);
            if (bo) s.delete(String(b.id));else s.add(String(b.id));
            this.setState({
              blockOpen: s
            });
          }
        }, bo ? "Show less" : "Show all"));
      }), g.link.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "pd-note-b"
      }, /*#__PURE__*/React.createElement("span", {
        className: "k"
      }, "Links and documents"), g.link.map(b => /*#__PURE__*/React.createElement("a", {
        key: String(b.id),
        className: "pd-doc",
        href: val(b),
        target: "_blank",
        rel: "noreferrer"
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons",
        "aria-hidden": "true"
      }, "description"), fileLabel(val(b)), " \u2197")))));
    })()), /*#__PURE__*/React.createElement("aside", {
      className: "pd-rail"
    }, /*#__PURE__*/React.createElement("section", {
      className: "pd-sec"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pd-sech"
    }, /*#__PURE__*/React.createElement("b", null, "Results"), /*#__PURE__*/React.createElement("span", null, rangeLabelFor(detail.funnelRange || this.range(), RANGES))), f ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "pd-tiles"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, num(f.impressions)), /*#__PURE__*/React.createElement("span", null, "Views")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, num(f.clicks)), /*#__PURE__*/React.createElement("span", null, "Clicks")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, num(f.sessions)), /*#__PURE__*/React.createElement("span", null, "Site visits")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, n(f.salesValue) > 0 ? usd(f.salesValue) : "$0"), /*#__PURE__*/React.createElement("span", null, "Sales"))), (n(f.reach) > 0 || n(f.conversions) > 0 || n(f.orders) > 0) && /*#__PURE__*/React.createElement("span", {
      className: "pd-quiet"
    }, [n(f.reach) > 0 ? `${num(f.reach)} people reached` : null, n(f.conversions) > 0 ? `${num(f.conversions)} conversions` : null, n(f.orders) > 0 ? `${num(f.orders)} orders` : null].filter(Boolean).join(" · ")), !sameRange && /*#__PURE__*/React.createElement("span", {
      className: "pd-quiet"
    }, "Showing all time: this piece went out before the dates picked at the top."), (f.variants || []).length > 0 && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "pd-link",
      "aria-expanded": !!this.state.pdByChannel,
      onClick: () => this.setState({
        pdByChannel: !this.state.pdByChannel
      })
    }, this.state.pdByChannel ? "Hide results by channel" : "See results by channel"), this.state.pdByChannel && /*#__PURE__*/React.createElement("div", {
      className: "pd-bych"
    }, f.variants.map(x => {
      const parts = [n(x.impressions) > 0 ? `${num(x.impressions)} views` : null, `${num(x.clicks)} clicks`, n(x.sessions) > 0 ? `${num(x.sessions)} visits` : null, n(x.conversions) > 0 ? `${num(x.conversions)} conversions` : null, n(x.salesValue) > 0 ? `${usd(x.salesValue)} sales` : null].filter(Boolean);
      return /*#__PURE__*/React.createElement("div", {
        key: String(x.variantId),
        className: "r"
      }, /*#__PURE__*/React.createElement("b", null, chName(x.channel) || "Version", x.title ? /*#__PURE__*/React.createElement("i", null, " \xB7 ", x.title) : null), /*#__PURE__*/React.createElement("span", null, parts.join(" · ")));
    }), /*#__PURE__*/React.createElement("span", {
      className: "pd-quiet"
    }, "Counted from tagged links and where visitors came from."))) : /*#__PURE__*/React.createElement("span", {
      className: "pd-quiet"
    }, "No results yet.")), /*#__PURE__*/React.createElement("section", {
      className: "pd-sec"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pd-sech"
    }, /*#__PURE__*/React.createElement("b", null, "Where it's live"), pubs.length > 0 && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "pd-link",
      onClick: () => this.setState({
        pdManageLive: !this.state.pdManageLive
      })
    }, this.state.pdManageLive ? "Done" : "Manage")), !pubs.length ? /*#__PURE__*/React.createElement("span", {
      className: "pd-quiet"
    }, "Not published anywhere yet. Use Publish at the top when a version is ready.") : this.state.pdManageLive ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "pd-quiet"
    }, imported ? "Plunk brought these in from where they were posted, so they are managed there." : "Update sends the current text to the same place. Remove takes it down where the network allows."), /*#__PURE__*/React.createElement(ShippedList, {
      items: shipItems,
      compact: true,
      readOnly: imported,
      shop: this.state.shopify && this.state.shopify.shop || "",
      pieceLabel: v => chName(v && v.channel),
      onChanged: () => this.reloadDetail(),
      onAgain: (pub, v, how) => {
        const t = String(pub.target || "").toLowerCase();
        this.publishTo(v, t === "plunk_campaign" ? "email_draft" : t, detail, {
          republish: how === "update",
          externalId: how === "update" ? pub.externalId : undefined
        });
      }
    })) : /*#__PURE__*/React.createElement("div", {
      className: "pd-live"
    }, pubs.slice().sort((a, b) => isLive(b) - isLive(a)).map(p => {
      const t = String(p.target || "").toLowerCase();
      const what = (targetName(t).split(" · ")[1] || "").toLowerCase();
      const st = String(p.status || "").toLowerCase();
      return /*#__PURE__*/React.createElement("div", {
        key: String(p.id),
        className: "r" + (isLive(p) ? "" : " off")
      }, /*#__PURE__*/React.createElement("span", {
        className: "t"
      }, /*#__PURE__*/React.createElement("b", null, chName(t) || chName((variants.find(v => String(v.id) === String(p.variantId)) || {}).channel) || targetName(t)), /*#__PURE__*/React.createElement("span", null, what ? ` · ${what}` : "", fmtDay(p.publishedDate || p.createdDate) ? ` · ${fmtDay(p.publishedDate || p.createdDate)}` : "", !isLive(p) ? ` · ${st === "failed" ? "did not go out" : "taken down"}` : st === "removing" ? " · being removed" : st === "private" ? " · private" : "")), p.url && isLive(p) && /*#__PURE__*/React.createElement("a", {
        href: p.url,
        target: "_blank",
        rel: "noreferrer"
      }, "Open \u2197"));
    }))), /*#__PURE__*/React.createElement("section", {
      className: "pd-sec"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pd-sech"
    }, /*#__PURE__*/React.createElement("b", null, "Tags")), this.pieceTagRow(row, false, "lb-ctags pd-tagrow")), /*#__PURE__*/React.createElement("section", {
      className: "pd-sec"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pd-sech"
    }, /*#__PURE__*/React.createElement("b", null, "Who it's for")), /*#__PURE__*/React.createElement("span", {
      className: "pd-quiet"
    }, "The stages of your customers this piece speaks to. Used when Plunk suggests content."), /*#__PURE__*/React.createElement("div", {
      className: "pd-stages",
      role: "group",
      "aria-label": "Who it's for"
    }, STAGES.map(([k]) => /*#__PURE__*/React.createElement("button", {
      type: "button",
      key: k,
      className: stageOn(k) ? "on" : "",
      "aria-pressed": stageOn(k),
      onClick: () => this.toggleDetailStage(k)
    }, STAGE_NAMES[k])))), (c.campaign || (detail.automations || []).length > 0) && /*#__PURE__*/React.createElement("section", {
      className: "pd-sec"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pd-sech"
    }, /*#__PURE__*/React.createElement("b", null, "Part of")), c.campaign && /*#__PURE__*/React.createElement("a", {
      href: "#",
      className: "pd-partof",
      onClick: e => {
        e.preventDefault();
        this.setState({
          detail: null
        }, () => this.openCampaign(c.campaign));
      }
    }, "The ", c.campaign, " campaign", f && (n(f.conversions) > 0 || n(f.salesValue) > 0) ? /*#__PURE__*/React.createElement("span", null, " \xB7 drove ", n(f.conversions) > 0 ? `${num(f.conversions)} conversions` : "visits", n(f.salesValue) > 0 ? ` and ${usd(f.salesValue)}` : "") : null), (detail.automations || []).map(a => /*#__PURE__*/React.createElement("a", {
      key: String(a.id),
      href: "#",
      className: "pd-partof",
      onClick: e => {
        e.preventDefault();
        window.location.assign(`#/Email/journeys?q=${encodeURIComponent(a.name || "")}`);
      }
    }, "The ", a.name, " email journey"))), /*#__PURE__*/React.createElement("section", {
      className: "pd-sec"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pd-sech"
    }, /*#__PURE__*/React.createElement("b", null, "Found by AI assistants"), vis && vis.topic && !this.state.pdTopicEdit && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "pd-link",
      onClick: () => this.setState({
        pdTopicEdit: true,
        topicDraft: vis.topic
      })
    }, "Change topic")), !vis ? /*#__PURE__*/React.createElement("span", {
      className: "pd-quiet"
    }, "Not available for this piece.") : !vis.topic || this.state.pdTopicEdit ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "pd-quiet"
    }, "Add a topic to see whether tools like ChatGPT mention you when people ask about it."), /*#__PURE__*/React.createElement("div", {
      className: "pd-topic"
    }, /*#__PURE__*/React.createElement("input", {
      value: this.state.topicDraft,
      placeholder: "e.g. what this piece is about",
      "aria-label": "Topic",
      onChange: e => this.setState({
        topicDraft: e.target.value
      }),
      onKeyDown: e => {
        if (e.key === "Enter") {
          this.setTopic();
          this.setState({
            pdTopicEdit: false
          });
        }
      }
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "pd-btn sm",
      disabled: this.state.topicBusy || !this.state.topicDraft.trim(),
      onClick: () => {
        this.setTopic();
        this.setState({
          pdTopicEdit: false
        });
      }
    }, this.state.topicBusy ? "Saving…" : "Track"))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "pd-quiet"
    }, "How often assistants like ChatGPT mention and link to you when people ask about ", /*#__PURE__*/React.createElement("b", null, vis.topic), ", over the last 60 days."), /*#__PURE__*/React.createElement("div", {
      className: "pd-tiles sm"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, Number(vis.visibilityScore || 0).toFixed(0), "%"), /*#__PURE__*/React.createElement("span", null, "Mentioned")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, Number(vis.citationRate || 0).toFixed(0), "%"), /*#__PURE__*/React.createElement("span", null, "Linked to you")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, Number(vis.ownedShare || 0).toFixed(0), "%"), /*#__PURE__*/React.createElement("span", null, "Your share of links", Number(vis.ownedShareDelta) ? `, ${Number(vis.ownedShareDelta) > 0 ? "up" : "down"} ${Math.abs(Number(vis.ownedShareDelta)).toFixed(0)}` : "")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, num(vis.aiReferredSessions)), /*#__PURE__*/React.createElement("span", null, "Visits from assistants"))), /*#__PURE__*/React.createElement("a", {
      href: "#/AiVisibility",
      className: "pd-link"
    }, "See every question checked (", num(vis.checks), ")"))))), this.state.tplSheet && /*#__PURE__*/React.createElement(TemplateSheet, {
      variantId: this.state.tplSheet.variantId,
      channel: this.state.tplSheet.channel,
      storyId: c.storyId ? String(c.storyId) : null,
      onClose: () => this.setState({
        tplSheet: null
      })
    }), Array.isArray(this.state.pdPick) && /*#__PURE__*/React.createElement("div", {
      className: "pd-pick-back",
      onMouseDown: e => {
        if (e.target === e.currentTarget && !this.state.pdPickBusy) this.setState({
          pdPick: null
        });
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "pd-pick",
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": "pd-pick-t"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pd-pick-h"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
      id: "pd-pick-t"
    }, "Add pictures and video"), /*#__PURE__*/React.createElement("span", null, "Pick from Assets or upload new ones. They are added to this piece for every channel.")), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "pd-x",
      "aria-label": "Close",
      disabled: this.state.pdPickBusy,
      onClick: () => this.setState({
        pdPick: null
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "close"))), /*#__PURE__*/React.createElement("div", {
      className: "pd-pick-b"
    }, /*#__PURE__*/React.createElement(AssetPicker, {
      accept: "any",
      only: ["product", "image", "render", "clip", "recording"],
      max: 20,
      picks: this.state.pdPick,
      disabled: this.state.pdPickBusy,
      exclude: (detail && detail.assets || []).map(a => String(a.id)),
      onChange: ids => this.setState({
        pdPick: ids
      })
    })), /*#__PURE__*/React.createElement("div", {
      className: "pd-pick-f"
    }, /*#__PURE__*/React.createElement("span", null, this.state.pdPick.length ? `${this.state.pdPick.length} picked` : "Click to pick, click again to drop."), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "pd-btn",
      disabled: this.state.pdPickBusy,
      onClick: () => this.setState({
        pdPick: null
      })
    }, "Cancel"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "pd-primary",
      disabled: this.state.pdPickBusy || !this.state.pdPick.length,
      onClick: this.addPicked
    }, this.state.pdPickBusy ? "Adding…" : this.state.pdPick.length > 1 ? `Add ${this.state.pdPick.length} to this piece` : "Add to this piece")))), (() => {
      const se = this.state.srcEdit;
      if (!se) return null;
      const close = () => this.setState({
        srcEdit: null
      });
      if (se.kind === "edit") return /*#__PURE__*/React.createElement(EditModeModal, {
        asset: se.url,
        runAgent: this.runAgent,
        waitAgent: this.waitAgent,
        creditsToast: this.creditsToast,
        onSaved: v => this.srcSaved(v, "image"),
        onClose: close
      });
      if (se.kind === "resize") return /*#__PURE__*/React.createElement(SmartResizeModal, {
        asset: se.url,
        runAgent: this.runAgent,
        waitAgent: this.waitAgent,
        creditsToast: this.creditsToast,
        onSaved: v => this.srcSaved(v, "image"),
        onClose: close
      });
      if (se.kind === "vedit") return /*#__PURE__*/React.createElement(VideoEditModal, {
        asset: se.url,
        onSaved: v => this.srcSaved(v, "video"),
        onClose: close
      });
      if (se.kind === "trim") return /*#__PURE__*/React.createElement(TrimModal, {
        asset: se.url,
        onSaved: v => this.srcSaved(v, "video"),
        onClose: close
      });
      if (se.kind === "vresize") return /*#__PURE__*/React.createElement(VideoResizeModal, {
        asset: se.url,
        onSaved: v => this.srcSaved(v, "video"),
        onClose: close
      });
      return null;
    })());
  }
  recCopy(r) {
    const raw = String(r.title || "");
    const name = x => cleanTitle(String(x || "").replace(/^"+|"+$/g, ""));
    const n0 = v => Number(String(v).replace(/,/g, ""));
    const money = v => `$${n0(v).toLocaleString(undefined, {
      maximumFractionDigits: 0
    })}`;
    const x = recRef(r);
    if (x.type === "hygiene") {
      const plain = REC_RULE_PLAIN[x.rule];
      const what = RULE_NAMES[x.rule] || String(x.rule).replace(/[-_]/g, " ");
      const n = x.count;
      const title = n === 1 ? `1 place on your site needs a fix: ${what}` : plain ? `${n != null ? num(n) : "Some"} places on your site ${plain[0]}` : `${n != null ? num(n) : "Some"} places on your site need a fix: ${what}`;
      const why = plain ? plain[1] : x.kind === "ada" ? `${what.charAt(0).toUpperCase() + what.slice(1)}. Fixing these makes your site easier to use for everyone, including people using screen readers.` : `${what.charAt(0).toUpperCase() + what.slice(1)}. Fixing these helps people find you in search.`;
      return {
        title,
        why
      };
    }
    if (x.type === "stage") {
      const st = REC_STAGE_PLAIN[x.stage] || [STAGE_PLURAL[x.stage] || x.stage, `people at the ${x.stage} stage`];
      return {
        title: `Nothing speaks to ${st[0]} yet`,
        why: `No piece is tagged for ${st[1]}`
      };
    }
    let m = raw.match(/^"?(.+?)"? is fading: (\w+) fell ([\d.]+)%/i);
    if (m || String(r.class) === "refresh") {
      const piece = this.recPiece(r);
      const row = piece ? (this.state.recDecay || {})[String(piece.id)] : null;
      const metric = row && row.metric || m && m[2] || "sessions";
      const unit = /engage/i.test(metric) ? ["interaction", "interactions"] : ["visit", "visits"];
      const u = k => `${num(k)} ${k === 1 ? unit[0] : unit[1]}`;
      const title0 = name(m ? m[1] : piece && piece.title || cleanTitle(raw));
      const pct = row && Number(row.previous) > 0 ? 100 * (Number(row.previous) - Number(row.current)) / Number(row.previous) : m ? Number(m[3]) : null;
      const none = row ? Number(row.current) === 0 : pct != null && pct >= 99.95;
      const title = none ? `${title0} had no ${unit[1]} this month` : pct != null ? `${title0} lost ${recShare(pct)} of its ${unit[1]}` : `${title0} is getting fewer ${unit[1]}`;
      const why = row ? none ? `${u(Number(row.previous))} last month` : `${u(Number(row.current))}, down from ${num(Number(row.previous))}` : pct != null ? `${unit[1].charAt(0).toUpperCase() + unit[1].slice(1)} fell ${Math.round(pct)}% compared with the month before` : "";
      return {
        title,
        why,
        piece
      };
    }
    m = raw.match(/^(.*): top seller — no linked content \(([\d,.]+) revenue, (\d+)d\)/i);
    if (m) return {
      title: `Nothing written about ${name(m[1])}`,
      why: `One of your top sellers: ${money(m[2])} in the last ${m[3]} days`
    };
    m = raw.match(/^(.*): high traffic — no linked content \(([\d,.]+) views, last quarter\)/i);
    if (m) return {
      title: `Nothing written about ${name(m[1])}`,
      why: `Popular with visitors: ${num(n0(m[2]))} views last quarter`
    };
    m = raw.match(/^(.*): AI answers mention competitors (\d+)x on this topic/i);
    if (m) return {
      title: `Nothing written about ${name(m[1])}`,
      why: `AI assistants named other brands ${num(n0(m[2]))} times on this in the last 30 days and did not link to you`
    };
    m = raw.match(/AI engines rarely mention you on "(.+?)" \((\d+)% visibility\)/i);
    if (m) return {
      title: `AI assistants rarely mention you for ${name(m[1])}`,
      why: `You came up in ${m[2]}% of the answers checked in the last 60 days, while other brands were named`
    };
    m = raw.match(/^"?(.+?)"? had ([\d,]+) views this month but only (\d+) characters of description/i);
    if (m) return {
      title: `${name(m[1])} needs a fuller description`,
      why: `${num(n0(m[2]))} views this month, ${Number(m[3]) === 0 ? "and no description yet" : `but only ${m[3]} characters of description`}`
    };
    m = raw.match(/^"?(.+?)"? earned (.+?) \(28d\) from a single channel/i);
    if (m) {
      const e = m[2];
      let why = "";
      let k = e.match(/^([\d,.]+) in attributed sales/i);
      if (k) why = `${money(k[1])} in sales in the last 4 weeks, all from one channel`;
      k = e.match(/^([\d,]+) sessions/i);
      if (k) why = `${num(n0(k[1]))} visits in the last 4 weeks, all from one channel`;
      k = e.match(/^([\d,]+) engagements/i);
      if (k) why = `${num(n0(k[1]))} interactions in the last 4 weeks, all from one channel`;
      return {
        title: `${name(m[1])} is doing well on one channel`,
        why
      };
    }
    return {
      title: cleanTitle(raw).replace(/\s+—\s+/g, ": "),
      why: r.detail ? cleanTitle(r.detail).replace(/\s+—\s+/g, ": ") : ""
    };
  }
  renderRecs(allRecs) {
    if (this.state.recsLoaded === false) return /*#__PURE__*/React.createElement("p", {
      className: "territory-hint"
    }, "Loading suggestions\u2026");
    if (!allRecs.length) return /*#__PURE__*/React.createElement("div", {
      className: "rec-view"
    }, /*#__PURE__*/React.createElement("div", {
      className: "rec-empty"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      "aria-hidden": "true"
    }, "task_alt"), /*#__PURE__*/React.createElement("b", null, "Nothing to do right now."), /*#__PURE__*/React.createElement("span", null, "New suggestions arrive every week.")));
    const {
      recBusy
    } = this.state;
    const groupOf = r => recGroup(r);
    const keys = [];
    REC_GROUPS.forEach(([k]) => {
      if (allRecs.some(r => groupOf(r) === k)) keys.push(k);
    });
    allRecs.forEach(r => {
      const k = groupOf(r);
      if (!keys.includes(k)) keys.push(k);
    });
    const meta = k => {
      const g = REC_GROUPS.find(x => x[0] === k);
      if (g) return g;
      const t = k.replace(/_/g, " ");
      return [k, t.charAt(0).toUpperCase() + t.slice(1), ""];
    };
    const filter = keys.includes(this.state.recClassFilter) ? this.state.recClassFilter : "";
    const count = k => allRecs.filter(r => groupOf(r) === k).length;
    const byScore = (a, b) => (Number(b.score) || 0) - (Number(a.score) || 0);
    const places = this.state.recPlaces || {};
    const row = this.renderRecRow;
    return /*#__PURE__*/React.createElement("div", {
      className: "rec-view"
    }, /*#__PURE__*/React.createElement("div", {
      className: "rec-bar"
    }, /*#__PURE__*/React.createElement("div", {
      className: "rec-pills",
      role: "group",
      "aria-label": "Show"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: !filter ? "on" : "",
      "aria-pressed": !filter,
      onClick: () => this.setState({
        recClassFilter: ""
      })
    }, "All ", /*#__PURE__*/React.createElement("i", null, allRecs.length)), keys.map(k => /*#__PURE__*/React.createElement("button", {
      type: "button",
      key: k,
      className: filter === k ? "on" : "",
      "aria-pressed": filter === k,
      onClick: () => this.setState({
        recClassFilter: k
      })
    }, meta(k)[1], " ", /*#__PURE__*/React.createElement("i", null, count(k))))), /*#__PURE__*/React.createElement("span", {
      className: "rec-sp"
    }), /*#__PURE__*/React.createElement("span", {
      className: "rec-hint"
    }, "Most valuable first. Updated every week.")), (filter ? [filter] : keys).map(k => {
      const [, label, sub] = meta(k);
      const list = allRecs.filter(r => groupOf(r) === k).sort(byScore);
      return /*#__PURE__*/React.createElement("section", {
        key: k,
        className: "rec-group",
        "aria-label": label
      }, /*#__PURE__*/React.createElement("div", {
        className: "rec-gh"
      }, /*#__PURE__*/React.createElement("b", null, label), sub && /*#__PURE__*/React.createElement("span", null, sub)), list.map(row));
    }));
  }
  render() {
    const {
      data,
      error,
      tab,
      detail,
      detailLoading
    } = this.state;
    if (error) return /*#__PURE__*/React.createElement(Error, null);
    if (!data) return /*#__PURE__*/React.createElement(Loader, null);
    const range = this.range();
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view wa-view content-view"
    }, this.renderStagePick(), /*#__PURE__*/React.createElement(PageHeader, {
      title: "Content Hub",
      subtitle: `${rangeLabelFor(range, RANGES)} · every piece of content, its channels and what it drove · imports sync nightly`,
      chips: [],
      actions: /*#__PURE__*/React.createElement("button", {
        className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
        onClick: () => this.props.history.push("/Content/build/new")
      }, "New story")
    }), this.state.createOpen && /*#__PURE__*/React.createElement("div", {
      className: "wa-modal-backdrop hub-edit-backdrop",
      onClick: () => this.setState({
        createOpen: false
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-trash-sheet hub-sched",
      onClick: e => e.stopPropagation()
    }, /*#__PURE__*/React.createElement("h3", {
      className: "hub-h3",
      style: {
        marginBottom: 2
      }
    }, "New piece"), /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: "0 0 14px"
      }
    }, "A working home for one piece of content. Add source blocks, then make channel variants in the Builder."), /*#__PURE__*/React.createElement("label", null, "Title", /*#__PURE__*/React.createElement("input", {
      value: this.state.createTitle,
      placeholder: "e.g. Fall collection launch",
      autoFocus: true,
      onChange: e => this.setState({
        createTitle: e.target.value
      }),
      style: {
        ...INPUT,
        height: "34px",
        padding: "0 10px",
        marginTop: "4px"
      }
    })), /*#__PURE__*/React.createElement("label", null, "Topic ", /*#__PURE__*/React.createElement("i", {
      style: {
        fontStyle: "normal",
        fontWeight: 500,
        letterSpacing: 0,
        textTransform: "none"
      }
    }, "optional, used for AI visibility"), /*#__PURE__*/React.createElement("input", {
      value: this.state.createTopic,
      placeholder: "e.g. sectional sofas",
      onChange: e => this.setState({
        createTopic: e.target.value
      }),
      style: {
        ...INPUT,
        height: "34px",
        padding: "0 10px",
        marginTop: "4px"
      }
    })), /*#__PURE__*/React.createElement("label", null, "Summary ", /*#__PURE__*/React.createElement("i", {
      style: {
        fontStyle: "normal",
        fontWeight: 500,
        letterSpacing: 0,
        textTransform: "none"
      }
    }, "optional"), /*#__PURE__*/React.createElement("textarea", {
      value: this.state.createSummary,
      rows: 3,
      placeholder: "One or two lines on what this piece is for",
      onChange: e => this.setState({
        createSummary: e.target.value
      }),
      style: {
        ...INPUT,
        marginTop: "4px",
        resize: "vertical"
      }
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "flex-end",
        gap: 8,
        marginTop: 18
      }
    }, /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle",
      style: {
        margin: 0
      },
      onClick: () => this.setState({
        createOpen: false
      })
    }, "Cancel"), /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
      disabled: this.state.createBusy || !(this.state.createTitle || "").trim(),
      onClick: this.createContainer
    }, this.state.createBusy ? "Creating…" : "Create")))), detailLoading ? /*#__PURE__*/React.createElement(Loader, null) : detail ? this.renderDetail() : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("nav", {
      className: "wa-switch",
      "aria-label": "Content Hub views"
    }, [["overview", "Overview"], ["library", `Library (${data.containers.length}${this.state.dataComplete === false ? "+" : ""})`], ["stories", "Stories"], ["assets", this.state.assets && this.state.assetKind !== "trash" && this.state.assetKind !== "sequences" ? `Assets (${this.state.assets.filter(a => a && !a.parentAssetId).length})` : "Assets"], ["calendar", "Calendar"], ["recommendations", this.state.recsLoaded ? `Recommendations (${data.recs.length})` : "Recommendations"]].concat(this.state.teamOn ? [["mywork", "My work"]] : []).map(([k, label]) => /*#__PURE__*/React.createElement("a", {
      key: k,
      className: "wa-tab" + (tab === k ? " on" : ""),
      style: {
        cursor: "pointer"
      },
      onClick: () => {
        this.setState({
          tab: k,
          search: ""
        });
        if (k === "campaigns" && this.state.camp === undefined) this.loadCampaigns();
        if (k === "assets" && this.state.assets === undefined) this.loadAssets();
        if (k === "calendar" && this.state.cal === undefined) this.loadCalendar();
      }
    }, label))), /*#__PURE__*/React.createElement(CssContainer, {
      cls: "margin-squeeze"
    }, tab === "overview" ? this.renderOverview() : tab === "library" ? this.renderLibrary(data.containers) : tab === "stories" ? this.renderStories(data.containers) : tab === "assets" ? this.renderAssets() : tab === "calendar" ? this.renderCalendar(data.containers) : tab === "mywork" ? /*#__PURE__*/React.createElement(MyWork, {
      history: this.props.history
    }) : tab === "campaigns" ? this.state.campDetail ? this.renderCampaignDetail() : this.renderOverview() : this.renderRecs(data.recs))));
  }
}
export const ContentHubViewComponent = withRouter(ContentHubComponent);
export default {
  ContentHubViewComponent
};